
var mPreviousSettings = [],
    mCurrentHash = null,
    mMasterOverheadHeight = null,
    mCache = null,
    mArchivedFlag = 'N',
    mStateManager = null,
    mEnabledSuperOri = 0,
    mParentOri,
    mCurrentSuperOri,
    mValidator,
    mCopyAddress = 0,
    mOrganizations,
    mChildCount = 0,
    gRequestManager = null,
    mCurrentRender = '',
    mActivityNotification,
    gObjectList = [],
    mRegexValidation = [],
    gUserDetails = null,
    gUserPermissions = [],
    gEnrolleeIds = [],
    gAgentUserIds = [],
    gMyAgentIds = [],
    mAppNotification = null,
    gUniversalDeviceIds = [],
    gDeviceIds = [],
    mSystemMessageCardView = null,
    uSystemMessageCell = null,
    mEnrolleeActiveChats = [],
    mEnrolleeActiveChat = null,
    gLastContact = [],
    gEnrolleeLastContact = [],
    gDeviceLastContact = [],
    gCurrentDeviceAssignment = [],
    gMapSettings = [],
    gMapFilterList = [],
    mInitialDataObjectsPending = 17,
    gAlcoholLastTest = [],
    mSystemDataObjectsPending = 50,
    gIsSystemCacheLoaded = false,
    gLoadScreenCounter = 1,
    gInitObjects = (mInitialDataObjectsPending + mSystemDataObjectsPending),
    gFilterFactory = null,
    gCacheSettings = new CacheSettings(),
    gPaginationSettings = new PaginationSettings(),
    gSystemSettings = new SystemSettings(),
    gSessionState = {},
    gItemsInited = [],
    gItemsComplete = [],
    gItemsNotComplete = [],
    gEnrolleeScheduleView,
    gPageClassManager = new PageClassManager(),
    gNonErrorBuilder = new SumoPredicateBuilder(),    
    //overflow requirement var
    overflowExists = false,
    gChangeOrganizationsListView,
    gAvailableOrganizationIds,
    gOnDemandEnrolleesListView,
    gOnDemandList,
    gOnDemandFilter,
    gOnDemandListCacheRefreshDataHolder,
    mAdvancedSearchAvailable = ["Enrollees", "Users"],
    mRegionalCutOff = 0,    
    gTreeControl = null;

if (isNullOrUndefined(veritracks.system)) {
    veritracks.system = {};
}
/**
 * setTimeout wrapper 
 * initialCacheItems_Init
 * @param {callback} aCallbackFunction 
 * @param {number} aInterval 
 */
//TODO: Move inside initialCacheItems_Init 
function setProcUpdateInterval(aCallbackFunction, aInterval) {
    window.setTimeout(function () {
        aCallbackFunction();
    }, aInterval);
}
/**
 * @callback 
 * Gets called by setProcUpdateInterval inside initialCacheItems_Init function 
 */
function getOffenderLastTestByUser() {
    GetOffenderAlcoholLastTest(gUserDetails.OrganizationIds.join(','), function (aParams, aData) {

        //gDashboardPage.setAlcoholData(aData);
        gAlcoholLastTest = aData;
        mInitialDataObjectsPending--;
        if (mInitialDataObjectsPending === 0) {
            cacheItemsInitial_OnComplete();
        }
    }, Sad);
}


/**
 * Checks If data contains Id & Version.
 * @param {*} aCache 
 * @param {*} aCurrentData 
 * @returns {boolean}
 */
function UpdateViewOnNewData(aCache, aCurrentData) {
    "use strict";
    var lCacheName = aCache.Name,
        lCurrentData = getArrayByIds(aCurrentData),
        lBuilder = new SumoPredicateBuilder(),
        lVersion = aCache.Version,
        lKey,
        lIsFound = false,
        lData;

    lBuilder.AddNewExpressionConditional('Id', lCurrentData, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('Version', lVersion, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());

    lData = query(getDataItems(lCacheName), lBuilder.RootExpression);

    if (ObjectLength(lData) > 0 || ObjectLength(aCurrentData) == 0) {
        lIsFound = true;
    }

    return lIsFound;
}
/**
 * 
 * @param {*} aCache 
 * @param {*} aCurrentData 
 * @param {*} aNoPagination 
 * @returns {Object} {IsFound:boolean,ReturnData:[]}
 */
function UpdateViewOnNewDataReturn(aCache, aCurrentData, aNoPagination) {
    "use strict";
    var lCacheName = aCache.Name,
    lCurrentData = getArrayByIds(aCurrentData),
    lBuilder = new SumoPredicateBuilder(),
    lVersion = aCache.Version,
    lKey,
    lIsFound = false,
    lData;

    if (!aNoPagination)
        lBuilder.AddNewExpressionConditional('Id', lCurrentData, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());

    lBuilder.AddNewExpressionConditional('Version', lVersion, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());

    lData = query(getDataItems(lCacheName), lBuilder.RootExpression);

    if (ObjectLength(lData) > 0) {
        lIsFound = true;
    }
    if (ObjectLength(aCurrentData) == 1 && lCacheName == 'EnrolleeLastContact') {
        lData = getDataItem(lCurrentData[0], lCacheName);
        var aCurrent;
        for (var lKey in aCurrentData) {
            if (aCurrentData.hasOwnProperty(lKey)) {
                aCurrent = aCurrentData[lKey];
            }
        }
        if (lData && aCurrent && lData.Version > aCurrent.LastContactVersion) {
            lIsFound = true;
        }
    }


    return { 'IsFound': lIsFound, 'ReturnData': lData };
}

/**
 * 
 * @param {*} aEnrolleeId 
 * @param {*} aTypeId 
 * @param {*} aDisplayId 
 * @param {*} aStartDate 
 * @param {*} aEndDate 
 */
function logUserTransactionRecordOnly(aEnrolleeId, aTypeId, aDisplayId, aStartDate, aEndDate) {
    var lUserTransaction = new UserTransaction();
    lUserTransaction.EnrolleeId = aEnrolleeId;    

    if (!isNullOrUndefined(aTypeId)) {
        lUserTransaction.TypeId = aTypeId;
    }
    if (!isNullOrUndefined(aDisplayId)) {
        lUserTransaction.DisplayId = aDisplayId;
    }

    lUserTransaction.TransactionStartDate = aStartDate;
    lUserTransaction.TransactionStopDate = aEndDate;

    function SingleTransaction_OnSuccess(aParams, aData) {
         /** @type {UserTransactionValue} */
        var lUserTransactionValue = new UserTransactionValue(),
            lUserTransactionValuesList = [];


        //CT_TRACKED_OFFENDER_ID 4411
        //lognumber logname
        //data type id = 2
        lUserTransactionValue.TransactionId = aData.Id;
        lUserTransactionValue.LogNumberName = 'CT_TRACKED_OFFENDER_ID';
        lUserTransactionValue.LogNumberValue = aEnrolleeId;
        lUserTransactionValue.LogDateValue = aStartDate;
        lUserTransactionValue.DataTypeId = 2;
        lUserTransactionValuesList.push(lUserTransactionValue);
        //write multiple
        WriteMultiple(lUserTransactionValuesList, null, null, null, true, true);
    }

    WriteSingle(lUserTransaction, SingleTransaction_OnSuccess, Sad, null, true);
}
/**
 * 
 * @param {number} aEnrolleeId 
 * @param {number} aTypeId 
 * @param {number} aDisplayId 
 * @param {*} aStartDate 
 * @param {*} aEndDate 
 * @param {*} aLastContactDate 
 * @param {*} aUserTransactionDateFlag 
 * @param {*} aTrackpointCount 
 * @returns {void}
 */
function logUserTransaction(aEnrolleeId, aTypeId, aDisplayId, aStartDate, aEndDate, aLastContactDate, aUserTransactionDateFlag, aTrackpointCount) {
    "use strict";

    var lUserTransaction = new UserTransaction();
    var ORIPropertyTrackReview = veritracks.enrollees.mapping.ORIFlag();
    if (ORIPropertyTrackReview == 'N') {
        // no track at all  return; 
        return;
    } else if (ORIPropertyTrackReview == 'R') {
        //  Recording  
        // only prevents to record when the Lock button is clicked
        var lLockData = veritracks.enrollees.mapping.getMapTimeLockTrackingState();
        if (!lLockData.lock && !lLockData.tracking || lLockData.lock && !lLockData.tracking) {
            return;
        }
    } else if (ORIPropertyTrackReview != 'Y') {
        // block anythng else
        return;
    }
    // Automatically ( no click control at ALL)

    function logUserTransaction_OnSuccess(aParams, aData) {
        "use strict";
        var lUserTransactionValue = new UserTransactionValue(),
            lUserTransactionValuesList = [];


        //CT_TRACKED_OFFENDER_ID 4411
        //lognumber logname
        //data type id = 2
        lUserTransactionValue.TransactionId = aData.Id;
        lUserTransactionValue.LogNumberName = 'CT_TRACKED_OFFENDER_ID';
        lUserTransactionValue.LogNumberValue = aEnrolleeId;
        lUserTransactionValue.DataTypeId = 2;
        lUserTransactionValuesList.push(lUserTransactionValue);

        //LAST_POSITION_DATE_LOCAL log date value
        //last contact date
        //data type id = 3
        lUserTransactionValue = new UserTransactionValue();
        lUserTransactionValue.TransactionId = aData.Id;
        lUserTransactionValue.LogDateName = 'LAST_POSITION_DATE_LOCAL';
        lUserTransactionValue.LogDateValue = aLastContactDate;
        lUserTransactionValue.DataTypeId = 3;
        lUserTransactionValuesList.push(lUserTransactionValue);

        //TRACK_START_DATE_LOCAL log date value
        //start date of time range
        //data type id = 3
        lUserTransactionValue = new UserTransactionValue();
        lUserTransactionValue.TransactionId = aData.Id;
        lUserTransactionValue.LogDateName = 'TRACK_START_DATE_LOCAL';
        lUserTransactionValue.LogDateValue = aStartDate;
        lUserTransactionValue.DataTypeId = 3;
        lUserTransactionValuesList.push(lUserTransactionValue);

        //TRACK_STOP_DATE_LOCAL log date value
        //stop date of time range
        //data type id = 3
        lUserTransactionValue = new UserTransactionValue();
        lUserTransactionValue.TransactionId = aData.Id;
        lUserTransactionValue.LogDateName = 'TRACK_STOP_DATE_LOCAL';
        if (aEndDate != null) {
            lUserTransactionValue.LogDateValue = aEndDate;
        } else {
            lUserTransactionValue.LogDateValue = aStartDate;
        }
        lUserTransactionValue.DataTypeId = 3;
        lUserTransactionValuesList.push(lUserTransactionValue);

        //write multiple
        WriteMultiple(lUserTransactionValuesList, null, null, null, true, true);
    }

    //lUserTransaction.UserId = gUserDetails.UserId;
    lUserTransaction.EnrolleeId = aEnrolleeId;
    if (!isNullOrUndefined(aTrackpointCount)) {
        lUserTransaction.TrackPointCount = aTrackpointCount;
    }
    

    if (!isNullOrUndefined(aTypeId)) {
        lUserTransaction.TypeId = aTypeId;
    }
    if (!isNullOrUndefined(aDisplayId)) {
        lUserTransaction.DisplayId = aDisplayId;
    }

    if (!isNullOrUndefined(aUserTransactionDateFlag) && aUserTransactionDateFlag) {
        lUserTransaction.TransactionStopDate = new Date(-1);
    }

    WriteSingle(lUserTransaction, logUserTransaction_OnSuccess, Sad, null, true);
}


/**
 * 
 * @param {Object} aParams 
 * @param {Object} aCacheItem 
 * @param {*} aThis @deprecated
 * @returns {void}
 */
function mCache_SystemMessageUpdated(aParams, aCacheItem, aThis) {
    "use strict";
    var lData = aCacheItem.Data;

    if (!isNullOrUndefined(mSystemMessageCardView)) {
        mSystemMessageCardView.setDataSource(lData);
    }
    $('#uHeaderSystemMessageCount').text(count(lData));
}
/**
 * 
 */
function createSystemMessageCardView() {
    "use strict";
    var lData = getDataItems('SystemMessage'),
            lOptions = {
                'cssClass': 'SystemMessage',
                'cardTemplate': 'Interface/Dashboard.Card.Template.htm',
                'templateType': 'uri',
                'selectMethod': 'none'
            };
    mSystemMessageCardView = new sumo.controls.CardView('uSystemMessageCardView', 'uSystemMessageListHolder', lOptions);
    mSystemMessageCardView.setDataSource(lData);
    uSystemMessageCell = $('#uSystemMessageListHolder');
    $('img.SystemMessage,span.SystemMessage').click(function () {
        "use strict";
        uSystemMessageCell.slideToggle();
    });
}

/**
 * 
 * @returns {JQuery} <div class="ButtonCommandBar"></div>
 */
function GenerateButtonCommandBar() {
    "use strict";
    return $('<div class="ButtonCommandBar"></div>');
}
/**
 * Generates a button element with specified text, class, and click event.
 *
 * @param {string} aText - The text to display on the button.
 * @param {string} aCompleteClass - The complete CSS class for the button.
 * @param {string|function} aOnClick - The click event handler for the button.
 *    If a string, it will be treated as an inline JavaScript code.
 *    If a function, it will be bound as a click event handler.
 * @returns {jQuery} The generated button element as a jQuery object.
 */
//TODO: Inprove to a component ButtonComponent 
function privateGenerateButton(aText, aCompleteClass, aOnClick) {
    "use strict";
    var lButton,
        lHtml = [];
    lHtml.push('<div ');
    if (!isNullOrUndefined(aOnClick)) {
        if (typeof aOnClick === 'string') {
            lHtml.push('onclick="');
            lHtml.push(aOnClick);
            lHtml.push('" ');
        }
    }
    lHtml.push('class="');
    lHtml.push(aCompleteClass);
    lHtml.push('">');
    lHtml.push(aText);
    lHtml.push('</div>');
    lButton = $(lHtml.join(''));
    if (typeof aOnClick === 'function') {
        lButton.click(aOnClick);
    }
    return lButton;
}
/**
 * 
 * @param {*} aText 
 * @param {*} aClass 
 * @param {*} aOnClick 
 * @param {*} aHideButton 
 * @returns 
 */
function GenerateButton(aText, aClass, aOnClick, aHideButton) {
    "use strict";
    var lClass = 'Clickable Button';
    if (!isNullOrUndefined(aClass) && aClass !== '') {
        lClass += ' ' + aClass + 'Button LargeIconButton';
    }

    if (aHideButton) {
        lClass += ' HideButton';
    }
    return privateGenerateButton(aText, lClass, aOnClick);
}
/**
 * Generates and Opens a Modal 
 * @param {*} aText 
 * @param {*} aClass 
 * @param {*} aOnClick 
 * @returns 
 */
function GenerateIconButton(aText, aClass, aOnClick) {
    "use strict";
    var lClass = 'Clickable IconButton';
    if (!isNullOrUndefined(aClass) && aClass !== '') {
        lClass += ' ' + aClass + 'Button';
    }
    return privateGenerateButton(aText, lClass, aOnClick);
}

/**
 * Create Small  jquery Button 
 * @param {*} aText 
 * @param {*} aClass 
 * @param {*} aOnClick 
 * @returns 
 */
function GenerateSmallButton(aText, aClass, aOnClick) {
    "use strict";
    var lClass = 'Clickable SmallButton';
    if (!isNullOrUndefined(aClass) && aClass !== '') {
        lClass += ' ' + aClass + 'Button';
    }
    return privateGenerateButton(aText, lClass, aOnClick);
}

/**
 * 
 * @param {string} aTitle - Title of the Modal 
 * @param {string} aContentHtml - Body HTML 
 * @param {*} aCloseButton 
 * @param {*} aData 
 * @param {*} options 
 */
function DisplayModal(aTitle, aContentHtml, aCloseButton, aData, options) {
    "use strict";
    var lPopupToUse = $('#uVeritracksModal'),
        lPopupContent = 'uVeritracksModalBody',
        lPopupContainer,
        lPopupHeader = 'uVeritracksModalHeader',
        lTop,
        lClose = '<a class="PopupClose Clickable" id="uModalCloseButton" style="height:25px; float:right;"></a>',
        lLeft,
        lWindowHeight = $(window).height(),
        lWindowWidth = $(window).width();
    options = Object.assign({
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto'
    }, options);
    lPopupContent = document.getElementById(lPopupContent);
    lPopupContent.innerHTML = '';
    lPopupHeader = document.getElementById(lPopupHeader);
    lPopupHeader.innerHTML = '';
    // handle corner clicking

    if (aCloseButton) {
        lClose = '<a class="PopupClose Clickable" id="uModalCloseButton" onclick="' + aCloseButton + ';" style="height:25px; float:right;"></a>';
    }


    lPopupToUse.css('top', options['top']);
    lPopupToUse.css('left', options['left']);
    lPopupToUse.css('right', options['right']);
    lPopupToUse.css('bottom', options['bottom']);
    var veriTracksModalWindow1 = $('<div class="VeritracksModalWindow headerModal"></div>'),
        veriTracksModalWindow2 = $('<div class="VeritracksModalWindow bodyModal"></div>'),
        popUpTitleBlock = $('<div class="PopupTitle"></div>'),
        popUpTitle = popUpTitleBlock.html(aTitle);

    popUpTitle.appendTo(veriTracksModalWindow1);
    $(lClose).appendTo(veriTracksModalWindow1);
    veriTracksModalWindow1.appendTo($('#uVeritracksModalHeader'));

    veriTracksModalWindow2.appendTo($('#uVeritracksModalBody'));
    veriTracksModalWindow2.html(aContentHtml);
    $('#uVeritracksModal #uVeritracksModalFooter').html(options['buttons'] || '');
    $('#uModalCloseButton').click(CloseModal);

    $(lPopupToUse).show();
}
/**
 * Close Modal 
 */
function CloseModal() {
    "use strict"
    var lPopupPanel;

    lPopupPanel = document.getElementById('uVeritracksModal');
    var lPopupMini = document.getElementById('uVeritracksCustomPopup');
    lPopupPanel.removeEventListener('click', CloseModal);
    if (lPopupMini) {
        lPopupMini.style.display = 'none';
    }
    $(lPopupPanel).hide();
    CustomPopupDispose();
}
/**
 * Utility function AutoDisposeEventHandler(eventName,query,target)
 * this will easily add and remove an "onclick" listener in a css html target
 * @param query string
 * @param target string 
 * @param AutoDisposeEventHandler  callback
 * @returns  callback
 */
var AutoDisposeEventHandler = function (eventName, query, target) {
    var response = {
        callbackEvent: function cb(onEventElementCb) {
            function EventOnClickClose(event) {
                var closest = event.target.closest(target);
                if (closest && document.querySelector(query).contains(closest)) {
                    onEventElementCb(event); // Call
                    //Auto dispose and remove Listener
                    document.querySelector(query).removeEventListener(eventName, EventOnClickClose, false);
                }
            }
            // Start listening...
            document.querySelector(query).addEventListener(eventName, EventOnClickClose, false);
        }
    };
    return response;

};
/**
 * CustomPopup
 * Utility function CustomPopup(options)
 * this will easily populate a custom popup 
 * @param  {template:'<div></div>',cssUrl:'./path/to/file.css'} options
 */
function CustomPopup(options) {
    options = Object.assign({
        id: 'uVeritracksCustomPopup',
        template: '<div></div>',
        // top:'50%',
        // left:'50%',
        cssUrl: undefined,
        cssTargetClickSave: '.btn-save',
        cssTargetClickClose: '.btn-close',
    }, options);
    var cacheTemplate = null; // keep the template once has been loaded 
    var eventHandler = AutoDisposeEventHandler;
    function checkPopupStyle(options) {
        document.getElementById(options['id']).style.top = options['top'] ? options['top'] : '';
        document.getElementById(options['id']).style.right = options['right'] ? options['right'] : '';
        document.getElementById(options['id']).style.left = options['left'] ? options['left'] : '';
        document.getElementById(options['id']).style.bottom = options['bottom'] ? options['bottom'] : '';
    }
    checkPopupStyle(options);
    /**
     * @param  callback _resolve
     * @param  callback _reject
     */
    this.result = function (_resolve, _reject) {
        function onCloseHandler() {
            _reject('close');
            this.close();
            this.onClose();
        }
        eventHandler('click', '#' + options['id'], options['cssTargetClickClose'])
            .callbackEvent(onCloseHandler.bind(this));

        function onSaveHandler() {
            _resolve('save');
            this.onClose();
        }
        eventHandler('click', '#' + options['id'], options['cssTargetClickSave'])
            .callbackEvent(onSaveHandler.bind(this));
    }
    // events
    this.onLoad = function () { };
    this.onClose = function () { };
    // propperties
    this.open = function _open() {
        if (!options['cssUrl']) {
            throw ('missing css url or file under Options { cssUrl:"./File"}');
        }
        loadCssStyle(options['cssUrl'], (function onLoadedCb(style) {
            if (!cacheTemplate) {
                cacheTemplate = style + '\n' + options['template'];
                document.getElementById(options['id']).innerHTML = cacheTemplate;
            }
            document.getElementById(options['id']).style.display = "block";
            this.onLoad();
        }).bind(this));
        return this;
    }
    this.close = function _close() {
        document.getElementById(options['id']).style.display = "none";
        if (!cacheTemplate) {
            document.getElementById(options['id']).innerHTML = "";

        }
    };
    this.hide = function () {
        document.getElementById(options['id']).style.display = "none";
    }
    this.show = function () {
        document.getElementById(options['id']).style.display = "block";
    }
    /**
     * @param  string fileName
     * @param  callback onStyleLoadedCallback
     */
    function loadCssStyle(fileName, onStyleLoadedCallback) {
        var client = new XMLHttpRequest();
        client.open('GET', fileName);
        client.onloadend = function () {
            var style = document.createElement('style');
            style.innerHTML = client.responseText;
            style.outerHTML
            onStyleLoadedCallback(style.outerHTML);
        };
        client.send();
    }
}
/**
 * Hide Modal 
 */
function CustomPopupDispose() {
    var lCustomPopup = document.getElementById('uVeritracksCustomPopup');
    if (lCustomPopup) {
        lCustomPopup.style.display = 'none';
    }
}

function DisplayPopup(aTitle, aContentHtml, aButtonBarHtml, aIsModal, aPopup2, aCloseAction, aPopup3) {
    "use strict";
    var lPopupToUse = $('#uPopupPanel'),
        lPopupContainers = 'uPopupContainer',
        lPopupContent = 'uPopupContent',
        lPopupContentClass = 'PopupContent',
        lCloseButtonClass = '',
        lSecondaryWindow = '',
        lThirdWindow = '',
        lCloseButtonAction = '';

    if (aPopup2) {
        lSecondaryWindow = ' Popup2';
    }
    if (aPopup3) {
        lThirdWindow = ' Popup3';
    }
    if (isNullOrUndefined(aIsModal)) {
        aIsModal = false;
    }
    if (!aIsModal) {
        lCloseButtonClass = 'PopupClose Clickable';
        lCloseButtonAction = 'ClosePopup()';
        if (aCloseAction) {
            lCloseButtonAction = aCloseAction + '()';
        }
    }
    if (aPopup2) {
        lPopupToUse = $('#uPopupPanel2');
        lPopupContainers = 'uPopupContainer2';
        lPopupContent = 'uPopupContent2';
    }
    if (aPopup3) {
        lPopupToUse = $('#uPopupPanel3');
        lPopupContainers = 'uPopupContainer3';
        lPopupContent = 'uPopupContent3';
    }
    var lTable = $('<table/>', {
        'class': 'PopupWindow' + lSecondaryWindow,
        'cellspacing': '0px',
        'cellpadding': '0px'
    }),
    lTableRow1 = $('<tr/>', {
        'class': 'PopupTitle'
    }),
    lTableRow1Cell1 = $('<td/>', {
        'class': 'PopupTitle',
        'html': aTitle
    }),
    lTableRow1Cell2 = $('<td/>', {
        'class': lCloseButtonClass,
        'onclick': lCloseButtonAction
    }),
    lTableRow2 = $('<tr/>', {
        'class': lPopupContentClass
    }),
    lTableRow2Cell1 = $('<td/>', {
        'id': lPopupContent,
        'class': lPopupContentClass,
        'colspan': '2'
    }),
    lTableRow3 = $('<tr/>', {
        'class': 'ButtonBar'
    }),
    lTableRow3Cell1 = $('<td/>', {
        'class': 'ButtonBar',
        'colspan': '2'
    }),
    lPopupPanel = lPopupToUse,
    lPopupContainer = document.getElementById(lPopupContainers);

    lPopupContainer.innerHTML = '';
    var lCurrentHash = window.location.hash;
    if (aIsModal) {
        if (window.history && window.history.pushState) {
            window.history.pushState('forward', null, './' + lCurrentHash);
        }
        lPopupPanel.click(function () { });
    } else {
        if (window.history && window.history.pushState) {
            window.history.pushState('forward', null, './' + lCurrentHash);
        }
        lPopupPanel.click(function (aEvent) {
            if (aEvent.srcElement && aEvent.srcElement.id === 'uPopupContainer') {
                //ClosePopup();
            }
        });
    }
    if (aTitle !== null) {
        lTableRow1Cell1.appendTo(lTableRow1);
        lTableRow1Cell2.appendTo(lTableRow1);
        lTableRow1.appendTo(lTable);
    }
    $(aContentHtml).appendTo(lTableRow2Cell1);
    lTableRow2Cell1.appendTo(lTableRow2);
    lTableRow2.appendTo(lTable);
    $(aButtonBarHtml).appendTo(lTableRow3Cell1);
    if (aButtonBarHtml !== null) {
        $(lTableRow3Cell1).appendTo(lTableRow3);
        $(lTableRow3).appendTo(lTable);
    }
    lTable.appendTo(lPopupContainer);

    $(lPopupPanel).show();
    veritracks.localization.localize('#' + lPopupContainers);
}

function ModalIsOpen() {
    "use strict";
    var isOpen = false;

    if ($('#uVeritracksModal').is(":visible")) {
        isOpen = true;
    }

    return isOpen;
}
function PopupIsOpen(aIdName) {
    "use strict";
    var isOpen = false;

    if ($('#uVeritracksModal').is(":visible") || $('#uPopupPanel').is(":visible") || $('#uPopupPanel2').is(":visible")) {
        isOpen = true;
    }

    if (aIdName) {
        if (aIdName && !$(aIdName).is(":visible")) {
            isOpen = false
        }
    }

    return isOpen;
}

function ClosePopup() {
    "use strict";
    var lPopupPanel;
    var lCurrentHash = window.location.hash;

    if (!$('#uVeritracksModal').is(":hidden")) {
        CloseModal();
    } else {
        if (!$('#uPopupPanel3').is(":hidden")) {
            lPopupPanel = document.getElementById('uPopupPanel3');
        }
        else if (!$('#uPopupPanel2').is(":hidden")) {
            lPopupPanel = document.getElementById('uPopupPanel2');
        }
        else {
            lPopupPanel = document.getElementById('uPopupPanel');
        }
        $(lPopupPanel).hide();
    }
    CustomPopupDispose();
}

function ClosePopup3() {
    "use strict";
    var lPopupPanel;
    if (!$('#uPopupPanel3').is(":hidden")) {
        lPopupPanel = document.getElementById('uPopupPanel3');
    }
    $(lPopupPanel).hide();
}

function ToggleVisibility(aElementId, aIndicatorId) {
    "use strict";
    var lElement = document.getElementById(aElementId);
    if ($(lElement).is(":visible")) {
        $(lElement).hide("fast", resetContentHolders);
        if (aIndicatorId != null) {
            $('#' + aIndicatorId).removeClass('IsVisible').addClass('IsHidden');
        }
    } else {
        $(lElement).show("fast", resetContentHolders);
        if (aIndicatorId != null) {
            $('#' + aIndicatorId).removeClass('IsHidden').addClass('IsVisible');
        }
    }
}

function getOverhead(aClassname) {
    "use strict";

    var lOverhead = 0,
        lItems = 0;
    $.each($("." + aClassname), function (aIndex, aItem) {
        if ($(aItem).is(":visible")) {
            lOverhead += $(aItem).height();
            lItems++;
        }
    });
    return lOverhead + (lItems * 5);
}

function getWindowHeight() {
    "use strict";

    var lHeight = $(window).height();
    if (lHeight < 630) {
        lHeight = 630;
    }
    return lHeight;
}

function resetContentHolders() {
    "use strict";
    var lWindowHeight = getWindowHeight(),
        lMasterContentHeight = (lWindowHeight - (mMasterOverheadHeight + 10)),
        lMasterWidth = $(window).width(),
        lPageOverhead = getOverhead('PageOverhead'),
        lLayoutTableHeight = lMasterContentHeight - 10,
        lPageHeight = lLayoutTableHeight - (lPageOverhead),
        lListOverhead = getOverhead('ListOverhead'),
        lListHeight = lPageHeight - lListOverhead,
        lListControlOverhead = getOverhead('ListHolder .ControlOverhead'),
        lListControlHeight = lListHeight - (lListControlOverhead + 4),
        lContentPrimaryOverhead = getOverhead('ContentPrimaryOverhead'),
        lContentPrimaryHeight = lPageHeight - lContentPrimaryOverhead,
        //lContentPrimaryContentOverhead = $('.ContentPrimaryHolder .ContentOverhead').height(),
        lContentPrimaryContentOverhead = 0,
    //lContentWidth = $('.ContentContainer').width(),
        lContentSecondaryPanel = $('.ContentSecondaryPanel'),
        lContentSecondaryIsVisible = ((lContentSecondaryPanel.length > 0) && (lContentSecondaryPanel.is(":visible"))),
        lContentSecondaryOverhead = 0,
        lContentSecondaryHeight = 0,
        lContentSecondaryContentOverheadHeight = 0,
        lMenuHeight = $('#uMasterMenuPanel').height();

    $('.ContentPrimaryHolder .ContentOverhead').each(function (aIndex, aElement) {
        lContentPrimaryContentOverhead += $(aElement).height();
    });

    if (lContentSecondaryIsVisible) {
        lContentSecondaryOverhead = getOverhead('ContentSecondaryOverhead');
        lContentPrimaryHeight = ((lPageHeight - (lContentPrimaryOverhead + lContentSecondaryOverhead)) / 2);
        lContentSecondaryHeight = lContentPrimaryHeight;
        lContentSecondaryContentOverheadHeight = $('.ContentSecondaryHolder .ContentOverhead').height();
        setHeight('.ContentSecondaryHolder', lContentSecondaryHeight);
        setHeight('.ContentSecondaryListHolder', lContentSecondaryHeight - 20);
        setHeight('.ContentSecondaryHolder .ContentContainer', lContentSecondaryHeight - (lContentSecondaryContentOverheadHeight + 8));
    }

    if (!isNullOrUndefined(lMasterWidth)) {
        if (lMasterWidth < 1150) {
            $('#uMasterPanel').css('overflow', 'auto');
            lMasterWidth = 1150;
        }
        else {
            $('#uMasterPanel').css('overflow', 'hidden');
        }
        //setWidth('#uMasterPanel', lMasterWidth);
        setWidth('#uMasterHeaderPanel', lMasterWidth - 20);
        setWidth('#uMasterMenuPanel', lMasterWidth);
        setWidth('#uMasterFooterPanel', lMasterWidth - 10);
        setWidth('#uMasterContentPanel', lMasterWidth);
        //setWidth('#uUniversalSearchText', (lMasterWidth - 50));
        //setWidth('#uMasterFeedbackPanelText', (lMasterWidth - 50));
    }
    if ($('#uDashboardMasterContent').length > 0) {
        lMasterContentHeight += lMenuHeight;
        lLayoutTableHeight = lMasterContentHeight - 10;
        lPageHeight = lLayoutTableHeight - (lPageOverhead);
        lListHeight = lPageHeight - lListOverhead;
        lListControlHeight = lListHeight - (lListControlOverhead + 4);
        lContentPrimaryHeight = lPageHeight - lContentPrimaryOverhead;
    }
    //$('#uDebugOutput').text('height - ' + lMasterContentHeight);
    setHeight('#uMasterContentHolder', lMasterContentHeight);
    setHeight('.LayoutTable', lLayoutTableHeight);
    setHeight('.ListHolder', lListHeight);
    setHeight('.ListHolder .CardViewControlContent', lListControlHeight);
    setHeight('.ContentPrimaryHolder', lContentPrimaryHeight);
    setHeight('.ContentPrimaryHolder .ContentContainer', lContentPrimaryHeight - (lContentPrimaryContentOverhead + 8));
    setHeight('.ContentPrimaryListHolder', lContentPrimaryHeight - 20);
    //setWidth('.ContentButtonBar', lContentWidth);
    // probably needs rework.
    if (gUserDetails && gUserDetails.Role != 2) {
        switch (mStateManager.Tab()) {
            case 'Dashboard':
                resetContentHoldersDashboard(lWindowHeight, lMasterWidth);
                break;
            case 'Enrollees':
                resetContentHoldersEnrollees(lWindowHeight, lMasterWidth);
                break;
            case 'Events':
                if (gUserDetails.RegionalOri && (getViewState("isRegionalLoaded") == null || getViewState("isRegionalLoaded") == false)) {
                    $("#uEventsTab").addClass("regionalOri");
                    $("#uZonesTab").addClass("regionalOri");
                }
                resetContentHoldersEvents(lWindowHeight, lMasterWidth);
                break;
            case 'Zones':
                if (gUserDetails.RegionalOri && (getViewState("isRegionalLoaded") == null || getViewState("isRegionalLoaded") == false)) {
                    $("#uEventsTab").addClass("regionalOri");
                    $("#uZonesTab").addClass("regionalOri");
                }
                resetContentHoldersZones(lWindowHeight, lMasterWidth);
                break;
            case 'Analysis':
                resetContentHoldersAnalysis();
                if (gUserDetails.RegionalOri && (getViewState("isRegionalLoaded") == null || getViewState("isRegionalLoaded") == false)) {
                    $("#uEventsTab").addClass("regionalOri");
                    $("#uZonesTab").addClass("regionalOri");
                }
                break;
            case 'Inventory':
                resetContentHoldersInventory(lMasterWidth);
                if (gUserDetails.RegionalOri && (getViewState("isRegionalLoaded") == null || getViewState("isRegionalLoaded") == false)) {
                    $("#uEventsTab").addClass("regionalOri");
                    $("#uZonesTab").addClass("regionalOri");
                }
                break;
            case 'Agents':
                resetContentHoldersAgents(lMasterWidth); //removed height
                if (gUserDetails.RegionalOri && (getViewState("isRegionalLoaded") == null || getViewState("isRegionalLoaded") == false)) {
                    $("#uEventsTab").addClass("regionalOri");
                    $("#uZonesTab").addClass("regionalOri");
                }
                break;
            case 'Reports':
                resetContentHoldersReports(lWindowHeight, lMasterWidth);
                if (gUserDetails.RegionalOri && (getViewState("isRegionalLoaded") == null || getViewState("isRegionalLoaded") == false)) {
                    $("#uEventsTab").addClass("regionalOri");
                    $("#uZonesTab").addClass("regionalOri");
                }
                break;
            default:
                if (gUserDetails.RegionalOri && (getViewState("isRegionalLoaded") == null || getViewState("isRegionalLoaded") == false)) {
                    $("#uEventsTileHolder").addClass("regionalOri");
                    $("#uZonesTileHolder").addClass("regionalOri");
                }
                break;
        }
    }
    else {
        switch (mStateManager.Tab()) {
            case 'Enrollees':
                resetContentHoldersEnrollees(lWindowHeight, lMasterWidth);
                if (gUserDetails.RegionalOri && (getViewState("isRegionalLoaded") == null || getViewState("isRegionalLoaded") == false)) {
                    $("#uEventsTab").addClass("regionalOri");
                    $("#uZonesTab").addClass("regionalOri");
                }
                break;
            case 'Analysis':
                resetContentHoldersAnalysis();
                if (gUserDetails.RegionalOri && (getViewState("isRegionalLoaded") == null || getViewState("isRegionalLoaded") == false)) {
                    $("#uEventsTab").addClass("regionalOri");
                    $("#uZonesTab").addClass("regionalOri");
                }
                break;
            case 'Events':
                if (gUserDetails.RegionalOri && (getViewState("isRegionalLoaded") == null || getViewState("isRegionalLoaded") == false)) {
                    $("#uEventsTab").addClass("regionalOri");
                    $("#uZonesTab").addClass("regionalOri");
                    uMasterMenuPanel_OnClick($('#uEventsTab'), 'Enrollees.Offenders.Profile.Events');
                }
                break;
            case "Zones":
                if (gUserDetails.RegionalOri && (getViewState("isRegionalLoaded") == null || getViewState("isRegionalLoaded") == false)) {
                    $("#uEventsTab").addClass("regionalOri");
                    $("#uZonesTab").addClass("regionalOri");
                    uMasterMenuPanel_OnClick($('#uZonesTab'), 'Enrollees.Offenders.Profile.Events');
                }
                break;
            default:
                if (gUserDetails.RegionalOri && (getViewState("isRegionalLoaded") == null || getViewState("isRegionalLoaded") == false)) {
                    $("#uEventsTileHolder").addClass("regionalOri");
                    $("#uZonesTileHolder").addClass("regionalOri");
                }
                break;

        }
    }
    //    if (mStateManager.Tab() === 'Dashboard') {
    //        resetContentHoldersDashboard(lWindowHeight, lMasterWidth);
    //    } else if (mStateManager.Tab() === 'Events') {
    //        resetContentHoldersEvents(lWindowHeight, lMasterWidth);
    //    } else if() {
    //        resetContentHoldersInventory(lWindowHeight, lMasterWidth);
    //    }



}

function getViewState(aId) {
    "use strict";
    var lResult = null;
    if (!isNullOrUndefined(gSessionState[aId])) {
        lResult = gSessionState[aId];
    }
    return lResult;
}


function setViewState(aId, aValue) {
    "use strict";
    var lState = new ViewState();
    lState.Id = aId;
    lState.Value = aValue;
    gSessionState[aId] = lState;
}

function deleteViewState(aId) {
    delete gSessionState[aId];
}

function ToggleVisibilitySize(aElementId, aIndicatorId) {
    "use strict";
    ToggleVisibility(aElementId, aIndicatorId);
    resetContentHolders();
}

function populateElement(aElementId, aFileName, aCallbackFunction, aParams) {
    "use strict";
    $('#' + aElementId).html('').load('Interface/' + aFileName, function () {
        if ($('.IsLoginScreen').length > 0) {
            veritracks.system.logout();
        } else if (aCallbackFunction != null) {
            veritracks.localization.localize('#' + aElementId);
            if (aParams != null) {
                aCallbackFunction(aParams);
            } else {
                aCallbackFunction();
            }
        }
    });
}

function getFileHtml(aFileName, aCallbackFunction) {
    "use strict";
    $.get('Interface/' + aFileName, function (aHtml) {
        if (aCallbackFunction != null) {
            aCallbackFunction(aHtml);
        }
    });
}

function EnterEditMode(aContainerId) {
    "use strict";
    $('#' + aContainerId + ' .Editable').hide();
    $('#' + aContainerId + ' .Editing').show();
}

function ExitEditMode(aContainerId) {
    "use strict";
    $('#' + aContainerId + ' .Editing').hide();
    $('#' + aContainerId + ' .Editable').show();
}

function EnterAddMode(aContainerId) {
    "use strict";
    $('#' + aContainerId + ' .Addable').hide();
    $('#' + aContainerId + ' .Adding').show();
}

function ExitAddMode(aContainerId) {
    "use strict";
    $('#' + aContainerId + ' .Adding').hide();
    $('#' + aContainerId + ' .Addable').show();
}

function setHeight(aSelector, aValue) {
    "use strict";
    var lElement = aSelector;
    if (typeof aSelector === 'string') {
        lElement = $(aSelector);
    }
    lElement.css('height', aValue + 'px')
            .css('max-height', aValue + 'px')
            .css('min-height', aValue + 'px');
}


function setWidth(aSelector, aValue) {
    "use strict";
    var lElement = aSelector;
    if (typeof aSelector === 'string') {
        lElement = $(aSelector);
    }
    if (aValue) {
        lElement.css('width', aValue + 'px')
        .css('max-width', aValue + 'px')
        .css('min-width', aValue + 'px');
    } else {
        lElement.css('width', '')
         .css('max-width', '')
         .css('min-width', '');
    }
}

function GetPrimaryHash() {
    "use strict";
    var lClassName = window.location.hash;
    if (lClassName.indexOf('.') !== -1) {
        lClassName = lClassName.substring(1, lClassName.indexOf('.'));
    } else {
        lClassName = lClassName.substring(1, lClassName.length);
    }
    if (lClassName === '') {
        lClassName = 'Dashboard';
    }
    return lClassName;
}

function GetSecondaryHash() {
    "use strict";
    var lSettingsString = window.location.hash,
        lSettings;
    if (lSettingsString.indexOf('.') !== -1) {
        lSettingsString = lSettingsString.substring(lSettingsString.indexOf('.') + 1, lSettingsString.length);
        lSettings = lSettingsString.split(".");
    } else {
        lSettings = [];
    }
    return lSettings;
}

function GetCurrentHash() {
    "use strict";
    var lHash = {};
    lHash.Tab = GetPrimaryHash();
    lHash.Settings = GetSecondaryHash();
    $('#uDebugOutput').text(lHash.Tab + ' - ' + lHash.Settings);
    return lHash;
}

function caculateMasterHeight() {
    "use strict";
    mMasterOverheadHeight = 0;
    $.each($(".MasterVisualOverhead"), function (aIndex, aItem) {
        mMasterOverheadHeight += $(aItem).height();
    });
}

function PopulateTabContent() {
    "use strict";
    switch (mCurrentHash.Tab) {
        case 'Dashboard':
            SetDashboardFixedHeights();
            DashboardTabContent_Init();
            break;
        case 'Enrollees':
            SetEnrolleesFixedHeights();
            EnrolleesTabContent_Init();
            break;
        case 'Events':
            SetEventsFixedHeights();
            EventsTabContent_Init();
            break;
        case 'Zones':
            SetZonesFixedHeights();
            ZonesTabContent_Init();
            break;
        case 'Inventory':
            SetInventoryFixedHeights();
            InventoryTabContent_Init();
            break;
        case 'Agents':
            SetAgentsFixedHeights();
            AgentsTabContent_Init();
            break;
        case 'Users':
            SetUsersFixedHeights();
            UsersTabContent_Init();
            break;
        case 'Reports':
            SetReportsFixedHeights();
            ReportsTabContent_Init();
            break;
    }
}

function ChangeHashSettings(aIndex, aNewValue) {
    "use strict";
    mStateManager.ChangeSettings(aIndex, aNewValue);
}

function CopySettings() {
    "use strict";
    var lSettings = [],
        i;
    for (i = 0; i < mCurrentHash.Settings.length; i++) {
        lSettings[i] = mCurrentHash.Settings[i];
    }
    return lSettings;
}


function uMapSettingsFilter_OnFilter(aExpression) {
    var lHtml = '',
        lKey;
    if (!isNullOrUndefined(aExpression)) {
        for (lKey in aExpression.Value) {
            if (aExpression.Value.hasOwnProperty(lKey)) {
                lHtml += '{ ' + aExpression.Value[lKey] + ' } ';
            }
        }
    }
    mActivityNotification.addNotification('- ' + lHtml + ' -', null, gSystemSettings.IsDebug);
}

function ClearValidation() {
    // ERRORS
    $('label.error').remove();
    $('.error').removeClass('error');
}


// EVENTS

function uMasterMenuPanel_OnClick(aTab, aDefaultHash) {
    "use strict";
    if (aTab) {
        var lFilterCleaner = aTab.id + 'PreCleaner';
        $('#uMasterMenuPanel .Selected').removeClass('Selected');
        $(aTab).addClass('Selected');
        if (!isNullOrUndefined(aDefaultHash)) {
            if (window[lFilterCleaner]) {
                window[lFilterCleaner]();
            }
            mStateManager.ChangeHash(aDefaultHash);
        }
    }
}



function setLoadingScreenColor() {
    "use strict";
}



$(document).ready(function () {
    if (gSystemSettings.IsDebug) {
        $('.DebugMode').show();
    } else {
        $('.DebugMode').remove();
    }
    setLoadingScreenColor();
    $("#uDefaultLoadingContainer").show();
});

// DATA
function EnrolleeLastContact_OnLoad(aParams, aCacheItem) {
    "use strict";
    for (var lKey in aCacheItem.Data) {
        if (aCacheItem.Data.hasOwnProperty(lKey)) {
            var lObject = aCacheItem.Data[lKey];
            gLastContact[lObject.DeviceId] = lObject;
            if (!isNullOrUndefined(lObject.EnrolleeId)) {
                gEnrolleeLastContact[lObject.EnrolleeId] = lObject;
            }
        }
    }
    // this is required to ensure the hashing process has finished before the system load process can be fired.
    if (--mSystemDataObjectsPending === 0) {
        cacheItemsSystem_OnComplete(aParams.CallbackFunction);
    }
}

function DeviceLastContact_OnLoad(aParams, aCacheItem) {
    "use strict";
    var lKey;
    for (lKey in aCacheItem.Data) {
        if (aCacheItem.Data.hasOwnProperty(lKey)) {
            var lObject = aCacheItem.Data[lKey];
            gDeviceLastContact[lObject.DeviceId] = lObject;
        }
    }
    // this is required to ensure the hashing process has finished before the system load process can be fired.
    if (--mSystemDataObjectsPending === 0) {
        cacheItemsSystem_OnComplete(aParams.CallbackFunction);
    }
}



function currentDeviceAssignment_OnLoad(aParams, aCacheItem) {
    "use strict";
    var lAssignments = [],
        lObject,
        lKey;
    for (lKey in aCacheItem.Data) {
        if (aCacheItem.Data.hasOwnProperty(lKey)) {
            lObject = aCacheItem.Data[lKey];
            if (isNullOrUndefined(lAssignments[lObject.EnrolleeId])) {
                lAssignments[lObject.EnrolleeId] = [];
            }
            lAssignments[lObject.EnrolleeId][lObject.Id] = lObject;
        }
    }
    gCurrentDeviceAssignment = lAssignments;
    // this is required to ensure the hashing process has finished before the system load process can be fired.
    if (--mSystemDataObjectsPending === 0) {
        cacheItemsSystem_OnComplete(aParams.CallbackFunction);
    }
}

function EnrolleesUpdated_OnUpdate(aParams, aCacheItem) {
    "use strict";
    var lKey,
        lData = aCacheItem.Data;

    for (lKey in aCacheItem.Data) {
        if (aCacheItem.Data.hasOwnProperty(lKey)) {
            aCacheItem.Data[lKey].InMyOrganization = (gUserDetails.OrganizationIds.indexOf(aCacheItem.Data[lKey].OrganizationId) !== -1);
        }
    }

}

function EnrolleesUniversal_OnUpdate(aParams, aCacheItem) {
    "use string";
    var lKey;

    for (lKey in aCacheItem.Data) {
        if (aCacheItem.Data.hasOwnProperty(lKey)) {
            aCacheItem.Data[lKey].InMyOrganization = (gUserDetails.OrganizationIds.indexOf(aCacheItem.Data[lKey].OrganizationId) !== -1);
        }
    }
    universalSearch_UpdateData();
}

function DevicesUniversal_OnUpdate(aParams, aCacheItem) {
    "use strict";
    AssignGlobalIds(gUniversalDeviceIds, aCacheItem, "Id");
}


function AssignGlobalIds(aGlobalIdArray, aCacheItem, aFieldName) {
    "use strict";

    var lKey = null,
        lHasId = false;

    // clear the array
    aGlobalIdArray.length = 0;

    if (count(aCacheItem.Data) > 0) {
        for (lKey in aCacheItem.Data) {
            if (aCacheItem.Data.hasOwnProperty(lKey)) {
                lHasId = !isNullOrUndefined(aCacheItem.Data[lKey][aFieldName]);
                break;
            }
        }
        if (lHasId === true) {
            for (lKey in aCacheItem.Data) {
                if (aCacheItem.Data.hasOwnProperty(lKey)) {
                    aGlobalIdArray.push(aCacheItem.Data[lKey][aFieldName]);
                }
            }
        }
    }
}

function AssignMyGlobalIds(aGlobalIdArray, aCacheItem, aFieldName) {
    "use strict";

    var lKey = null,
        lHasId = false;

    // clear the array
    aGlobalIdArray.length = 0;

    if (count(aCacheItem.Data) > 0) {
        for (lKey in aCacheItem.Data) {
            if (aCacheItem.Data.hasOwnProperty(lKey)) {
                lHasId = !isNullOrUndefined(aCacheItem.Data[lKey][aFieldName]);
                break;
            }
        }
        if (lHasId === true) {
            for (lKey in aCacheItem.Data) {
                if (aCacheItem.Data.hasOwnProperty(lKey)) {
                    if (gUserDetails.OrganizationIds.indexOf(aCacheItem.Data[lKey].OrganizationId) !== -1)
                        aGlobalIdArray.push(aCacheItem.Data[lKey][aFieldName]);
                }
            }
        }
    }
}

// LAYOUT POPULATION
function mStateManager_Init() {
    MasterTabContent_OnLoad();
}

function MasterTabContent_OnLoad() {
    "use strict";
    var lTab = document.getElementById('u' + mStateManager.Tab() + 'Tab');
    uMasterMenuPanel_OnClick(lTab);
    //resetContentHolders();
    //dataObjectList_Init();
    //PopulateTabContent();
}

function MasterTabContent_Init() {
    "use strict";
    //var lLayout = mCurrentHash.Tab + '.Layout.htm';
    //populateElement('uMasterContentHolder', lLayout, MasterTabContent_OnLoad);
}

function hideLoadingScreen() {
    gLoadScreenCounter--;
    if (gLoadScreenCounter === 0) {
        $('#uLoadingScreen').fadeOut(1000 * 1);
    }
}


function ExtendSession_OnSuccess(aData) {
    var l = '';
}

function cardView_OnDataBind(aSender, aParams, aData) {
    aSender.selectedIndex(0);
    resetContentHolders();
}

function displayBoolean(aValue) {
    var lResult = localizeText('cYes');
    if (!aValue) {
        lResult = localizeText('cNo');
    }
    return lResult;
}

function RoundNumber(aNumber, aDecimalPlaces) {
    "use strict";
    var result = Math.round(aNumber * Math.pow(10, aDecimalPlaces)) / Math.pow(10, aDecimalPlaces);
    return result;
}

/**
 * DisplayShortDateTime repeated in * Formatters.js 
 * @param {*} aDate 
 * @returns 
 */
function DisplayShortDateTime(aDate) {
    "use strict";
    var lReturn = '';

    if (aDate instanceof Date) {
        lReturn = $.format.date(aDate, "MM/dd/yyyy hh:mm:ss a");
    } else {
        lReturn = $.format.date(new Date(aDate), "MM/dd/yyyy hh:mm:ss a");
    }

    return lReturn;
}
/**
 * @deprecated Not being used 
 * @param {*} aDate 
 * @param {*} aTimeZoneName 
 * @returns 
 */
function converToUTCWithTimezoneOffset(aDate, aTimeZoneName) {
    "use strict";

    var lDate = new Date(aDate),
        timezoneBrowser = moment().tz(moment.tz.guess()),
        lGetTimeZoneOffsetBrowser = getTimeZoneOffSet(timezoneBrowser._z.name),
        lGetTimeZoneOffset = getTimeZoneOffSet(aTimeZoneName),
        lTimeZoneOffsetDifference = lGetTimeZoneOffset,
        lMoment = moment(aDate).tz(aTimeZoneName),
        lMoment = moment(aDate).add(lTimeZoneOffsetDifference, 'minutes');

    return lMoment._d;
}
/**
 * @deprecated Not being used 
 * @param {*} aDate 
 * @param {*} aTimeZoneName 
 * @returns 
 */
function converToUTCWithTimezoneOffsetBackShortDisplay(aDate, aTimeZoneName) {
    "use strict";

    var lDate = new Date(aDate),
        timezoneBrowser = moment().tz(moment.tz.guess()),
        lGetTimeZoneOffsetBrowser = getTimeZoneOffSet(timezoneBrowser._z.name),
        lGetTimeZoneOffset = getTimeZoneOffSet(aTimeZoneName),
        lTimeZoneOffsetDifference = lGetTimeZoneOffset,
        lMoment = moment(aDate).tz(aTimeZoneName),
        lMoment = moment(aDate).add(lTimeZoneOffsetDifference, 'minutes');

    return DisplayShortDateTime(lMoment._d);
}
/**
 *  this method converts a Date in given timezone to ISO String using momentjs
 * @param {*} aDate 
 * @param {*} aTimeZoneName 
 * @returns 
 */
function getMomentInTimeZone(aDate, aTimeZoneName) {
    "use strict";
    var timezoneBrowser = moment().tz(moment.tz.guess()),
        lGetTimeZoneOffsetBrowser = getTimeZoneOffSet(timezoneBrowser._z.name),
        lGetTimeZoneOffset = getTimeZoneOffSet(aTimeZoneName),
        lMoment = moment(aDate).tz(aTimeZoneName);

    var lOffset = Math.abs(((Math.abs(lGetTimeZoneOffset) - Math.abs(lGetTimeZoneOffsetBrowser)) / 60));

    if (lGetTimeZoneOffsetBrowser > lGetTimeZoneOffset) {
        lMoment = moment(aDate).add(lOffset, 'hours');
    } else {
        lMoment = moment(aDate).add(-lOffset, 'hours');
    }

    return lMoment._d.toISOString();
}
/**
 * Get Moment Date 
 * @param {*} aDate 
 * @returns 
 */
function getMoment(aDate) {
    var momentDate = moment(aDate);

    return momentDate._d;
}
/**
 * Convert Date into Local Time - L LT
 * @param {*} aDate 
 * @returns 
 */
function convertMomentLocal(aDate) {
    var momentLocal = moment.utc(aDate).format('L LT');
    var momentDate = moment(momentLocal);

    return momentDate._d;
}
/**
 * 
 * @param {*} aDateString 
 * @returns 
 */
function convertMomentFromStringOffset(aDateString) {
    var nowOffset = getMinuteOffset();

    var momentDate = moment(aDateString).add(nowOffset, 'minutes');

    return momentDate._d;
}

function convertMomentFromStringTimezone(aDateString, aTimeZoneName) {
    var momentDate = moment(aDateString).tz(aTimeZoneName);//add(nowOffset, 'minutes');

    return momentDate._d;
}

//can later be moved to use displayDateByTimeZoneId
function displayEventInEnrolleeTimeZone(aDate, aEnrollee) {
    "use strict";
    var lTimezone,
        lResult;
    if (aEnrollee) {
        lTimezone = getDataItem(aEnrollee.TimeZoneId, 'TimeZone');
        if (lTimezone) {
            lResult = displayFixedTimeZoneTime(aDate, lTimezone.TimeZoneName);
        } else {
            lResult = aDate;
        }
    } else {
        lResult = aDate;
    }

    return lResult;
}

function displayDateByTimeZoneId(aDate, aId) {
    var lTimezone = getDataItem(aId, 'TimeZone'),
    lResult;

    if (lTimezone) {
        lResult = displayFixedTimeZoneTime(aDate, lTimezone.TimeZoneName);
    } else {
        lResult = aDate;
    }

    return lResult;
}

function displayFixedTimeZoneTime(aDate, aTimeZoneName) {
    "use strict";
    var momentUTC,
        momentDate = moment();

    if (aTimeZoneName) {
        momentUTC = moment.utc(aDate).format('YYYY-MM-DD HH:mm:ss');
        momentDate = moment(momentUTC).tz(aTimeZoneName);
    }
    return momentDate._d;
}

function convertTimeToUTC(aDate, aTimeZoneName) {
    "use strict";
    var timeZoneOffset;
    var localTime = aDate.getTime();
    var utc = localTime;
    // use timezone offset as of Now
    if (!isNullOrUndefined(aTimeZoneName) && aTimeZoneName !== '') {
        timeZoneOffset = getMinuteOffset(aTimeZoneName);
    }
    else {
        timeZoneOffset = getMinuteOffset();
    }
    var milliSecs = (60000 * timeZoneOffset);

    if (milliSecs > 0) {
        milliSecs = -Math.abs(milliSecs);
    }
    else {
        milliSecs = Math.abs(milliSecs);
    }

    var enrolleeTimeZoneDifferenceMilliseconds = (utc + milliSecs);
    var e = new Date(enrolleeTimeZoneDifferenceMilliseconds);
    var t = IeFixDateUTCBrowser(e);
    return t;
}

function IeFixDateUTCBrowser(aDate) {
    "use strict";

    var utc = aDate.getTime(); //+ localOffset;
    // use timezone offset as of Now
    var timeZoneOffset = getMinuteOffset();
    var milliSecs = (60000 * timeZoneOffset);
    if (milliSecs < 0)
        milliSecs = -Math.abs(milliSecs);
    else
        milliSecs = Math.abs(milliSecs);

    var enrolleeTimeZoneDifferenceMilliseconds = (utc + milliSecs);

    return new Date(enrolleeTimeZoneDifferenceMilliseconds);
}

function IeFixDate(stringDate) {
    "use strict";
    var a = stringDate.split(" ");
    var d = a[0].split("-");
    var t = a[1].split(":");

    return new Date(d[0], (d[1] - 1), d[2], t[0], t[1], t[2]);
}

// dates like this 3-4-2014
function IeFixShortDate(stringDate) {
    var d = stringDate.split("-");

    return new Date(d[2], (d[0] - 1), d[1]);
}

function getTimeZoneOffSet(aTimezoneName) {
    return getMinuteOffset(aTimezoneName);
}

function displayTime(aDate) {
    "use strict";
    return $.format.date(aDate, "hh:mm:ss a");
}

function displayShortTime(aDate) {
    "use strict";
    return $.format.date(aDate, "hh:mm a");
}
function timeFieldFormatter(aDate) {
    "use strict";
    return $.format.date(aDate, "h:mm a");
}

function displayShortDate(aDate) {
    "use strict";
    var lReturn = '';


    if (aDate instanceof Date) {
        if (!isNaN(aDate.getTime())) {
            lReturn = $.format.date(aDate, "MM/dd/yyyy");
        }
    } else {
        lReturn = $.format.date(new Date(aDate), "MM/dd/yyyy");
    }



    return lReturn;
}

function displayDaytoDay(aStart, aEnd) {
    var lDays = '';
    var lStart = 'c' + aStart.format("dddd");
    var lEnd = 'c' + aEnd.format("dddd");

    if (lStart == lEnd)
        lDays = localizeWrapper(lStart);
    else
        lDays = localizeWrapper(lStart) + localizeWrapper('cTo') + localizeWrapper(lEnd);

    return lDays;
}

function getWeek(aDate) {
    "use strict";
    var lDate,
        lDay,
        lMaxDayCounter = 6;

    if (!isNullOrUndefined(aDate)) {
        lDate = new Date(aDate);
    }
    else {
        lDate = new Date();
    }
    lDate.setHours(0);
    lDate.setMinutes(0);
    lDate.setSeconds(0);
    lDate.setMilliseconds(0);

    lDay = lDate.getDay();

    var week_start = new Date(lDate).addDays(-lDay);

    var week_end = new Date(lDate).addDays(lMaxDayCounter - lDay);  // first day of week
    week_end.setHours(23);
    week_end.setMinutes(59);
    week_end.setSeconds(59);


    return { 'DateString': displayShortDate(week_start) + ' - ' + displayShortDate(week_end), 'FirstDay': displayShortDate(week_start), 'LastDay': displayShortDate(week_end) };    // date range for current week
}

function displayDailyRate(aNumber) {
    var lNumber;
    if (aNumber < 0) {
        lNumber = localizeText('cDisabled');
    }
    else {
        lNumber = aNumber.toFixed(2).toString();
    }
    return lNumber;
}
/**
 * Method that displays % symbol in a given number.
 * @param {*} aNumber 
 * @returns string
 */
function DisplayPercent(aNumber) {
    "use strict";
    return RoundNumber(aNumber, 2) + '%';
}


/**
 * P
 * @param {*} aSpeed 
 * @returns 
 */
function DisplaySpeed(aSpeed) {
    "use strict";
    var lDoMetric =  parseInt(getUserPreferenceValue(13,'ShowMetric'));
    if (lDoMetric) {
        return convertMilesToKilometers(aSpeed) + ' KPH';
    }
    else {
        return aSpeed + ' MPH';
    }
}

function getTimezone(aId) {
    "use strict";
    return getDataItem(aId, 'TimeZone');
}

function timezoneCodeFormatter(aTimezoneCode) {
    "use strict";
    var lTimezone = 'EASTERN',
        lItem = getTimezoneByCode(aTimezoneCode);

    if (!isNullOrUndefined(lItem)) {
        lTimezone = localizeDataItem('TimeZone', lItem.Name);
    }

    return lTimezone;
}

function spatialTimezoneCodeFormatter(aTimezoneId) {
    "use strict";
    var lTimezone = '',
        lItems = getDataItems('TimeZone');

    lItems = lItems.filter(function (a, b) {
        return a.Id == aTimezoneId
    })

    if (!isNullOrUndefined(lItems[0])) {
        lTimezone = localizeDataItem('TimeZone', lItems[0].Name);
    }

    return lTimezone;
}

function getTimezoneByCode(aTimeZoneCode, aByName) {
    "use strict";
    var lResult = null,
        lItem = null,
        lItems = getDataItems('TimeZone'),
        lKey;

    for (lKey in lItems) {
        if (lItems.hasOwnProperty(lKey)) {
            lItem = lItems[lKey];
            if (lItem.TimeZoneCode === aTimeZoneCode) {
                break;
            } else {
                lItem = null;
            }
        }
    }

    if (!isNullOrUndefined(lItem)) {
        lResult = lItem;
    }

    if (aByName) {
        return lResult.TimeZoneName;
    }

    return lResult;
}
/**
 * @deprecated
 * @returns 
 */
function getTimezonebyBrowser() {
    var now = new Date().toString();
    var TZ = now.indexOf('(') > -1 ?
    now.match(/\([^\)]+\)/)[0].match(/[A-Z]/g).join('') :
    now.match(/[A-Z]{3,4}/)[0];
    if (TZ == "GMT" && /(GMT\W*\d{4})/.test(now)) TZ = RegExp.$1;

    return TZ;
}



// does not save text fields
function FreeFormFilterUserPreferences(aSender) {
    "use strict";
    var lKey,
        lColumns = aSender.Columns;

    for (lKey in lColumns) {
        if (lColumns.hasOwnProperty(lKey)) {
            if (lColumns[lKey].Type == 'Text') {
                if (!isNullOrUndefined(aSender.FilterState[lKey])) {
                    if (lColumns[lKey].DataField.toLowerCase() == aSender.FilterState[lKey].ColumnName.toLowerCase()) {
                        aSender.FilterState[lKey].Value = '';
                    }
                }
            }
        }
    }

    writeUserPreferences(aSender.FilterState, function () {
        aSender.UpdatePreferences(aSender.FilterState);
    });
}

function writeUserPreferences(aList, aCallback) {
    "use strict";
    var lPrefList = [],
        lPref,
        lKey;

    for (lKey in aList) {
        if (aList.hasOwnProperty(lKey)) {
            lPref = aList[lKey];
            lPref.TransactionId = moment().format("YYYYMMDDHHmmss");
            if (lPref.ColumnName !== null && lPref.ColumnName !== '' && lPref.Value !== null) {
                lPrefList.push(lPref);
            } else {
                //alert('uh oh');
            }
        }
    }
    WriteMultiple(lPrefList, function writeUserPreferences_OnSuccess(aParams, aData) {
        "use strict";
        var lItem,
            lKey;
        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lItem = aData[lKey];
                if (lItem.Id === gUserDetails.UserId) {
                    setDataItem(null, 'UserPreference', lItem);
                }
            }
        }
        //mCache.UpdateItem('UserPreference');
        if (!isNullOrUndefined(aParams)) {
            aParams();
        }
    }, function writeUserPreferences_OnFailure(aParams, a, b, c) {
        "use strict";
        //alert('writeUserPreferences_OnFailure: ' + b);
    }, aCallback, true);
}
/**
 * Method that curates the UserPreferenceRead by UserPreferenceType
 * @param {*} aTypeId 
 * @returns 
 */
function getUserPreferences(aTypeId) {
    "use strict";
    var lPreferences = getDataItems('UserPreference'),
        lBuilder = new SumoPredicateBuilder(),
        lPreferenceHash = {},
        lItem,
        lKey;

    lBuilder.AddNewExpressionConditional('UserPreferenceType', aTypeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lPreferences = query(lPreferences, lBuilder.RootExpression);

    for (lKey in lPreferences) {
        if (lPreferences.hasOwnProperty(lKey)) {
            lItem = lPreferences[lKey];
            lPreferenceHash[lItem.ColumnName] = lItem;
        }
    }
    return lPreferenceHash;
}
function getUserPreferenceValue(aTypeId,aColumnName){
    var lPreferences = getUserPreferences(aTypeId);
    if(aColumnName in lPreferences){
        return lPreferences[aColumnName].Value;
    }
    return null;
}

function getMyAgentIds(aUserId) {
    "use strict";
    var lAgents = getDataItems('Agents'),
        lBuilder = new SumoPredicateBuilder(),
        lMyAgents = [],
        lAgentIds = [],
        lAgent,
        lKey;

    lBuilder.AddNewExpressionConditional('UserId', aUserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lMyAgents = query(lAgents, lBuilder.RootExpression);

    if (!isNullOrUndefined(lMyAgents)) {
        if (lMyAgents.length == 0) {
            lMyAgents = query(getDataItems('AgentsStop'), lBuilder.RootExpression);
        }
    } else {
        lMyAgents = query(getDataItems('AgentsStop'), lBuilder.RootExpression);
    }

    for (lKey in lMyAgents) {
        if (lMyAgents.hasOwnProperty(lKey)) {
            lAgent = lMyAgents[lKey];
            lAgentIds.push(lAgent.Id);
        }
    }

    return lAgentIds;
}


/**
 * Function that returns an array of Integers Agents ID's by given UserId
 * @param {*} aUserId 
 * @returns Array 
 */
function getUserRoleById(aUserId) {
    "use strict";
    var lUserRoles = getDataItems('UserRoles'),
        lBuilder = new SumoPredicateBuilder(),
        llUserRolesHash = 1,
        lItem,
        lKey;

    lBuilder.AddNewExpressionConditional('UserId', aUserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lUserRoles = query(lUserRoles, lBuilder.RootExpression);

    for (lKey in lUserRoles) {
        if (lUserRoles.hasOwnProperty(lKey)) {
            lItem = lUserRoles[lKey];
            break;
        }
    }
    return lItem;
}
/**
 * Map Display Type event OnChange
 * @event sumo.maps.GoogleMapControl#mapTypeId_OnChange#mapDisplayType_OnChange
 * @param {*} aMap google.maps.Map
 */
function mapDisplayType_OnChange(aMap) {
    var lPreference = new UserPreference();
    lPreference.ColumnName = 'MapDisplayType';
    lPreference.Id = gUserDetails.UserId;
    lPreference.UserPreferenceType = 10;
    lPreference.Value = aMap.getMapTypeId();
    writeUserPreferences([lPreference]);
}
/**
 * Function that Populates View 
 * @param {*} aObject 
 * @param {*} aFormatters 
 * @param {*} aElementPrefix 
 */
function PopulateDetailView(aObject, aFormatters, aElementPrefix) {
    "use strict";
    var lProperty,
        lValue,
        lFormatter,
        lPrefix;
    if (!isNullOrUndefined(aElementPrefix)) {
        lPrefix = aElementPrefix;
    }
    for (lProperty in aObject) {
        if (aObject.hasOwnProperty(lProperty)) {
            lFormatter = aFormatters[lProperty];
            if (!isNullOrUndefined(lFormatter)) {
                lValue = lFormatter(aObject[lProperty]);
            }
            else {
                lValue = aObject[lProperty];
            }
            $('#' + aElementPrefix + lProperty).html(lValue);
             const hasPhoneNumber =$('#' + aElementPrefix + lProperty).hasClass('InternationalPhoneNumber');
            if (hasPhoneNumber) {
                setIntlPhoneNumber('#' + aElementPrefix + lProperty, lValue, {
                    onlyCountries: UserHelper.getPhoneCodes()
                });
            }

            // for TESTING
            // mActivityNotification.addNotification(lProperty + ":" + lValue, true);
        }
    }
}
/**
 * Function that Populates  
 * @param {*} aObject 
 * @param {*} aFields 
 * @param {*} aFormatters 
 * @param {*} aElementPrefix 
 * @param {*} aElementSuffix 
 * @param {*} aLocalizeMethod 
 */
function populateEditView(aObject, aFields, aFormatters, aElementPrefix, aElementSuffix, aLocalizeMethod) {
    "use strict";
    var lProperty, lValue, lFormatter, lField, lFieldKey, lKey, lHtml, lDataItem, lNewElementId, lNullText, lElement, lBlankText,
        lPrefix = '',
        lSuffix = '',
        lNullValue = '-1';

    if (!isNullOrUndefined(aElementPrefix)) {
        lPrefix = aElementPrefix;
    }
    if (!isNullOrUndefined(aElementSuffix)) {
        lSuffix = aElementSuffix;
    }
    for (lFieldKey in aFields) {
        if (aFields.hasOwnProperty(lFieldKey)) {
            lField = aFields[lFieldKey];
            var lLocaleName = lField.LocaleName;
            lHtml = [];

            if (lField.Type === 'Dropdown') {
                if (!isNullOrUndefined(lField.isNullableKey) && lField.isNullableKey && (isNullOrUndefined(aObject[lField.Id]) || aObject[lField.Id] === -1 || aObject[lField.Id] === '')) {
                    if (!isNullOrUndefined(lField.nullText)) {
                        lNullText = lField.nullText;
                    } else {
                        lNullText = localizeText('cPleaseSelect');
                    }
                    if (!isNullOrUndefined(lField.nullValue)) {
                        lNullValue = lField.nullValue;
                    } else {
                        lNullValue = '-1';
                    }
                    lHtml.push('<option value="');
                    lHtml.push(lNullValue);
                    lHtml.push('">');
                    lHtml.push(lNullText);
                    lHtml.push('</option>');
                }
                if (!isNullOrUndefined(lField.insertBlank) && lField.insertBlank) {
                    if (!isNullOrUndefined(lField.blankText)) {
                        lBlankText = lField.blankText;
                    } else {
                        lBlankText = '';
                    }
                    lHtml.push('<option value="-1">' + lBlankText + '</option>');
                }
                for (lKey in lField.DataSource) {
                    if (lField.DataSource.hasOwnProperty(lKey)) {
                        lDataItem = lField.DataSource[lKey];
                        lHtml.push('<option value="');
                        lHtml.push(lDataItem[lField.DataValueField]);
                        lHtml.push('">');
                        if (aLocalizeMethod && lLocaleName) {
                            lHtml.push(aLocalizeMethod(lLocaleName, lDataItem[lField.DataTextField]));
                        } else {
                            lHtml.push(lDataItem[lField.DataTextField]);
                        }
                        lHtml.push('</option>');
                    }
                }
            } else if (lField.Type === 'CheckboxList') {
                for (lKey in lField.DataSource) {
                    if (lField.DataSource.hasOwnProperty(lKey)) {
                        lDataItem = lField.DataSource[lKey];
                        lNewElementId = lPrefix + lField.Id + lSuffix + lDataItem[lField.DataValueField];
                        lHtml.push('<div><input type="checkbox" name="" id="');
                        lHtml.push(lNewElementId);
                        lHtml.push('" value="');
                        lHtml.push(lDataItem[lField.DataValueField]);
                        lHtml.push('" /> <label for="');
                        lHtml.push(lNewElementId);
                        lHtml.push('" title="');
                        if (aLocalizeMethod) {
                            lHtml.push(aLocalizeMethod(lLocaleName, lDataItem[lField.DataTextField]));
                        } else {
                            lHtml.push(lDataItem[lField.DataTextField]);
                        }
                        lHtml.push('">');
                        if (aLocalizeMethod) {
                            lHtml.push(aLocalizeMethod(lLocaleName, lDataItem[lField.DataTextField]));
                        } else {
                            lHtml.push(lDataItem[lField.DataTextField]);
                        }
                        lHtml.push('</label></div>');

                    }
                }
            }
            $('#' + lPrefix + lField.Id + lSuffix).html(lHtml.join(''));
            if (lField.Class !=null) {
                $('#' + lPrefix + lField.Id + lSuffix).addClass(lField.Class);
            }
        }
    }
    for (lProperty in aObject) {
        if (aObject.hasOwnProperty(lProperty)) {
            lFormatter = aFormatters[lProperty];
            if (!isNullOrUndefined(lFormatter)) {
                lValue = lFormatter(aObject[lProperty]);
            }
            else {
                lValue = aObject[lProperty];
            }
            if ($('#' + lPrefix + lProperty + lSuffix).attr('type') == 'checkbox') {
                $('#' + lPrefix + lProperty + lSuffix).prop('checked', lValue);
            } else {
                $('#' + lPrefix + lProperty + lSuffix).val(lValue);
            }
        }
    }
}
/**
 * Function that Populates Object into  DOM elements 
 * e.g. <input class="Editing EidItem DatePick EidDatePickers Validate ValidateRequired ValidateDate" type="text" id="uOffenderProfileEnrolleeEIdEndDateEdit" /> 
 * @param {*} aObject 
 * @param {*} aPrefix 
 * @param {*} aSuffix 
 */
function populateFromEditView(aObject, aPrefix, aSuffix) {
    var lKey,
        lItem;
    for (lKey in aObject) {
        if (aObject.hasOwnProperty(lKey)) {
            lItem = $('#' + aPrefix + lKey + aSuffix);
            if (lItem.length > 0) {
                if (lItem.attr('type') == 'checkbox') {
                    aObject[lKey] = convertBoolToInteger(lItem.is(':checked'));
                } else {
                    if (!lItem.hasClass('DatePick')) {
                        aObject[lKey] = lItem.val();
                    } else {
                        populateFromDateView(aObject, lKey, '#' + aPrefix + lKey + aSuffix);
                    }
                }
            }
        }
    }
}

function populateDateView(aElementSelector, aCallback) {
    "use strict";
    var lElement = $(aElementSelector),
        lValue = lElement.val();
    if (lValue === '') {
        lValue = $.format.date(new Date(), 'MM/dd/yyyy');
    }
    
    lElement.datepicker({
        'changeYear': true,
        'onClose': function () {
            var lNewValue = $(aElementSelector).val();
            if (lNewValue !== lValue) {
                lValue = lNewValue;
                if (!isNullOrUndefined(aCallback)) {
                    aCallback();
                }
            }
        },
        'showButtonPanel': false,
        'yearRange': '-100:+10',
        onChangeMonthYear: function (aYear, aMonth, aInst) {
            var lCurrrentDate = $(this).datepicker("getDate");
            if (lCurrrentDate == null)
                return;
            if (lCurrrentDate.getYear() != aYear || lCurrrentDate.getMonth() != aMonth - 1) {
                lCurrrentDate.setYear(aYear);
                lCurrrentDate.setMonth(aMonth - 1);
                $(this).datepicker("setDate", lCurrrentDate);
            }
        }
    });
    //
    //lElement.DatePicker({
    //    'format': 'm/d/Y',
    //    'date': lValue,
    //    'current': lValue,
    //    'onBeforeShow': function () {
    //        lValue = lElement.val();
    //        if (lValue === '') {
    //            lValue = $.format.date(new Date(), 'MM/dd/yyyy');
    //        }
    //        lElement.DatePickerSetDate(lValue, true);
    //    },
    //    'onChange': function (aFormatted, aDates) {
    //        lValue = aFormatted;
    //        $(aElementSelector).val(aFormatted);
    //        $(aElementSelector).DatePickerHide();
    //        if (!isNullOrUndefined(aCallback)) {
    //            aCallback();
    //        }
    //    }
    //});
}
function populateFromDateView(aObject, aProperty, aElementSelector) {
    "use strict";
    var lValue = $(aElementSelector).val();
    if (isNullOrUndefined(lValue) || lValue === '') {
        aObject[aProperty] = new Date(-3000000000000);
    } else {
        aObject[aProperty] = new Date(Date.parse(lValue));
    }
}

/* BASE FUNCTIONS */
/**
 * Function that gets Cache Elements from the mCache Instance
 * calls mCache.GetItem
 * @param {*} aCacheName 
 * @returns 
 */
function getCacheItem(aCacheName) {
    var lReturn = null,
        lCacheItem = mCache.GetItem(aCacheName);
    if (!isNullOrUndefined(lCacheItem)) {
        lReturn = lCacheItem;
    }
    return lReturn;
}
/**
 * Calls getCacheItem@function and maps to Result.Data
 * @param {*} aCacheName 
 * @returns 
 */
function getDataItems(aCacheName) {
    "use strict";
    var lResult = null,
        lDataItem = getCacheItem(aCacheName);
    if (!isNullOrUndefined(lDataItem)) {
        lResult = lDataItem.Data;
    }
    return lResult;
}
/**
 * Function that gets an specific Item from a Cache 
 * e.g. getDataItem(1,'Enrollee')
 * @param {*} aId 
 * @param {*} aCacheName 
 * @returns 
 */
function getDataItem(aId, aCacheName) {
    "use strict";
    var lResult = null,
        lItems = getCacheItem(aCacheName),
        lItem = null;
    if (!isNullOrUndefined(lItems)) {
        if (!isNullOrUndefined(lItems.Data)) {
            lItem = lItems.Data[aId];
        }
    }
    if (!isNullOrUndefined(lItem)) {
        lResult = lItem;
    }
    return lResult;
}
/**
 * Set Data Cache Item by a given Id
 * @param {*} aId 
 * @param {*} aCacheName 
 * @param {*} aData 
 */
function setDataItem(aId, aCacheName, aData) {
    "use strict";
    var lResult = null,
        lItems = getCacheItem(aCacheName),
        lHash;
    if (!isNullOrUndefined(lItems)) {
        if (!isNullOrUndefined(aData)) {
            lHash = lItems.getHashValue(aData);
            lItems.Data[lHash] = aData;
        } else {
            lItems.Data[aId] = aData;
        }
    }
}

// FEEDBACK
var gFeedback = {};
gFeedback.DefaultValue = 'provide feedback';
function uFeedBackPopup_OnClick() {
    "use strict";
    var lButtonBar = GenerateButtonCommandBar(),
        lHtml = ['<div id="uFeedBackPopup">',
            '<p><textarea type="text" id="uFeedbackPanelText" Rows="10" Cols="80"></textarea></p>',
        '</div>'],
        lBuilder = new SumoPredicateBuilder();
    GenerateButton(localizeWrapper('cAgentSubmit'), 'Submit', gFeedback.writeFeedback).appendTo(lButtonBar);
    GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', ClosePopup).appendTo(lButtonBar);
    DisplayPopup(localizeWrapper('cAgentProvideFeedback'), lHtml.join(''), lButtonBar, false);
}
gFeedback.Text = function (aText) {
    "use strict";
    var lResult = "",
        lFeedbackTextInput = $('#uFeedbackPanelText');
    if (!isNullOrUndefined(aText)) {
        lFeedbackTextInput.val(aText);
    } else {
        lResult = lFeedbackTextInput.val();
    }
    return lResult;
};

gFeedback.OnFocus = function () {
    "use strict";
    if (gFeedback.Text() === gFeedback.DefaultValue) {
        gFeedback.Text('');
    }
};

gFeedback.OnKeyDown = function (aEvent, a, b, c) {
    "use strict";
    if (aEvent.keyCode === 13) {
        //  gFeedback.writeFeedback();
    }
};

gFeedback.OnBlur = function () {
    "use strict";
    if (gFeedback.Text() === '') {
        gFeedback.Text(gFeedback.DefaultValue);
    }
};

gFeedback.write_OnSuccess = function (aParams, aUserFeedback) {
    "use strict";
    mActivityNotification.addNotification(localizeWrapper('cAgentFeedbackReceived'));
    gFeedback.Text(gFeedback.DefaultValue);
};

gFeedback.write_OnFailure = function (a, b, c) {
    "use strict";

    //alert('feedback failed: ' + b);
};

gFeedback.writeFeedback = function () {
    "use strict";
    var lUserFeedback = new UserFeedback(gUserDetails.UserId, window.location.href, gFeedback.Text());

    if (lUserFeedback.Content != "") {
        mActivityNotification.addNotification(localizeWrapper('cAgentSavingFeedback'));
        WriteSingle(lUserFeedback, gFeedback.write_OnSuccess, gFeedback.write_OnFailure, lUserFeedback);
    }
    ClosePopup();
};


// On Demand Enrollee Loader
/**
 * @deprecated
 * Gets Organization HTML Select 
 * @returns 
 */
function uChangeOrganizationData() {
    "use strict";
    var lHtml = [],
        lOrganizations = getDataItems('Organizations'),
        lKey,
        lCount = 0;

    if (!isNullOrUndefined(lOrganizations)) {
        lHtml.push('<span> Organization </span>');
        lHtml.push('<select id="uChangeOrganization" onchange="uChangeOrganizationData_OnChange()">');
        lHtml.push('<option value="' + '-1' + '" selected="selected">  All </option>');
        for (lKey in lOrganizations) {
            if (lOrganizations.hasOwnProperty(lKey)) {
                lHtml.push('<option value="' + lOrganizations[lKey].Id + '">' + lOrganizations[lKey].Name + '</option>');
            }
        }
        lHtml.push('</select>');
    }
    return lHtml.join('');
}
/**
 * @deprecated
 * @event uChangeOrganization#OnChange 
 */
function uChangeOrganizationData_OnChange() {
    "use strict";
    var lOrganization = $('#uChangeOrganization').val(),
        lBuilder = new SumoPredicateBuilder(),
        lData;

    if (lOrganization != -1) {
        lBuilder.AddNewExpressionConditional('OrganizationId', lOrganization, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lData = query(gOnDemandList, lBuilder.RootExpression);
    }
    else {
        lData = gOnDemandList;
    }

    gOnDemandEnrolleesListView.setDataSource(lData);
}
/**
 * @deprecated
 * 
 */
function uSearchEnrolleeOnDemand_OnClick() {
    "use strict";
    var lEnrollee = $('#uEnrolleeNameInput').val(),
        lBuilder = new SumoPredicateBuilder(),
        lData = gOnDemandEnrolleesListView.getDataSource();

    lBuilder.AddNewExpressionConditional('FullName', lEnrollee, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lData = query(lData, lBuilder.RootExpression());

    gOnDemandEnrolleesListView.setDataSource(lData);
}
/**
 * @event uOnDemandEnrolleesFilter_Init#gOnDemandFilter#OnFilter
 *  OnFilter event in gOnDemandFilter instance of gFilterFactory.createControl
 * @param {*} aSender 
 * @param {*} aExpression 
 * @param {*} aData 
 */
//TODO: Move function outside of global to local scope uOnDemandEnrolleesFilter_Init. No need to be in global scope
function uOnDemandEnrolleeFilter_OnFilter(aSender, aExpression, aData) {
    "use strict";
    var lBuilder,
        lExpression,
        lOnDemandList;

    lOnDemandList = query(gOnDemandList, aExpression);
    gOnDemandEnrolleesListView.setDataSource(lOnDemandList);
}
/**
 * Initializes gOnDemandFilter  
 * @returns {void}
 */
//TODO Move function inside uOnDemandEnrolleesCacheLoad_OnClick@function . No need to be in global scope
function uOnDemandEnrolleesFilter_Init() {
    "use strict";
    if (isNullOrUndefined(gOnDemandFilter)) {
        var lColumns = [],
            lTitle = localizeWrapper('cEnrolleeSearch'),
            lParams;

        lColumns.push({ 'Id': 'FullName', 'Title': localizeWrapper('cEnrolleeName'), 'Type': 'Text', 'DataField': 'FullName' },
            { 'Id': 'PrimaryId', 'Title': localizeWrapper('cEnrolleePrimaryId'), 'Type': 'Text', 'DataField': 'PrimaryId' },
        { 'Id': 'OrganizationId', 'Title': localizeWrapper('cEnrolleeOrganization'), 'Type': 'Dropdown', 'DataField': 'OrganizationId', 'DataSource': OrganizationSortFormatter(), 'DataValueField': 'Id', 'DataTextField': 'Name', 'InsertBlank': true, 'BlankText': 'All' });

        lParams = {
            'Title': lTitle,
            'Content': '',
            'CssClass': 'DefaultFilter',
            'HideOnFilter': true,
            'OnFilter': uOnDemandEnrolleeFilter_OnFilter,
            'Columns': lColumns,
            'Settings': null
        };
         /** @type {gFilterFactory.createControl} */
        gOnDemandFilter = gFilterFactory.createControl('uOnDemandEnrolleesFilter', 'uOnDemandEnrolleesFilterHolder', lParams);
    }
    else {
        gOnDemandFilter.render();
    }
}
/**
 * @emits OnClick event in HTML DOM #uEnrolleesMenuCell
 * @returns {void}
 */
function uOnDemandEnrolleesCacheLoad_OnClick() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lButtonBar = GenerateButtonCommandBar(),
        lColumns,
        lHtml = [];
    var lIdList = sessionStorage.OnDemandEnrollees;

    lHtml.push('<div id="uOnDemandEnrolleesFilterHolder" class="ListFilterHolder ListOverhead" style="width:200px; margin-bottom:2px;"></div>');
    lHtml.push('<div id="uOnDemandEnrolleesListHolder" style="min-width:600px; height:500px;"></div>');

    GenerateButton(localizeWrapper('cEnrolleeRetrieveArchive'), 'Save', uOnDemandEnrolleesCacheLoad_OnChange).appendTo(lButtonBar);
    GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', 'ClosePopup()').appendTo(lButtonBar);
    DisplayPopup(localizeWrapper('cEnrolleeSearchArchive'), lHtml.join(''), lButtonBar, false);

    if (!isNullOrUndefined(gOnDemandEnrolleesListView)) {
        gOnDemandEnrolleesListView = null;
    }
    uOnDemandEnrolleesFilter_Init();
    lColumns = [
    { 'id': 'Selection', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': selectionColumnFormatter, 'canResize': false },
    { 'id': 'FullName', 'title': localizeWrapper('cEnrollee'), 'dataField': 'FullName', 'width': 'autoData', 'minWidth': 120, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
    { 'id': 'PrimaryId', 'title': localizeWrapper('cEnrolleePrimaryId'), 'dataField': 'PrimaryId', 'width': 'autoData', 'minWidth': 120, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
    { 'id': 'OrganizationId', 'title': localizeWrapper('cEnrolleeOrganization'), 'dataField': 'OrganizationId', 'width': 'autoData', 'minWidth': 120, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': OrganizationNameFormatter }
    ];

    gOnDemandEnrolleesListView = new sumo.controls.ListView('uOnDemandEnrolleesListView', 'uOnDemandEnrolleesListHolder', { 'keyField': 'Id', 'selectMethod': 'auto', 'cssClass': 'VeritracksListView', 'canUnselect': true }, lColumns);


    lBuilder.AddNewExpressionConditional('ArchiveFlag', 'Y', false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    if (!isNullOrUndefined(lIdList)) {
        if (lIdList.length > 0) {
            lIdList = lIdList.split(',');
            lBuilder.AddNewExpressionConditional('Id', lIdList, false, mRelationalOperatorEnum.NotIn(), mLogicalOperatorEnum.And());
        }
    }
    lBuilder.AddNewExpressionConditional('OrganizationId', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.Enrollee.AssemblyQualifiedName, lBuilder.RootExpression, 0, EnrolleeOnDemand_LoadPopup, null, null, null, 0);

    function EnrolleeOnDemand_LoadPopup(aParams, aData) {
        "use strict";
        var lSort = new SortExpression();

        lSort.addAscendingColumn('FullName');
        aData = lSort.sort(aData);

        gOnDemandEnrolleesListView.setDataSource(aData);
        gOnDemandList = aData;
    }
}
/**
 * Handles the onChange event.
 * Calls the LoadOnDemandEnrollees() function.
 */
//TODO: Move inside uOnDemandEnrolleesCacheLoad_OnClick
function uOnDemandEnrolleesCacheLoad_OnChange() {
    "use strict";

    var lIdList = gOnDemandEnrolleesListView.selected();

    if (!isNullOrUndefined(lIdList)) {
        LoadOnDemandEnrollees(lIdList);
    }
}
/**
 * Calls ReadMultiple. EnrolleeRead by Id list 
 * @param {*} aIdList 
 */
//TODO: Only being used inside uOnDemandEnrolleesCacheLoad_OnChange. Move from global scope
function LoadOnDemandEnrollees(aIdList) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lIdList = aIdList,
        lEnrollees,
        lKey;

    lBuilder.AddNewExpressionConditional('Id', lIdList, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.Enrollee.AssemblyQualifiedName, lBuilder.RootExpression, 0, EnrolleeOnDemand_OnSuccess, null, null, null, 0);

    function EnrolleeOnDemand_OnSuccess(aParams, aData) {
        var lEnrollee,
            lEnrolleeList = [],
            lKey;

        FixDates(aData);
        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lEnrollee = aData[lKey];
                lEnrollee.InMyOrganization = (gUserDetails.OrganizationIds.indexOf(lEnrollee.OrganizationId) !== -1);
                lEnrollee.ArchiveFlag = 'N';
                setDataItem(lEnrollee.Id, 'Enrollees', lEnrollee);
                if (CheckUserHasPermission(45))
                    setDataItem(lEnrollee.Id, 'EnrolleesUniversal', lEnrollee);
                lEnrolleeList.push(lEnrollee);
            }
        }
        WriteMultiple(lEnrolleeList, null, null);

        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('EnrolleeId', lIdList, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        // ReadMultiple(gObjectList.Event.AssemblyQualifiedName, lBuilder.RootExpression, 0, EventsOnDemand_OnSuccess, null, null, null, 0);
        ReadMultiple(gObjectList.OffenderSchedule.AssemblyQualifiedName, lBuilder.RootExpression, 0, EnrolleeSchedulesOnDemand_OnSuccess, null, null, null, 0);
    }

    function EnrolleeSchedulesOnDemand_OnSuccess(aParams, aData) {
        var lSchedule,
            lSchedulesList = [],
            lHash = GetCurrentHash(),
            lKey;

        FixDates(aData);

        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lSchedule = aData[lKey];
                lSchedule.ArchiveFlag = 'N';
                lSchedulesList.push(lSchedule);
            }
        }
        WriteMultiple(lSchedulesList, null, null);

        ClosePopup();
        mActivityNotification.addNotification(localizeWrapper('cEnrolleeSuccessRetrievedArchive'));
        // check if on enrollees tile
        if (lHash.Tab == 'Enrollees') {
            enrolleesDataListConverter();
            if (!isNullOrUndefined(mEnrolleesControls.CardView)) {
                if (ObjectLength(lIdList) == 1)
                    mEnrolleesData.TargetId = lIdList[0];
                mEnrolleesControls.CardViewOffenderFilter.filter();
            }
        }
    }

}
/**
 * @callback 
 * Handles the OnSuccess Callback for Generate Device Action Write. 
 * Calls ClosePopup() function
 * @param {*} aParams 
 * @param {*} aData 
 */
//TODO: Move from global scope. Inside generateDeviceAction function ;
function generateDeviceAction_OnSuccess(aParams, aData) {
    "use strict";
    ClosePopup();
}
/**
 * Calls showRapidReportingStatusToggle()
 * @param {number} aDeviceActionType 
 * @param {number} aDeviceId 
 */
function generateDeviceAction(aDeviceActionType, aDeviceId) {
    "use strict";
    /** @type {DeviceAction} */
    var lDeviceAction = new DeviceAction();

    lDeviceAction.ActionType = aDeviceActionType;
    lDeviceAction.ActionStatus = 1; // pending = 1 sent = 2
    lDeviceAction.Id = aDeviceId;
    lDeviceAction.ActionDateUTC = new Date();

    mActivityNotification.addNotification(localizeWrapper('cInventoryDeviceActionSent'));
    WriteSingle(lDeviceAction, generateDeviceAction_OnSuccess, null, {}, true);
    //generateDeviceAction_OnSuccess({}, lDeviceAction);
    if (aDeviceActionType === 9 || aDeviceActionType === 140) {
        var lBuilder = new SumoPredicateBuilder(),
        lDevices = getDataItems('Devices'),
        lKey,
        lDevice;

        lBuilder.AddNewExpressionConditional('Id', aDeviceId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lDevices = query(lDevices, lBuilder.RootExpression);
        if (!isNullOrUndefined(lDevices)) {
            for (lKey in lDevices) {
                if (lDevices.hasOwnProperty(lKey)) {
                    lDevice = lDevices[lKey];
                    showRapidReportingStatusToggle(lDevice.SerialNumber);
                }
            }
        }
    }
}
/**
 * @callback OnComplete
 * displayDeviceActionPopup
 * @param {Object} aParams 
 * @param {Object} aData 
 */
//TODO: Move to displayDeviceActionPopup
function displayDeviceActionPopup_OnComplete(aParams, aData) {
    "use strict";
    var lButtonBar = GenerateButtonCommandBar(),
		lHtml = [],
        lActionName = '',
        lNow = new Date(),
        lSendRecieveTimeOut = 1000 * 60 * 45, //45 minutes
        lActionStatus,
        lActionStatusExists = false,
        lHaltActionStatusExists = false,
        lRapidReportData,
        lSort = new SortExpression(),
        lHaltActionStatus,
        lItem,
        lKey;

    // localize issues
    function showSendCommand(aActionName) {
        lHtml.push('<h3>' + localizeText('cDeviceSendCommand') + '</h3>');
        lHtml.push('<div style="margin:5px 0;">');
        lHtml.push(DeviceSendCommand(aActionName));
        lHtml.push('</div>');
    }

    function showLastCommand(aDoesExist, aActionStatus) {
        if (aDoesExist) {
            if (aActionStatus.ActionStatus === 1) {
                lHtml.push('<h3>' + localizeText('cDeviceLastCommandSent') + '</h3>');
            } else {
                lHtml.push('<h3>' + localizeText('cDeviceLastCommandReceived') + '</h3>');
            }
        }
        lHtml.push('<div style="margin:5px 0;">');
        if (aDoesExist) {
            lHtml.push(DisplayShortDateTime(aActionStatus.ActionDateUTC));
        } else {
            lHtml.push(localizeText('cDeviceNoContact'));
        }
        lHtml.push('</div>');
    }

    function showTimeOutMessage() {
        lHtml.push('<div style="margin:5px 0;">');
        lHtml.push('<br>');
        lHtml.push(DeviceCommandTimeoutMessage(aActionName));
        lHtml.push('<br><br>');
        lHtml.push(DeviceSendCommand(aActionName));
        lHtml.push('</div>');
    }

    function DeviceSendCommand(aActionName) {
        var lActionName = aActionName.replace(/\s+/g, '');
        return localizeText('cDeviceSend' + lActionName);
    }
    function DeviceCommandTimeoutMessage(aActionName) {
        var lActionName = aActionName.replace(/\s+/g, '');
        return localizeText('cDeviceMessageTimeout' + lActionName);
    }

    function showInProgressMessage(aActionName) {
        lHtml.push('<div style="margin:5px 0;">');
        lHtml.push(DeviceCommandProcessingMessage(aActionName));
        lHtml.push('</div>');
    }

    function DeviceCommandProcessingMessage(aActionName) {
        var lActionName = aActionName.replace(/\s+/g, '');
        return localizeText('cDeviceMessageInProgress' + lActionName);
    }

    function showRapidReportingStatus() {
        lHtml.push('<div style="margin:15px 0;">');
        lHtml.push(DeviceCurrentMode(lActionName));
        lHtml.push(lRapidReportData.EndDate);
        lHtml.push('.');
        lHtml.push('</div>');
        lHtml.push('<div style="margin:5px 0;">');
        lHtml.push(localizeText('cDeviceDisableRapidReporting'));
        lHtml.push('</div>');
    }

    function DeviceCurrentMode(aActionName) {
        var lActionName = aActionName.replace(/\s+/g, '');
        return localizeText('cDeviceCurrently' + lActionName);
    }

    function showConfirmButton() {
        GenerateButton(localizeWrapper('cEventConfirm'), 'ConfirmEvent', 'generateDeviceAction(' + aParams.DeviceActionType + ',' + aParams.Id + ')').appendTo(lButtonBar);
    }

    function showHaltRapidReportingButton() {
        GenerateButton(localizeWrapper('cEnrolleeDisable'), 'Cancel', 'generateDeviceAction(140,' + aParams.Id + ')').appendTo(lButtonBar);
    }

    FixDates(aData);
    lSort.addDescendingColumn('ActionDateUTC');
    aData = lSort.sort(aData);

    if (aData.length > 0) {
        lItem = aData[0];
        if (lItem.ActionType === aParams.DeviceActionType || lItem.ActionType === 139) {
            lActionStatus = lItem;
            lActionStatusExists = true;
        } else if (lItem.ActionType === 140) {
            lHaltActionStatus = lItem;
            lHaltActionStatusExists = true;
        }
    }
    if (!isNullOrUndefined(aParams.RapidReportData)) {
        if (!isNullOrUndefined(aParams.RapidReportData[0])) {
            lRapidReportData = aParams.RapidReportData[0];
            FixDates([lRapidReportData]);
        } else {
            lRapidReportData = [];
        }
    }

    switch (aParams.DeviceActionType) {
        case 6: //    Buzz = 6
            lActionName = 'Buzz';
            showLastCommand(lActionStatusExists, lActionStatus);
            showSendCommand(lActionName);
            showConfirmButton();
            break;
        case 7: //    Vibrate = 7
            lActionName = 'Vibrate';
            showLastCommand(lActionStatusExists, lActionStatus);
            showSendCommand(lActionName);
            showConfirmButton();
            break;
        case 8: //    LocateDevice = 8
            lActionName = 'Locate Device';
            showLastCommand(lActionStatusExists, lActionStatus);
            showSendCommand(lActionName);
            showConfirmButton();
            break;
        case 9: //    RapidReporting = 9
            lActionName = 'Rapid Reporting';
            if (lActionStatusExists && lActionStatus.ActionDateUTC < lRapidReportData.EndDate && getMoment(lRapidReportData.EndDate) > getMoment(lNow)) {
                showLastCommand(lActionStatusExists, lActionStatus);
                if (lActionStatus.ActionStatus == 1) {
                    showInProgressMessage(lActionName);
                } else {
                    lActionName = 'Halt Rapid Reporting';
                    showHaltRapidReportingButton(lActionName);
                }
            } else if (lHaltActionStatusExists && lHaltActionStatus.ActionDateUTC < lRapidReportData.EndDate && getMoment(lRapidReportData.EndDate) > getMoment(lNow)) {
                showLastCommand(lHaltActionStatusExists, lHaltActionStatus);
                if (lHaltActionStatus.ActionStatus == 1) {
                    lActionName = 'Halt Rapid Reporting';
                    showInProgressMessage(lActionName);
                } else {
                    showLastCommand(lHaltActionStatusExists, lHaltActionStatus);
                    showSendCommand(lActionName);
                    showConfirmButton();
                }
            }
            else if (lRapidReportData && lRapidReportData.EndDate > lNow) {
                showLastCommand(lActionStatusExists, 1);
                showInProgressMessage(lActionName);
            } else {
                // never started or expired 1
                showLastCommand(lActionStatusExists, lActionStatus);
                showSendCommand(lActionName);
                showConfirmButton();
            }
            break;
        case 176: //    AGENTFINGERPRINT = 176
            lActionName = 'Agent Fingerprint Setup';
            showLastCommand(lActionStatusExists, lActionStatus);
            showSendCommand(lActionName);
            showConfirmButton();
            break;
    }

    if (aParams.Id != -1) {
        if (aParams.DeviceActionType === 9) {
            var lBuilder = new SumoPredicateBuilder(),
            lDevices = getDataItems('Devices'),
            lKey,
            lDevice;

            lBuilder.AddNewExpressionConditional('Id', aParams.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lDevices = query(lDevices, lBuilder.RootExpression);
            if (!isNullOrUndefined(lDevices)) {
                for (lKey in lDevices) {
                    if (lDevices.hasOwnProperty(lKey)) {
                        lDevice = lDevices[lKey];
                        showRapidReportingStatusToggle(lDevice.SerialNumber);
                    }
                }
            }
        }
        var popup2 = false;
        if (PopupIsOpen())
            popup2 = true;

        var lPopUpTitle = lActionName;
        if (aParams.DeviceActionType !== 176) {
            lPopUpTitle = lPopUpTitle + ' - ' + aParams.FullName;
        }

        DisplayPopup(lPopUpTitle, lHtml.join(''), lButtonBar, false, popup2);
    }
}
/**
 * 
 * @param {number} aDeviceActionType 
 * @param {number} aDeviceId 
 * @param {string} aFullName 
 */
function displayDeviceActionPopup(aDeviceActionType, aDeviceId, aFullName) {
    "use strict";

    var lBuilder = new SumoPredicateBuilder(),
        lParamsOuter = { 'DeviceActionType': aDeviceActionType, 'Id': aDeviceId, 'FullName': aFullName, 'RapidReportData': null };

    function fail() {
        mActivityNotification.addNotification(localizeWrapper('cInventoryDeviceActionFailed'));
    }
    function synchronizeReads(aParams, aData) {
        var lParams = aParams;
        lParams.RapidReportData = aData;
        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('Id', aDeviceId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('ActionType', [aDeviceActionType, 139, 140], false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.DeviceAction.AssemblyQualifiedName, lBuilder.RootExpression, 0, displayDeviceActionPopup_OnComplete, fail, lParams, null, 0);
    }

    if (aDeviceActionType !== 9) {
        // not rapid reporting
        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('Id', aDeviceId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('ActionType', aDeviceActionType, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.DeviceAction.AssemblyQualifiedName, lBuilder.RootExpression, 0, displayDeviceActionPopup_OnComplete, fail, lParamsOuter, null, 0);
        //  $('.RapidReportButton').removeClass('Selected');
        //  $('.RapidReportButton').attr('title', 'rapid reporting off');
    } else {
        // rapid reporting
        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('Id', aDeviceId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.DeviceRapidReporting.AssemblyQualifiedName, lBuilder.RootExpression, 0, synchronizeReads, fail, lParamsOuter, null, 0);
        //  $('.RapidReportButton').addClass('Selected');
        //  $('.RapidReportButton').attr('title', 'rapid reporting on');
    }

}
/**
 * Calls ReadMultiple DeviceRapidReporting 
 * @param {string|number} aSerialNumber 
 */
function showRapidReportingStatusToggle(aSerialNumber) {
    var lBuilder = new SumoPredicateBuilder(),
        lDevices = getDataItems('Devices'),
        lDeviceRapidReporting = getDataItems('DeviceRapidReporting'),
        lKey,
        lDevice;

    lBuilder.AddNewExpressionConditional('SerialNumber', aSerialNumber, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lDevices = query(lDevices, lBuilder.RootExpression);
    if (!isNullOrUndefined(lDevices)) {
        for (lKey in lDevices) {
            if (lDevices.hasOwnProperty(lKey)) {
                lDevice = lDevices[lKey];
                lBuilder.Clear();
                lBuilder.AddNewExpressionConditional('Id', lDevice.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                ReadMultiple(gObjectList.DeviceRapidReporting.AssemblyQualifiedName, lBuilder.RootExpression, 0, showRapidReporting_OnSuccess, showRapidReporting_OnFailure, lDevice.Id, null, 0);
            }
        }
    }
}
/**
 * @callback OnSuccess
 * showRapidReporting 
 * @param {Object} aParams 
 * @param {Object} aData 
 */
//TODO: Move to showRapidReportingStatusToggle function
//TODO: Remove jQuery DOM manipulation
function showRapidReporting_OnSuccess(aParams, aData) {
    var rightnow = new Date();
    FixDates(aData);
    if (aData.length > 0) {
        if (+aData[0].EndDate < +rightnow) {
            $('.RapidReportButton').removeClass('Selected');
            $('.RapidReportButton').attr('title', localizeTitleFormatter('rapid reporting off'));
        }
        else {
            // rapid reporting
            $('.RapidReportButton').addClass('Selected');
            $('.RapidReportButton').attr('title', localizeTitleFormatter('rapid reporting off'));
        }
    }
    else {
        $('.RapidReportButton').removeClass('Selected');
        $('.RapidReportButton').attr('title', localizeTitleFormatter('rapid reporting on'));
    }

}
/**
 * @callback OnFailure 
 * showRapidReporting
 * @param {Object} aParams 
 * @param {Object} aData 
 */
//TODO: Move to showRapidReportingStatusToggle function
function showRapidReporting_OnFailure(aParams, aData) {
    "use strict"
}






































//------------------
// Page Load Process
//------------------
function systemDisplay_Init() {
    "use strict";

    //  preDashBoardCheck();
    mStateManager.Initialize();
    caculateMasterHeight();
    enhancedCrimeAnalystSupport();
    TopLevelCDCRSupport();
    hideLoadingScreen();
    resetContentHolders();
    uUserOrganizationsLoggedInto();
}

function universalSearch_Init() {
    "use strict";
    var lSearchItems = new Array(),
        lSearch,
        lCacheItem,
        lAdvancedSearching = CheckUserHasPermission(45),
        lBuilder;

    lBuilder = new SumoPredicateBuilder();
    lBuilder.AddNewExpressionConditional('EnrolleeType', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    if (lAdvancedSearching || gUserDetails.Role == 2) {
        lCacheItem = getCacheItem('EnrolleesUniversal');
        lSearchItems.push({ 'Class': 'OffenderSearchResult', 'Class2': 'MyOffenderSearchResult', 'Title': 'Enrollees', 'Hash': '#Enrollees.Offenders.Profile.Events', 'DataSource': lCacheItem.Data, 'SearchFields': ['FullName', 'PrimaryId', 'SecondaryId'], 'ValueField': 'FullName', 'Generator': EnrolleeUniversalSearchGenerator, 'Expression': lBuilder.RootExpression });
    }
    else {
        lCacheItem = getCacheItem('Enrollees');
        lSearchItems.push({ 'Class': 'OffenderSearchResult', 'Title': 'Events', 'Hash': '#Enrollees.Offenders.Profile.Events', 'DataSource': lCacheItem.Data, 'SearchFields': ['FullName', 'PrimaryId', 'SecondaryId'], 'ValueField': 'FullName', 'Generator': EnrolleeUniversalSearchGenerator, 'Expression': lBuilder.RootExpression });
    }


    if (gUserDetails.Role !== 2) {
        if (!isNullOrUndefined(lCacheItem)) {
            lBuilder = new SumoPredicateBuilder();
            lBuilder.AddNewExpressionConditional('EnrolleeType', 2, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lSearchItems.push({ 'Class': 'VictimSearchResult', 'Title': 'Enrollees', 'Hash': '#Enrollees.Victims.Profile.Events', 'DataSource': lCacheItem.Data, 'SearchFields': ['FullName', 'PrimaryId', 'SecondaryId'], 'ValueField': 'FullName', "Generator": EnrolleeUniversalSearchGenerator, 'Expression': lBuilder.RootExpression });
        }
        lCacheItem = getCacheItem('Devices');
        if (!isNullOrUndefined(lCacheItem)) {
            lSearchItems.push({ 'Class': 'DeviceSearchResult', 'Title': 'Devices', 'Hash': '#Inventory.Devices.Device', 'DataSource': lCacheItem.Data, 'SearchFields': ['SerialNumber'], 'ValueField': 'SerialNumber', 'Generator': DeviceUniversalSearchGenerator });
        }
        lCacheItem = getCacheItem('Users');
        if (!isNullOrUndefined(lCacheItem)) {
            lSearchItems.push({ 'Class': 'AgentSearchResult', 'Title': 'Users', 'Hash': '#Agents.Agents.Profile', 'DataSource': lCacheItem.Data, 'SearchFields': ['FullName', 'Email'], 'ValueField': 'FullName', 'Generator': AgentUniversalSearchGenerator });
        }
        lCacheItem = getCacheItem('Zones');
        if (!isNullOrUndefined(lCacheItem)) {
            lSearchItems.push({ 'Class': 'ZoneSearchResult', 'Title': 'Zones', 'Hash': '#Zones.Map', 'DataSource': lCacheItem.Data, 'SearchFields': ['Name'], 'ValueField': 'FullName', 'Generator': ZoneUniversalSearchGenerator });
        }
    }
    lSearch = new UniversalSearch(lSearchItems, null, lAdvancedSearching);
    lSearch.RenderContents($('#uUniversalSearchPanel'));
}

function universalSearch_UpdateData() {
    "use strict";
    $('#uUniversalSearchPanel').html('');
    universalSearch_Init();
}

function cacheItemsSystem_OnComplete(aCallbackFunction) {
    "use strict";
    var lState = mStateManager.getSystemState();
    var lAllowedDomain = "veritracks.com";

    if (document.domain.indexOf(lAllowedDomain) !== -1) {
        document.domain = "veritracks.com";
    }
    gIsSystemCacheLoaded = true;
    mActivityNotification.addNotification(localizeWrapper('cEnrolleeComplete'));
    if (lState.Tab === 'Dashboard' || (gUserDetails.Role == 2 && lState.Tab == 'Analysis')) {
        $('.CacheLoadRequired').fadeIn('slow');
        $('#uDashboardDefaultLoadingContainer').hide();
    } else {
        systemDisplay_Init();
    }
    if (!isNullOrUndefined(aCallbackFunction)) {
        aCallbackFunction();
    }

    applyUserPermissions([1, 2, 4, 7, 12, 22, 31, 36]);
    createSystemMessageCardView();
    if (CheckUserHasPermission(45) || gUserDetails.Role == 2) {
        preUniversalSearch_InitSetup();
        devicesUniversalLoad();
    } else {
        universalSearch_Init();
    }
  gMyAgentIds =getMyAgentIds(gUserDetails.UserId).join(',');
  mAppNotification= new ActivityNotification('app-notification',gMyAgentIds,{
    'APIFunction':GetAgentNotificationPending
  });
  setTimeout(function () {
        RedirecToSSOPath();
    },5000);
    
}


function preUniversalSearch_InitSetup() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    var lIdList = veritracks.system.clientSetting("organizationrestrictionlist") || "";

    if (lIdList == "NULL" || lIdList == "") {
        lIdList = [];
    }
    else if (lIdList.toString().includes(",")) {
        lIdList = lIdList.split(",").map(Number);
    } else {
        lIdList = [lIdList]
    }

    gUserDetails.OrganizationIds.forEach(function (id) { var index = lIdList.indexOf(id); if (index !== -1) { lIdList.splice(index, 1) } });

    if (lIdList.length > 0) {
        lBuilder.AddNewExpressionConditional('Id', lIdList, false, mRelationalOperatorEnum.NotIn(), mLogicalOperatorEnum.And());
    }

    ReadMultiple(gObjectList.Organization.AssemblyQualifiedName, lBuilder.RootExpression, 0, function (aParams, aData) {
        lBuilder.Clear()

        gUserDetails.ExtendedOrganizationIds = aData.map(function (organization) { return organization.Id });

        lBuilder.AddNewExpressionConditional("ArchiveFlag", "N", false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional("OrganizationId", gUserDetails.ExtendedOrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        mCache.bind("EnrolleesUniversalupdated", EnrolleesUniversal_OnUpdate);
        cacheItemUpdatable_Init('Enrollee', 'EnrolleesUniversal', gCacheSettings.EnrolleesUpdateInterval * 10, lBuilder.RootExpression, null, false, null);
    }, null, null, null, 0, false);
}

function devicesUniversalLoad() {
    var lBuilder = new SumoPredicateBuilder();
    lBuilder.AddNewExpressionConditional("ProductType", 2, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    mCache.bind("DevicesUniversalupdated", DevicesUniversal_OnUpdate);
    cacheItemUpdatable_Init('Device', 'DevicesUniversal', gCacheSettings.DevicesUpdateInterval * 10, lBuilder.RootExpression, null, false, null);

}
function checkAdvancedSearchIsNeeded(aTitle, aSelectedHash, aSelectedId) {
    "use strict";
    var lAdvancedNeeded = false,
        lDataItem,
        lFunc,
        lFuncName = aTitle + 'AdvancedDataPermissions';
    if (mAdvancedSearchAvailable.indexOf(aTitle) !== -1) {
        lDataItem = getDataItem(aSelectedId, aTitle);
        if (isNullOrUndefined(lDataItem)) {
            lAdvancedNeeded = true;
            lFunc = window[lFuncName];
            lFunc(aSelectedHash, aSelectedId);
        }
    }
    return lAdvancedNeeded;
}

function fixHashOffendersVictim(aId, aHash) {
    "use strict";
    var lEnrollee = getDataItem(aId, 'Enrollees');

    if (lEnrollee && lEnrollee.EnrolleeType == 2) {
        aHash = "#Enrollees.Victims.Profile.Events"
    }
    return aHash;
}
function cacheItemsInitial_OnComplete(aCallbackFunction) {
    "use strict";
    var lState = mStateManager.getSystemState();

    systemGenerateStaticData();   

    mCurrentHash = GetCurrentHash();

    if (gUserDetails.Role > 1) {
        if (!checkAccountStatus()) {
            systemDisplay_Init();
        }
    }
    else if (lState.Tab === 'Dashboard') {
        if (!checkAccountStatus()) {
            systemDisplay_Init();
        }
    } else {
        checkAccountStatus();
        systemCacheItems_Init();
    }
    if (!isNullOrUndefined(aCallbackFunction)) {
        aCallbackFunction();
    }
}

function checkAccountStatus() {
    var lStat = false;
    if (gUserDetails.AccountStatus == 'NEW' || gUserDetails.SecurityQuestionId == -1) {
        NewUserPopup();
        lStat = true;
    }
    else if (gUserDetails.AccountStatus == 'RESET') {
        ResetUserPopup();
        lStat = true;
    }
    else if (gUserDetails.AccountStatus == 'RESETPOLICY') {
        ResetUserPopup();
        lStat = false;
    }
    else if (gUserDetails.AccountStatus == 'EXPIRED' && gUserDetails.PasswordPolicy == 1) {
        ResetUserPopup();
        lStat = false;
    }
    else if (gUserDetails.AccountStatus == 'INACTIVE' && gUserDetails.PasswordPolicy == 1) {
        InactiveExpiredUserPopup('Inactive');
        lStat = true;
    }

    return lStat;
}

function log2fa() {
    veritracks.data.controller.Generate2FATotp(function (aParams, aData) {
        console.log(aData);
    });
}

function enable2fa(secret) {
    var code = $('#2facode').val();

    veritracks.data.controller.Enable2FA(secret, code, function (aParams, aData) {
        if (aData) {
            $('.PopupWindow .ButtonCommandBar').empty()

            var height = $('#uPopupContent').height()
            $('#2faAlert').hide()
            $('#2fasetup').fadeOut("slow", function (a) {
                $('#uPopupContent').height(height)
                $('#2fasetupcomplete').fadeIn("slow", function (a) {
                    dataObjectList_Init();
                    window.setTimeout(function () {
                        ClosePopup();
                    }, 2000)
                })
            })
        } else {
            $('#2faAlert').show()
        }
    },
    function (aParams, aData) {
        $('#2faAlert').show()
    })

}

function display2fa() {
    veritracks.data.controller.Generate2FactorAuthSecret(function (aParams, aData) {
        if (!aData) return;

        var username = gUserDetails.UserName
        var secret = aData
        var lButtonBar = GenerateButtonCommandBar();

        lButtonBar.append(GenerateButton('Enable 2FA', '', function () {
            enable2fa(secret)
        }));

        DisplayPopup("Two-Factor Authentication Setup", "<div id='u2fasetup'></div>", lButtonBar, true);

        populateElement("u2fasetup", "User.2fa.setup.htm", function (a, b) {
            $('#uQRCode2faImage').qrcode({
                render: 'image',
                size: 200,
                text: 'otpauth://totp/' + username + '?secret=' + secret + '&issuer=VeriTracks'
            })
        })
    }, null, null)
}

$(document).on("keypress", '#2facode', function (evt) {
    if (evt.keyCode < 48 || evt.keyCode > 57) {
        evt.preventDefault();
    } else {
        if ($('#2facode').val().length >= 6) {
            evt.preventDefault();
        }
    }
});

$(document).on("keyup", "#uUserDetailsPasswordEdit", function (e) {
    "use strict";
    var lPassword = $('#uUserDetailsPasswordEdit').val();
    showScoreCard('AgentUpdatePassword', getPasswordStrength(lPassword));
});

//-------------------
// Cache Init Process
//-------------------
function cacheItemLoadProgressBar_Increment() {
    "use strict";
    var lObjectsRemaining = mInitialDataObjectsPending + mSystemDataObjectsPending,
        lLoadingCounter = Math.round((1 - lObjectsRemaining / gInitObjects) * 100);
    if (lLoadingCounter >= 100) {
        lLoadingCounter = 100;
    }
    $(".DefaultLoadingBar").width(lLoadingCounter + '%');
}

function cacheItemUpdatable_OnLoad(aSender, aCacheItem, aParams) {
    "use strict";
    var lPredicateBuilder;
    mCache.unbind(aCacheItem.Name + 'updated', cacheItemUpdatable_OnLoad);
    cacheItemLoadProgressBar_Increment();
    if (!isNullOrUndefined(aParams.NotificationId)) {
        mActivityNotification.removeNotification(aParams.NotificationId);
    }
    if (--mSystemDataObjectsPending === 0) {
        cacheItemsSystem_OnComplete(aParams.CallbackFunction);
    }
    gItemsComplete.push(aCacheItem.Name);
    if (aCacheItem.Name === 'Devices') {
        AssignGlobalIds(gDeviceIds, aCacheItem, "Id");
        if (gDeviceIds.length == 0) {
            gDeviceIds.push(0);
        }
        lPredicateBuilder = new SumoPredicateBuilder();
        lPredicateBuilder.AddNewExpressionConditional('DeviceId', gDeviceIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        mCache.bind('DeviceLastContactupdated', DeviceLastContact_OnLoad, null);
        cacheItemUpdatable_Init('DeviceLastContact', 'DeviceLastContact', gCacheSettings.DeviceLastContactUpdateInterval, lPredicateBuilder.RootExpression, null, false, aParams.CallbackFunction);
        cacheItemUpdatable_Init('DeviceClusterDevice', 'DeviceClusterDevices', gCacheSettings.DeviceClusterDevicesUpdateInterval, lPredicateBuilder.RootExpression, null, false, aParams.CallbackFunction);
    }
}

function cacheItemInitialUpdatable_OnLoad(aSender, aCacheItem, aParams) {
    "use strict";
    var lPredicateBuilder = new SumoPredicateBuilder(),
        lCultureId = gUserDetails.CultureId;
    mCache.unbind(aCacheItem.Name + 'updated', cacheItemInitialUpdatable_OnLoad);
    mActivityNotification.removeNotification(aParams.NotificationId);
    cacheItemLoadProgressBar_Increment();
    mInitialDataObjectsPending--;
    if (aCacheItem.Name === 'Enrollees') {
        AssignGlobalIds(gEnrolleeIds, getCacheItem('Enrollees'), 'Id');
        // ENROLLEE SPECIFIC
        if (gEnrolleeIds.length > 0) {
            mCache.bind('EnrolleeLastContactupdated', EnrolleeLastContact_OnLoad, null);
            lPredicateBuilder.Clear();
            lPredicateBuilder.AddConditional(gNonErrorBuilder.RootExpression);
            lPredicateBuilder.AddNewExpressionConditional('EnrolleeId', gEnrolleeIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            cacheItemUpdatable_Init('EnrolleeLastContact', 'EnrolleeLastContact', gCacheSettings.EnrolleeLastContactUpdateInterval, lPredicateBuilder.RootExpression, null, false, null);
            lPredicateBuilder.Clear();
            lPredicateBuilder.AddNewExpressionConditional('Id', gEnrolleeIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            cacheItemUpdatable_Init('EnrolleeEventSummary', 'EnrolleeEventSummary', gCacheSettings.EnrolleeEventSummaryUpdateInterval, lPredicateBuilder.RootExpression, null, false, null);


            //lPredicateBuilder.Clear();
            //lPredicateBuilder.AddNewExpressionConditional('Id', gEnrolleeIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            //cacheItemUpdatable_Init('EnrolleeCorrelateMatch', 'EnrolleeCorrelateMatch', gCacheSettings.EnrolleesUpdateInterval, lPredicateBuilder.RootExpression, null, false, null);
        } else {
            mSystemDataObjectsPending -= 3;
        }
    }
    else if (aCacheItem.Name === 'Agents') {
        AssignGlobalIds(gAgentUserIds, aCacheItem, 'UserId');
        if (gAgentUserIds.length > 0) {
            lPredicateBuilder.Clear();
            lPredicateBuilder.AddNewExpressionConditional('OrganizationId', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            cacheItemUpdatable_Init('User', 'Users', gCacheSettings.UsersUpdateInterval, lPredicateBuilder.RootExpression, null, true);
        }
        else {
            mSystemDataObjectsPending -= 1;
        }
    }
    else if (aCacheItem.Name === 'UserPreference') {
        //FROM HERE <---- 
        var lPreferences = getUserPreferences(13),
            lPreference;
        if (count(lPreferences) > 0) {
            lPreference = lPreferences['CultureId'];
            if (!isNullOrUndefined(lPreference) && lPreference.Value != -1) {
                lCultureId = lPreference.Value;
            }
        }// <--- to HERe can be replaced by var lCultureId = UserHelper.getCultureId();
        lPredicateBuilder.Clear();
        lPredicateBuilder.AddNewExpressionConditional('CultureId', lCultureId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lPredicateBuilder.AddNewExpressionConditional('Id', 1018631, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
        cacheItemUpdatable_Init('Translation', 'Translation', gCacheSettings.OffenderSchedulesUpdateInterval, lPredicateBuilder.RootExpression, ['Name'], true);
        //Translate Time
        
    }
    else if (aCacheItem.Name === 'Translation') {
        veritracks.localization.localize('body');
    }

    gItemsComplete.push(aCacheItem.Name);
    if (mInitialDataObjectsPending === 0) {
        cacheItemsInitial_OnComplete(aParams.CallbackFunction);
    }
}

function cacheItemUpdatable_Init(aObjectType, aCacheItemName, aUpdateIntervalInSeconds, aExpression, aHashColumns, aIsInitialObject, aCallbackFunction, aIsNonCached, aNonCachedExpression) {
    "use strict";
    var lType,
        lNotificationId = mActivityNotification.addNotification(localizeWrapper('cEnrolleeLoading') + ': ' + aCacheItemName + '.', null, gSystemSettings.IsDebug);

    if (!isNullOrUndefined(gObjectList[aObjectType])) {
        lType = gObjectList[aObjectType].AssemblyQualifiedName;
    } else {
        console.log(gObjectList)
        throw (aObjectType + ' not found in cache item list.');
    }

    if (aIsInitialObject) {
        mCache.bind(aCacheItemName + 'updated', cacheItemInitialUpdatable_OnLoad, { 'NotificationId': lNotificationId, 'CallbackFunction': aCallbackFunction });
    } else {
        mCache.bind(aCacheItemName + 'updated', cacheItemUpdatable_OnLoad, { 'NotificationId': lNotificationId, 'CallbackFunction': aCallbackFunction });
    }
    mCache.AddUpdatableItem(aCacheItemName,
                            lType,
                            aExpression,
                            aUpdateIntervalInSeconds,
                            null,
                            null,
                            true,
                            aHashColumns,
                            aIsNonCached,
                            aNonCachedExpression);
    gItemsInited.push(aObjectType);
}

function cacheItemExpirable_OnFailure(aParams, a, b, c) {
    "use strict";
    mActivityNotification.addNotification(localizeWrapper('cEnrolleeLoading') + ': ' + aParams.ObjectType + ' failed.');
}

function cacheItemExpirable_OnSuccess(aParams, aData) {
    "use strict";
    var lList = [],
        i;
    if (aParams.DoHash) {
        for (i = 0; i < aData.length; i++) {
            var lObject = aData[i];
            lList[lObject.Id] = lObject;
        }
        mCache.AddExpirableItem(lList, aParams.CacheName, aParams.ExpireLength, true, null);
    } else {
        mCache.AddExpirableItem(aData, aParams.CacheName, aParams.ExpireLength, true, null);
    }
    cacheItemLoadProgressBar_Increment();
    mActivityNotification.removeNotification(aParams.NotificationId);
    if (--mSystemDataObjectsPending === 0) {
        cacheItemsSystem_OnComplete(aParams.CallbackFunction);
    }
    if (aParams.CacheName == "Culture")
        aParams.CallbackFunction();
    gItemsComplete.push(aParams.CacheName);
}

function cacheItemInitialExpirable_OnSuccess(aParams, aData) {
    "use strict";
    var lList = [],
        i;

    if (aParams.DoHash) {
        for (i = 0; i < aData.length; i++) {
            var lObject = aData[i];
            lList[lObject.Id] = lObject;
        }
        mCache.AddExpirableItem(lList, aParams.CacheName, aParams.ExpireLength, true, null);
    } else {
        mCache.AddExpirableItem(aData, aParams.CacheName, aParams.ExpireLength, true, null);
    }
    cacheItemLoadProgressBar_Increment();
    mActivityNotification.removeNotification(aParams.NotificationId);
    mInitialDataObjectsPending--;
    if (mInitialDataObjectsPending === 0) {
        cacheItemsInitial_OnComplete(aParams.CallbackFunction);
    }
    gItemsComplete.push(aParams.CacheName);
}

function cacheItemExpirable_Init(aObjectType, aCacheName, aExpireLength, aDoHash, aIsInitialObject, aCallbackFunction, aExpression) {
    "use strict";
    var lParams = {
        'ObjectType': aObjectType,
        'CacheName': aCacheName,
        'ExpireLength': aExpireLength,
        'NotificationId': mActivityNotification.addNotification(localizeWrapper('cEnrolleeLoading') + ': ' + aCacheName + '.', null, gSystemSettings.IsDebug),
        'DoHash': isNullOrUndefined(aDoHash) || aDoHash === true,
        'CallbackFunction': aCallbackFunction
    };
    if (isNullOrUndefined(gObjectList[aObjectType])) {
        console.log(aObjectType);
        console.log(gObjectList[aObjectType]);
    }
    gItemsInited.push(aObjectType);
    if (aIsInitialObject) {
        ReadMultiple(gObjectList[aObjectType].AssemblyQualifiedName, aExpression, 0, cacheItemInitialExpirable_OnSuccess, cacheItemExpirable_OnFailure, lParams, null, 0, false);
    } else {
        ReadMultiple(gObjectList[aObjectType].AssemblyQualifiedName, aExpression, 0, cacheItemExpirable_OnSuccess, cacheItemExpirable_OnFailure, lParams, null, 0, false);
    }
}



//------------------
// Data Load Process
//------------------
function systemCacheItems_Init(aSender, aNothing, aCallbackFunction) {
    "use strict";

    var lPredicateBuilder = new SumoPredicateBuilder();
    if (!isNullOrUndefined(gDashboardPage)) {
        gDashboardPage.unbind('render', systemCacheItems_Init);
    }
    if (mSystemDataObjectsPending > 0) {
        if (gUserDetails.OrganizationIds.length > 0) {
            // ORGANIZATION SPECIFIC
            lPredicateBuilder = new SumoPredicateBuilder();
            lPredicateBuilder.AddNewExpressionConditional('OrganizationId', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            cacheItemUpdatable_Init('Device', 'Devices', gCacheSettings.DevicesUpdateInterval, lPredicateBuilder.RootExpression, null, false, aCallbackFunction);
            //     lPredicateBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            cacheItemUpdatable_Init('DeviceCluster', 'DeviceClusters', gCacheSettings.DeviceClustersUpdateInterval, lPredicateBuilder.RootExpression, null, false, aCallbackFunction);
            lPredicateBuilder.Clear();
            lPredicateBuilder.AddNewExpressionConditional('UserId', gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            //cacheItemUpdatable_Init('Tag', 'Tag', gCacheSettings.TagUpdateInterval, lPredicateBuilder.RootExpression, ['Id', 'UserPreferenceType', 'ColumnName'], false, aCallbackFunction);
            //cacheItemUpdatable_Init('Tag', 'Tag', gCacheSettings.TagUpdateInterval, lPredicateBuilder.RootExpression, null, false, aCallbackFunction);

            if (gUserDetails.Role !== 2 && !gUserDetails.RegionalOri) {
                lPredicateBuilder.Clear();
                lPredicateBuilder.AddConditional(gNonErrorBuilder.RootExpression);
                lPredicateBuilder.AddNewExpressionConditional('OrganizationId', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
                lPredicateBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                cacheItemUpdatable_Init('Zone', 'Zones', gCacheSettings.ZonesUpdateInterval, lPredicateBuilder.RootExpression, null, false, aCallbackFunction);

                lPredicateBuilder.Clear();
                lPredicateBuilder.AddConditional(gNonErrorBuilder.RootExpression);
                lPredicateBuilder.AddNewExpressionConditional('OrganizationId', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
                lPredicateBuilder.AddNewExpressionConditional('ArchiveFlag', mArchivedFlag, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                cacheItemUpdatable_Init('Event', 'Events', gCacheSettings.EventsUpdateInterval, lPredicateBuilder.RootExpression, null, false, null);
            } else {
                mInitialDataObjectsPending = mInitialDataObjectsPending - 2;
                mSystemDataObjectsPending = mSystemDataObjectsPending - 2;
            }

            lPredicateBuilder.Clear();
            lPredicateBuilder.AddNewExpressionConditional('OrganizationId', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());

            cacheItemUpdatable_Init('ReportSchedule', 'ReportSchedules', gCacheSettings.OffenderSchedulesUpdateInterval, lPredicateBuilder.RootExpression, null, false, aCallbackFunction);


            lPredicateBuilder.Clear();
            lPredicateBuilder.AddConditional(gNonErrorBuilder.RootExpression);
            lPredicateBuilder.AddNewExpressionConditional('OrganizationId', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            lPredicateBuilder.AddNewExpressionConditional('EndDate', (new Date(9000, 11, 30)), false, mRelationalOperatorEnum.GreaterThan(), mLogicalOperatorEnum.And());
            mCache.bind('CurrentDeviceAssignmentsupdated', currentDeviceAssignment_OnLoad, null);
            cacheItemUpdatable_Init('DeviceAssignment', 'CurrentDeviceAssignments', gCacheSettings.CurrentDeviceAssignmentsUpdateInterval, lPredicateBuilder.RootExpression, ['Id', 'EnrolleeId'], false, aCallbackFunction);

            lPredicateBuilder.Clear();

            lPredicateBuilder.AddNewExpressionConditional('IsActive', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            cacheItemUpdatable_Init('OrganizationAddress', 'OrganizationAddress', 5000, lPredicateBuilder.RootExpression, null, false, aCallbackFunction);

            //lPredicateBuilder.Clear();
            //cacheItemUpdatable_Init('ScheduleType', 'ScheduleType', 5000, lPredicateBuilder.RootExpression, null, false, aCallbackFunction);

            // EXPIRABLE
            cacheItemExpirable_Init('Race', 'Race', 0, true, false, aCallbackFunction);
            cacheItemExpirable_Init('Color', 'Color', 0, true, false, aCallbackFunction);
            cacheItemExpirable_Init('Gender', 'Gender', 0, true, false, aCallbackFunction);
            cacheItemExpirable_Init('RfRange', 'RfRange', 0, true, false, aCallbackFunction);
            cacheItemExpirable_Init('Offense', 'Offense', 0, true, false, aCallbackFunction);
            //cacheItemExpirable_Init('Product', 'Products', 0, true, false, aCallbackFunction);
            cacheItemExpirable_Init('ZoneType', 'ZoneType', 0, true, false, aCallbackFunction);
            cacheItemExpirable_Init('HitLevel', 'HitLevel', 0, true, false, aCallbackFunction);
            cacheItemExpirable_Init('ZoneShape', 'ZoneShape', 0, true, false, aCallbackFunction);
            cacheItemExpirable_Init('ZoneScope', 'ZoneScope', 0, true, false, aCallbackFunction);
            cacheItemExpirable_Init('MetaEvent', 'MetaEvents', 0, true, false, aCallbackFunction);
            cacheItemExpirable_Init('SexOffense', 'SexOffense', 0, true, false, aCallbackFunction);
            cacheItemExpirable_Init('OffenderPhotoType', 'OffenderPhotoType', 0, true, false, aCallbackFunction);
            lPredicateBuilder.Clear();
            lPredicateBuilder.AddNewExpressionConditional('IsActive', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            cacheItemExpirable_Init('DeviceMode', 'DeviceModes', 0, true, false, aCallbackFunction, lPredicateBuilder.RootExpression);

            cacheItemExpirable_Init('AddressType', 'AddressType', 0, true, false, aCallbackFunction);
            cacheItemExpirable_Init('ScheduleType', 'ScheduleType', 0, true, false, aCallbackFunction);
            cacheItemExpirable_Init('OrganizationAddressType', 'OrganizationAddressType', 0, true, false, aCallbackFunction);
            cacheItemExpirable_Init('VehicleMake', 'VehicleMake', 0, true, false, aCallbackFunction);
            cacheItemExpirable_Init('VehicleColor', 'VehicleColor', 0, true, false, aCallbackFunction);
            cacheItemExpirable_Init('DeviceStatus', 'DeviceStatuses', 0, true, false, aCallbackFunction);

            cacheItemExpirable_Init('SupervisionType', 'SupervisionType', 0, true, false, aCallbackFunction);
            cacheItemExpirable_Init('NotificationType', 'NotificationType', 0, true, false, aCallbackFunction);
            cacheItemExpirable_Init('SecurityQuestion', 'SecurityQuestions', 0, true, false, aCallbackFunction);
            cacheItemExpirable_Init('MetricMetaEvent', 'MetricMetaEvent', 0, false, false, aCallbackFunction);
            cacheItemExpirable_Init('MetaEnrolleeCategory', 'MetaEnrolleeCategory', 0, true, false, aCallbackFunction);
            cacheItemExpirable_Init('DeviceChangeReason', 'DeviceChangeReason', 0, false, false, aCallbackFunction);
            cacheItemExpirable_Init('EventGroup', 'EventGroup', 0, true, false, aCallbackFunction);

            cacheItemExpirable_Init('ReportScheduleDate', 'ReportScheduleDates', 0, true, false, aCallbackFunction);
            cacheItemExpirable_Init('ReportScheduleTimeSpan', 'ReportScheduleTimeSpans', 0, true, false, aCallbackFunction);
            cacheItemExpirable_Init('ReportScheduleTime', 'ReportScheduleTimes', 0, true, false, aCallbackFunction);
            cacheItemExpirable_Init('EmailFormat', 'EmailFormats', 0, true, false, aCallbackFunction);
            lPredicateBuilder.Clear();
            lPredicateBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            cacheItemExpirable_Init('Product', 'Products', 0, true, false, aCallbackFunction, lPredicateBuilder.RootExpression);

            lPredicateBuilder.Clear();
            cacheItemExpirable_Init('UserContactMethod', 'UserContactMethod', 0, true, false, aCallbackFunction); //4.3
            cacheItemExpirable_Init('UserContactFormat', 'UserContactFormat', 0, true, false, aCallbackFunction);
            //lPredicateBuilder.AddNewExpressionConditional('DisplayType', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            cacheItemExpirable_Init('MetricType', 'MetricType', 0, true, false, aCallbackFunction, lPredicateBuilder.RootExpression);


            cacheItemExpirable_Init('ProcessStatus', 'ProcessStatus', 0, true, false, aCallbackFunction);
            cacheItemExpirable_Init('ClearedException', 'ClearedException', 0, true, false, aCallbackFunction);
            cacheItemExpirable_Init('Disposition', 'Disposition', 0, true, false, aCallbackFunction);

            //mCache.bind('ClientSettingadded', ClientSetting_OnLoad);
            //cacheItemExpirable_Init('ClientSetting', 'ClientSetting', 0, true, false, aCallbackFunction);
        } else {
            throw ('User does not have access to any Organizations.');
        }
    }

}

function initialCacheItems_Init() {
    "use strict";
    var lPredicateBuilder = new SumoPredicateBuilder();
    var lBrowser = get_browser() + get_browser_version();
    gNonErrorBuilder.AddNewExpressionConditional('Id', 0, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());


    lPredicateBuilder.Clear();
    lPredicateBuilder.AddNewExpressionConditional('UserId', gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lPredicateBuilder.AddNewExpressionConditional('ColumnName', 'MapDatePicker', false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
    lPredicateBuilder.AddNewExpressionConditional('ColumnName', 'StartDateUTC', false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
    lPredicateBuilder.AddNewExpressionConditional('ColumnName', 'StopDateUTC', false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());

    if ($.inArray(lBrowser, ["MSIE9"]) != -1) {
        lPredicateBuilder.AddNewExpressionConditional('UserPreferenceType', 5, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
    }
    //cacheItemUpdatable_Init('UserPreference', 'UserPreference', gCacheSettings.UserPreferenceUpdateInterval, lPredicateBuilder.RootExpression, ['UserId', 'UserPreferenceType', 'ColumnName'], true);
    cacheItemUpdatable_Init('UserPreference', 'UserPreference', gCacheSettings.UserPreferenceUpdateInterval, lPredicateBuilder.RootExpression, ['Id', 'UserPreferenceType', 'ColumnName'], true);

    if (gUserDetails.OrganizationIds.length > 0) {
        lPredicateBuilder.Clear();
        lPredicateBuilder.AddNewExpressionConditional('Id', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        cacheItemUpdatable_Init('Organization', 'Organizations', gCacheSettings.OrganizationsUpdateInterval, lPredicateBuilder.RootExpression, null, true);

        lPredicateBuilder.Clear();
        lPredicateBuilder.AddNewExpressionConditional('Id', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        cacheItemUpdatable_Init('OrganizationProperty', 'OrganizationProperty', 60000, lPredicateBuilder.RootExpression, ['Id', 'Name'], true);

        lPredicateBuilder.Clear();
        lPredicateBuilder.AddConditional(gNonErrorBuilder.RootExpression);
        lPredicateBuilder.AddNewExpressionConditional('DisplayType', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lPredicateBuilder.AddNewExpressionConditional('OrganizationId', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lPredicateBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        cacheItemUpdatable_Init('Agent', 'Agents', gCacheSettings.AgentsUpdateInterval, lPredicateBuilder.RootExpression, null, true);

        lPredicateBuilder.Clear();
        lPredicateBuilder.AddNewExpressionConditional('OrganizationId', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        cacheItemUpdatable_Init('RiskLevel', 'RiskLevels', gCacheSettings.RiskLevelUpdateInterval, lPredicateBuilder.RootExpression, ['Id', 'OrganizationId'], true);

        lPredicateBuilder.Clear();
        lPredicateBuilder.AddConditional(gNonErrorBuilder.RootExpression);
        mCache.bind('Enrolleesupdated', EnrolleesUpdated_OnUpdate, null);
        lPredicateBuilder.AddNewExpressionConditional('OrganizationId', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lPredicateBuilder.AddNewExpressionConditional('ArchiveFlag', mArchivedFlag, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        cacheItemUpdatable_Init('Enrollee', 'Enrollees', gCacheSettings.EnrolleesUpdateInterval, lPredicateBuilder.RootExpression, null, true);

        lPredicateBuilder.Clear();
        // fix for .STOP accounts.
        lPredicateBuilder.AddNewExpressionConditional('DisplayType', 2, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lPredicateBuilder.AddNewExpressionConditional('OrganizationId', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        cacheItemUpdatable_Init('Agent', 'AgentsStop', gCacheSettings.StopAgentsUpdateInterval, lPredicateBuilder.RootExpression, null, true);

        //lPredicateBuilder.Clear();
        //lPredicateBuilder.AddNewExpressionConditional('OrganizationId', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        //lPredicateBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        //cacheItemUpdatable_Init('OffenderAlcoholSchedule', 'OffenderAlcoholSchedules', gCacheSettings.OffenderSchedulesUpdateInterval, lPredicateBuilder.RootExpression, null, true);

        // lPredicateBuilder.Clear();
        //lPredicateBuilder.AddNewExpressionConditional('OrganizationId', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        //lPredicateBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        // cacheItemUpdatable_Init('OffenderAlcoholImage', 'OffenderAlcoholImages', gCacheSettings.OffenderSchedulesUpdateInterval, lPredicateBuilder.RootExpression, null, true);


        getOffenderLastTestByUser();

        GetIcons([], 1, function (aParams, aIconData) {
            var lIconsData = [];

            for (var lIconKey in aIconData) {
                if (aIconData.hasOwnProperty(lIconKey)) {
                    lIconsData[aIconData[lIconKey].Id] = aIconData[lIconKey];
                }
            }
            mEnrolleesIcon.icons = lIconsData;
            mInitialDataObjectsPending--;
            if (mInitialDataObjectsPending === 0) {
                cacheItemsInitial_OnComplete();
            }
        });


        setProcUpdateInterval(getOffenderLastTestByUser, 3600 * 5);

        lPredicateBuilder.Clear();
        lPredicateBuilder.AddNewExpressionConditional('OrganizationId', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lPredicateBuilder.AddNewExpressionConditional('EndDate', (new Date(9000, 11, 30)), false, mRelationalOperatorEnum.GreaterThan(), mLogicalOperatorEnum.And());
        lPredicateBuilder.AddNewExpressionConditional('AlcoholDeviceId', 0, false, mRelationalOperatorEnum.GreaterThan(), mLogicalOperatorEnum.And());
        cacheItemUpdatable_Init('DeviceAssignment', 'AlcoholDeviceAssignments', gCacheSettings.OffenderSchedulesUpdateInterval, lPredicateBuilder.RootExpression, null, true);

        // moved this here since no longer using local object.
        cacheItemExpirable_Init('TimeZone', 'TimeZone', 0, true, true, null);
        cacheItemExpirable_Init('BatteryLevel', 'BatteryLevel', 0, true, true, null);
        cacheItemExpirable_Init('Permission', 'Permissions', 0, true, true, null, null);
        cacheItemExpirable_Init('UserRole', 'UserRoles', 0, true, true, null, null);
        // cacheItemExpirable_Init('RolePermissionMembership', 'RolePermissionMemberships', 0, true, true, null, null);
        cacheItemExpirable_Init('UserRoleValueType', 'UserRoleValueTypes', 0, true, true, null, null);
        cacheItemExpirable_Init('Language', 'Languages', 0, true, true, null, null);
        cacheItemExpirable_Init('VictimRiskLevel', 'VictimRiskLevels', 0, true, true, null, null);

        //Load Culture 
        cacheItemExpirable_Init('Culture', 'Culture', 0, true, false, function () {
            //On Success Culture Cache
            const lSelectedLanguage = UserHelper.getSelectedLanguage().toLowerCase();
            console.log('lSelectedLanguage',lSelectedLanguage);
            //Translate ptTimeSelect
            // if (lSelectedLanguage == 'ES') {
            console.log(ptTimeSelectRegional[lSelectedLanguage], lSelectedLanguage);
            $.ptTimeSelect.options = ptTimeSelectRegional[lSelectedLanguage];
            console.log($.ptTimeSelect.options);
            // }
            // i18n - TimePicker
            // i18n - DatePicker
            const value = lSelectedLanguage === 'en' ? '' : lSelectedLanguage;
            $.datepicker.setDefaults($.datepicker.regional[value]);
            // } 
        }, null);

    } else {
        throw ('User does not have access to any Organizations.');
    }
}

function dataObjectList_OnSuccess(aParams, aData) {
    "use strict";
    var i,
        lObject;
    if (isNullOrUndefined(gUserDetails)) {
        mActivityNotification.addNotification(localizeWrapper('cAgentSessionExpiredMessage'));
        veritracks.system.redirectToLogin();
        return 0;
    }

    for (i = 0; i < aData.length; i++) {
        lObject = aData[i];
        gObjectList[lObject.ShortName] = lObject;
    }
    gObjectList.EventHistory = new DataItem('EventHistory');
    gObjectList.Trackpoint = new DataItem('Trackpoint');
    gObjectList.TrackpointHistory = new DataItem('TrackpointHistory');
    gObjectList.DeviceGpsStatus = new DataItem('DeviceGpsStatus');
    gObjectList.DeviceAssignment = new DataItem('DeviceAssignment');
    gObjectList.VisitSuggestion = new DataItem('VisitSuggestion');
    gObjectList.PointGrouping = new DataItem('PointGrouping');
    gObjectList.TagVisitLink = new DataItem('TagVisitLink');
    gObjectList.OffenderSchedule = new DataItem('OffenderSchedule');
    gObjectList.OffenderAlcoholImage = new DataItem('OffenderAlcoholImage');
    gObjectList.ReportSchedule = new DataItem('ReportSchedule');
    gObjectList.ReportScheduleFilter = new DataItem('ReportScheduleFilter');
    gObjectList.ReportScheduleEmail = new DataItem('ReportScheduleEmail');
    gObjectList.OffHoursSchedule = new DataItem('OffHoursSchedule');
    gObjectList.Address = new DataItem('Address');
    gObjectList.Tag = new DataItem('Tag');
    gObjectList.IncidentMatchTrackpoint = new DataItem('IncidentMatchTrackpoint');
    gObjectList.IncidentMatch = new DataItem('IncidentMatch');
    gObjectList.BluHomeConfiguration = new DataItem('BluHomeConfiguration');
    gObjectList.IncidentSearch = new DataItem('IncidentSearch');
    gObjectList.BluPlusConfiguration = new DataItem('BluPlusConfiguration');
    gObjectList.DeviceRapidReporting = new DataItem('DeviceRapidReporting');
    gObjectList.OrganizationRiskLevel = new DataItem('OrganizationRiskLevel');
    gObjectList.OriZoneClassification = new DataItem('OriZoneClassification');
    gObjectList.ClientSetting = new DataItem('ClientSetting');
    gObjectList.OriParent = new DataItem('OriParent');
    gObjectList.EnrolleeContactHistory = new DataItem('EnrolleeContactHistory');
    gObjectList.EnrolleeAlternateContact = new DataItem('EnrolleeAlternateContact');
    gObjectList.UserRole = new DataItem('UserRole');
    gObjectList.UserRoleValueType = new DataItem('UserRoleValueType');
    gObjectList.ZoneVertex = new DataItem('ZoneVertex');
    gObjectList.ReportInstance = new DataItem('ReportInstance');
    gObjectList.DeviceAction = new DataItem('DeviceAction');
    //gObjectList.RolePermissionMembership = new DataItem('RolePermissionMembership');
    gObjectList.OffenderPhotos = new DataItem("OffenderPhoto");
    gObjectList.OffenderPhotoType = new DataItem("OffenderPhotoType");
    gObjectList.Language = new DataItem('Language');
    gObjectList.Translation = new DataItem('Translation');
    gObjectList.VictimProfile = new DataItem('VictimProfile');
    gObjectList.EnrolleeTimeline = new DataItem('EnrolleeTimeline');
    gObjectList.EnrolleeCorrelateMatch = new DataItem('EnrolleeCorrelateMatch');
    gObjectList.EnrolleePriorVisit = new DataItem('EnrolleePriorVisit');
    gObjectList.EnrolleeFrp = new DataItem("EnrolleeFrp");
    gObjectList.OrganizationAddress = new DataItem("OrganizationAddress");
    gObjectList.OrganizationProperty = new DataItem("OrganizationProperty");
    gObjectList.EnrolleeLastPosition = new DataItem("EnrolleeLastPosition");
    gObjectList.OffenderAlcoholSchedule = new DataItem("OffenderAlcoholSchedule");
    gObjectList.OffenderAlcoholSchedBlock = new DataItem("OffenderAlcoholSchedBlock");
    gObjectList.OffenderAlcoholTestResult = new DataItem("OffenderAlcoholTestResult");
    gObjectList.EnrolleeAssociationThread = new DataItem("EnrolleeAssociationThread");

    gObjectList.ReportScheduleDate = new DataItem("ReportScheduleDate");
    gObjectList.ReportScheduleTime = new DataItem("ReportScheduleTime");
    gObjectList.OrganizationAddressType = new DataItem("OrganizationAddressType");
    gObjectList.ReportScheduleTimeSpan = new DataItem("ReportScheduleTimeSpan");
    gObjectList.EmailFormat = new DataItem("EmailFormat");

    gObjectList.OffenderAlcoholSchedNote = new DataItem('OffenderAlcoholSchedNote');
    gObjectList.UserContactFormat = new DataItem('UserContactFormat');
    gObjectList.SobertrackNotification = new DataItem('SobertrackNotification');
    gObjectList.User = new DataItem('UserAgent');
    gObjectList.VictimRiskLevel = new DataItem('VictimRiskLevel');
    //gObjectList.UserAgent = new DataItem('UserAgent');
    initialCacheItems_Init();



    //lBuilder.AddNewExpressionConditional('Id', 58, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    //ReadMultiple(gObjectList.ClientSetting.AssemblyQualifiedName, lBuilder.RootExpression, 0, ClientSettingRead_Success, null, {}, null, 0, false);
}

function dataObjectList_OnFailure(aParams, a, b, c) {
    "use strict";
    mActivityNotification.addNotification(localizeWrapper('cDefaultCacheErrorRetry'));
    window.setTimeout(dataObjectList_Init, 10000);
}

function dataObjectList_Init() {
    "use strict";
    GetObjectList(dataObjectList_OnSuccess, dataObjectList_OnFailure, mActivityNotification.addNotification('Loading Cached Items', null, gSystemSettings.IsDebug));
}

// super ori enabled
//function OriParentRead_Success(aParams, aData) {
//    "use strict";
//    mParentOri = aData;
//    //uUserOrganizationsLoggedInto();

//}


function uEnabledSuperOri() {
    "use strict";
    // if (gUserDetails.AvailableOrganizationIds.length !== gUserDetails.OrganizationIds.length) {
    if (mEnabledSuperOri) {
        $('.CurrentOri').show();
    }
    else {
        $('.SuperUser').show();
    }
    // }
}

function uUserOrganizationsLoggedInto() {
    "use strict";
    var lList = OrganizationSortFormatter(),
        lKey,
        lCount = 0,
        lSuperOri = 0,
        lBuilder = new SumoPredicateBuilder();

    lBuilder.AddNewExpressionConditional('Id', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lList = query(lList, lBuilder.RootExpression);
    ReadMultiple(gObjectList.OriParent.AssemblyQualifiedName, null, 0, PopulateOrganizationHover, null, {}, null, 0, false);

    function PopulateOrganizationHover(aParams, aData) {

        mParentOri = aData;
        if (mEnabledSuperOri) {
            setParentOri(gUserDetails.OrganizationIds);
            lSuperOri = mCurrentSuperOri;
            // find selected parent ori
            for (lKey in lList) {
                if (lList.hasOwnProperty(lKey)) {
                    if (lList[lKey].Id == lSuperOri) {
                        var lTemp = lList[lKey];
                        lList.splice(lKey, 1);
                        lList.unshift(lTemp);
                    }
                }
            }
        }

        for (lKey in lList) {
            if (lList.hasOwnProperty(lKey)) {
                if (lSuperOri == lList[lKey].Id) {
                    $('#uCurrentOrganizationsGlobal').append('<li><strong>' + lList[lKey].Name + '</strong></li>');
                } else {
                    $('#uCurrentOrganizationsGlobal').append('<li>' + lList[lKey].Name + '</li>');
                }
                lCount++;
            }
        }
    }
}

function uUserOrganizationsHoverOn() {
    $('#uCurrentOrganizationsGlobal').show('fast');
}

function uUserOrganizationsHoverOff() {
    $('#uCurrentOrganizationsGlobal').hide('fast');
}

function TrainingOn() {
    $('.CurrentTraining').show('fast');
}

function TrainingOff() {
    $('.CurrentTraining').hide('fast');
}

function preDashBoardCheck() {
    var lRole = gUserDetails.Role;

    // is top level cdcr user
    if (IsOriLimited())
        lRole = 3;

    mStateManager.setUserRole(lRole);
}

function userDetailsData_OnComplete(aParams, aData) {
    "use strict";
    var lItem,
        lKey,
        lRole = 1;
    gUserDetails = aData;
    // enhanced crime analyst mock. remove after testing is completed!!!
    //gUserDetails.Role = 2;
    lRole = gUserDetails.Role;

    // is top level cdcr user
    if (IsOriLimited())
        lRole = 3;

    mStateManager.setUserRole(lRole);

    if (gUserDetails.FullName !== '') {
        $('#uHeaderUserName').text(gUserDetails.FullName);
        $('.MyAccount').click(function () {
            window.location.hash = 'Agents.Agents.Profile.' + gUserDetails.UserId;
        });
    }
    //  if (gUserDetails.AvailableOrganizationIds.length !== gUserDetails.OrganizationIds.length) {
    if (gUserDetails.Role != 2) {
        $('.SuperUser').show();
    }
    $('.CurrentOri').show();
    $('#uCurrentOrganizationsChange').hover(uUserOrganizationsHoverOn, uUserOrganizationsHoverOff);
    $('#CurrentTrainingChange').hover(TrainingOn, TrainingOff);
    //   }
    gUserPermissions = [];
    for (lKey in gUserDetails.UserPermissions) {
        if (gUserDetails.UserPermissions.hasOwnProperty(lKey)) {
            lItem = gUserDetails.UserPermissions[lKey];
            gUserPermissions[lItem.PermissionId] = lItem;
        }

    }

    mEnabledSuperOri = veritracks.system.clientSetting("EnableSuperOri");
    AccountExpiryCheck();
    writeUserTranactionLoginInfo();

    veritracks.data.controller.Is2FARequired(function (aParams, aData) {
        if (aData) {
            display2fa();
        } else {
            dataObjectList_Init();
        }
    }, null);
}

function LogOutUsers() {
    var lToken = veritracks.security.controller.tryGetSecurityToken();
    callAjax('LogOutUsers', { 'aSecurityToken': lToken }, LogOutUsers_OnSuccess, null, null);
    ClosePopup();
}

function LogOutUsers_OnSuccess(aParams, aData) {
    "use strict";
    gUserDetails = aData;
}

function userDetailsData_OnFailure(aParams, a, b, c) {
    "use strict";
    //alert('fail getting user details');
}

function userDetailsData_Init() {
    "use strict";
    var lToken = veritracks.security.controller.tryGetSecurityToken();
    callAjax('GetUserDetails', { 'aSecurityToken': lToken }, userDetailsData_OnComplete, userDetailsData_OnFailure, null);
}

function clientParentOriEnabled_Init() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        clientSetting = new DataItem('ClientSetting');

    lBuilder.AddNewExpressionConditional('Id', 58, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(clientSetting.AssemblyQualifiedName, lBuilder.RootExpression, 0, ClientSettingRead_Success, null, {}, null, 0, false);
}


function clientSettings_Init() {
    "use strict";
    gObjectList.ClientSetting = new DataItem('ClientSetting');

    mCache.bind('ClientSettingadded', ClientSetting_OnLoad);
    cacheItemExpirable_Init('ClientSetting', 'ClientSetting', 0, true, false);

}


function ClientSetting_OnLoad(aSender, aCacheItem, aParams) {
    var lData = {},
        lName,
        lItem,
        lKey;

    for (lKey in aCacheItem.Data) {
        if (aCacheItem.Data.hasOwnProperty(lKey)) {
            lItem = aCacheItem.Data[lKey];
            lName = lItem.Description;
            while (lName.indexOf('_') !== -1) {
                lName = lName.replace('_', '');
            }
            veritracks.system.formatData(lItem, 'Value', 'DisplayType');

            lData[lName] = lItem;
        }
    }
    veritracks.system.data.clientSettings = lData;


    var lEnabled = veritracks.system.clientSetting('EnableSessionTimeout') >= 1 ? true : false;
    veritracks.security.controller.EnableTimer(lEnabled);
    veritracks.security.controller.startTimer();
    userDetailsData_Init();
}

function ClientSettingRead_Success(aParams, aData) {
    "use strict";
    var lData = aData[0];
    if (!isNullOrUndefined(lData)) {
        mEnabledSuperOri = parseInt(lData.Value);
    }
    userDetailsData_Init();
}
function webServiceConnection_OnComplete(aParams, aData) {
    "use strict";
    if (aData.IsInitialized) {
        mActivityNotification.removeNotification(aParams);
        mActivityNotification.addNotification('Server ready.', null, gSystemSettings.IsDebug);
        clientSettings_Init();
    } else {
        veritracks.system.redirectToLogin();
    }
}

function webServiceConnection_OnFailure(aParams, a, b, c) {
    "use strict";
    mActivityNotification.addNotification(localizeWrapper('cDefaultServerErrorRetry'));
    window.setTimeout(function () { webServiceConnection_Init(a); }, 5000);
}

function webServiceConnection_Init(aNotificationId) {
    "use strict";
    var lNotificationId;
    if (aNotificationId === -1) {
        lNotificationId = mActivityNotification.addNotification('Communicating with server.', true, gSystemSettings.IsDebug);
    } else {
        lNotificationId = aNotificationId;
    }

    callAjax('GetStatus', null, webServiceConnection_OnComplete, webServiceConnection_OnFailure, lNotificationId);

}


var mIsNatural = true;
//--------------------
// System Load Process
//--------------------
function systemObject_Init() {
    "use strict";

    // extends the session every time you click or type. also prevents form post on enter.
    $(window).keydown(function (event) {
        if (event.keyCode == 13) {
            event.preventDefault();
            $(".FilterControlExpander").each(function (index) {
                var lExpander = $(".FilterControlExpander")[index];
                var lButton = lExpander.id.replace("Expander", "FilterButton");
                if ($("#" + lExpander.id).css("display") != "none") {
                    $("#" + lButton).click();
                }
            });

            return false;
        } else if (event.keyCode == 27) {

            $(".FilterControlExpander").each(function (index) {
                var lExpander = $(".FilterControlExpander")[index];
                var lHeader = lExpander.id.replace("Expander", "Header");
                if ($("#" + lExpander.id).css("display") != "none") {
                    $("#" + lHeader).click();
                }
            });

        }
        veritracks.security.controller.extendSession();
    }).click(function (event) {
        veritracks.security.controller.extendSession();
    });

    mStateManager = new SumoStateManager('mStateManager');
    gRequestManager = new RequestManager();

    //SetupSessionTimer();

    mActivityNotification = new SumoActivityNotification('uActivityNotification', 'uMasterBody', 5000, { 'allowClose': false });
    mActivityNotification.render();
    var baseHtml= [
        '    <div class="FilterControl" id="##id##">',
        '    <div class="FilterControlHeader" id="##id##Header">##title##<div class="ArrowContainer Right" id="##id##Arrow"></div></div>',
        '    <div class="FilterControlExpander ##expandertype##" id="##id##Expander" style="z-index:9999999;">',
        '        <div class="FilterControlContent" id="##id##Content">##content##</div>',
        '        <div class="ButtonBar FilterButtonCommandBar" id="##id##ButtonBar">',
        '            <div class="ButtonCommandBar">',
        '                <div class="Button" id="##id##ResetButton"><span class="cLocalize cReset">Reset</span></div>',
        '                <div class="Button LargeIconButton ContinueButton" id="##id##FilterButton"><span class="cLocalize cFind">Find</span></div>',
        '            </div>',
        '        </div>',
        '    </div>',
        '</div>',
    ];
    gFilterFactory = new SumoControlFactory(
        'Scripts/Controls/',
        'FilterControl',
        null,
        baseHtml.join(''));

    //gPaginatorFactory = new SumoControlFactory(
    //    'Scripts/Controls/',
    //    'PaginatorControl',
    //    null);

    function xxx() {
        mIsNatural = false;
        $(window).resize();
    }

    //function yyy() {
    //    $(window).resize();
    //}

    function onResize(aEvent) {
        resetContentHolders();

        if (!isNullOrUndefined(aEvent.originalEvent)) {
            window.setTimeout(xxx, 2000);
        }

        //if (mIsNatural) {
        //    window.setTimeout(xxx, 2000);
        //} else {
        //    mIsNatural = true;
        //}
    }

    //$(window).resize(resetContentHolders);
    $(window).resize(onResize);
}

function systemGenerateStaticData() {
    "use strict";
    gMapSettings.push({ 'Id': 1, 'Description': localizeText('cZonesShowZones') });
    gMapSettings.push({ 'Id': 2, 'Description': localizeText('cEventLockStart') });
    gMapSettings.push({ 'Id': 3, 'Description': localizeText('cEnrolleeShowAddresses') });
    gMapSettings.push({ 'Id': 4, 'Description': localizeText('cEnrolleeShowConnectedTracks') });
    gMapSettings.push({ 'Id': 5, 'Description': localizeText('cEnrolleeShowNumberedLabels') });
    gMapSettings.push({ 'Id': 6, 'Description': localizeText('cEventShowEvents') });
    gMapSettings.push({ 'Id': 7, 'Description': localizeText('cEnrolleeGpsTracks') });
    gMapSettings.push({ 'Id': 8, 'Description': localizeText('cEnrolleeCellTowerPoints') });
    gMapSettings.push({ 'Id': 9, 'Description': localizeText('cEnrolleeWiFiPoints') });
    gMapSettings.push({ 'Id': 31, 'Description': localizeText('cEnrolleeEMACheckinPoints') });
    gMapSettings.push({ 'Id': 33, 'Description': localizeText('cEnrolleeBluHomeV4') });

    gMapFilterList.push({ 'Id': '1', 'Title': localizeText('cEnrolleeAddresses') });
    gMapFilterList.push({ 'Id': '2', 'Title': localizeText('cZones') });
    gMapFilterList.push({ 'Id': '3', 'Title': localizeText('cEnrolleeVisits') });
    gMapFilterList.push({ 'Id': '6', 'Title': localizeText('cEnrolleeVisitLabels') });
    gMapFilterList.push({ 'Id': '4', 'Title': localizeText('cEnrolleeVisitPoints') });
    //gMapFilterList.push({ 'Id': '99', 'Title': localizeText('cEnrolleeVisitAssociations') });
    gMapFilterList.push({ 'Id': '5', 'Title': localizeText('cEnrolleeTrackPoints') });
    gMapFilterList.push({ 'Id': '8', 'Title': localizeText('cEnrolleeCellTowers') });
    gMapFilterList.push({ 'Id': '9', 'Title': localizeText('cEnrolleeWiFi') });
    gMapFilterList.push({ 'Id': '31', 'Title': localizeText('cEnrolleeEMACheckIn') });
    gMapFilterList.push({ 'Id': '61', 'Title': localizeText('cStalkerAlertMobile') });
    gMapFilterList.push({ 'Id': '33', 'Title': localizeText('cEnrolleeBluHomeV4') });
    gMapFilterList.push({ 'Id': '10', 'Title': localizeText('cEnrolleeMapLabels') });
    gMapFilterList.push({ 'Id': '7', 'Title': localizeText('cEnrolleeConnectedTracks') });
    gMapFilterList.push({ 'Id': '21', 'Title': localizeText('cEnrolleeAlcoholTestPoints') });


    mRegexValidation['Email'] = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,9}$/;
    mRegexValidation['Phone'] = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
    mRegexValidation['Time'] = /^(0?[1-9]|1[012])(:[0-5]\d) [APap][mM]$/;
    mRegexValidation['Date'] = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
    mRegexValidation['Integer'] = /(^\s*\d+\s*$)|^(?![\s]+)$/;
    mRegexValidation['IsNumber'] = /^\d+(?:\.\d{1,2})?$/;
    mRegexValidation['PhoneExtension'] = /^[0-9]+[xX]?[0-9]+$/;
}

function systemData_Init() {
    "use strict";
    mCache = new Cache();
    //mStringStorage = new StringStorage();
    initializeAjax();
    gServiceUrlList = sessionStorage.getItem("veritracksservice");
    webServiceConnection_Init(-1);
}

function uMasterBody_OnLoad() {
    "use strict";
    // do not load any user data until 2fa is setup if required
    systemObject_Init();
    systemData_Init();
    // load essential cache items
    // enrollees
    // risk levels
}

function writeUserTranactionLoginInfo() {
    var lBrowserName = '',
        lBrowserVersion = '',
        lUserTransactionLogin = new UserTransactionLogin();

    if (!isNullOrUndefined(navigator.appCodeName)) {
        lBrowserName = get_browser();
    }
    if (!isNullOrUndefined(navigator.appVersion)) {
        lBrowserVersion = get_browser_version();
    }
    lUserTransactionLogin.BrowserName = lBrowserName;
    lUserTransactionLogin.BrowserVersion = lBrowserVersion;
    lUserTransactionLogin.UserId = gUserDetails.UserId;
    lUserTransactionLogin.OrganizationId = gUserDetails.OrganizationIds[0];
    // WriteSingle(lUserTransactionLogin, userTranactionLogin_OnComplete, userTranactionLogin_OnFailure, null, true);
}

function get_browser() {
    var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE';
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR\/(\d+)/)
        if (tem != null) { return 'Opera ' + tem[1]; }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) { M.splice(1, 1, tem[1]); }
    return M[0];
}

function get_browser_version() {
    var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return tem[1] || '';
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR\/(\d+)/)
        if (tem != null) { return 'Opera ' + tem[1]; }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) { M.splice(1, 1, tem[1]); }
    return M[1];
}

function userTranactionLogin_OnComplete() {
    "use strict"
}

function userTranactionLogin_OnFailure() {
    "use strict"
}

function countDistinct(aHash, aProperty) {
    "use strict";
    var lValueHash = [],
        lValue,
        lCount = 0,
        lItem,
        lKey;

    for (lKey in aHash) {
        if (aHash.hasOwnProperty(lKey)) {
            lItem = aHash[lKey];
            lValue = lValueHash[lItem[aProperty]];
            if (isNullOrUndefined(lValue) || !lValue) {
                lValueHash[lItem[aProperty]] = true;
                lCount++;
            }
        }
    }

    return lCount;
}

function applyUserPermissions(aPermissionIdCollection) {
    "use strict";
    var lPermissions = getDataItems('Permissions'),
        lPermission,
        lUserPermission,
        lValue,
        lItem,
        lKey;
    if (isNullOrUndefined(aPermissionIdCollection)) {
        throw ("aPermissionIdCollection cannot be null");
    }
    for (lKey in aPermissionIdCollection) {
        if (aPermissionIdCollection.hasOwnProperty(lKey)) {
            lItem = aPermissionIdCollection[lKey];
            lPermission = lPermissions[lItem];
            if (!isNullOrUndefined(lPermission)) {
                lUserPermission = gUserPermissions[lItem];
                if (!isNullOrUndefined(lUserPermission)) {
                    lValue = lUserPermission.Value;
                } else {
                    lValue = 0;
                }
                switch (lValue) {
                    case 0:
                        $('.' + lPermission.QueryBase).remove();
                        $('.' + lPermission.QueryBase.trim() + 'Write').remove();
                        break;
                    case 2:
                        //$('.' + lPermission.QueryBase).remove();
                        //$('.' + lPermission.QueryBase + 'Write').remove();
                        break;
                    case 1:
                    default:
                        //$('.' + lPermission.QueryBase).remove();
                        $('.' + lPermission.QueryBase.trim() + 'Write').remove();
                        break;
                }
            }
        }
    }
}

function CheckUserHasPermission(aPermissionId) {
    "use strict";
    var lIsValid = false;

    function isValid(aPermissionId) {
        var lIsValid = false,
            lPermission,
            lItem,
            lKey;
        lPermission = gUserPermissions[aPermissionId];
        if (!isNullOrUndefined(lPermission)) {
            lIsValid = (lPermission.Value !== 0);
        }

        return lIsValid;
    }

    lIsValid = isValid(aPermissionId);

    if (lIsValid > 0)
        lIsValid = true;
    else
        lIsValid = false;

    return lIsValid;
}

function applyUserPermissionsNavigation(aPageClass, aTabValue, aIsBreaking) {
    var lIsValid = true,
        lIsSubValid = true,
        lIsBreaking = true,
        lCount = aPageClass.length,
        lFailedNavigations = {},
        lHash = 'Error',
        lIndex = -1,
        lPermission,
        lItem,
        lKey;

    function isValid(aPageClass, aTabValue) {
        var lIsValid = false,
            lPermission,
            lItem,
            lKey;

        for (lKey in aPageClass) {
            if (aPageClass.hasOwnProperty(lKey)) {
                lItem = aPageClass[lKey];
                if (lItem.Name === aTabValue) {
                    lIndex = parseInt(lKey);
                    lPermission = gUserPermissions[lItem.PermissionId];
                    if (!isNullOrUndefined(lPermission)) {
                        lIsValid = (lPermission.Value !== 0);
                    }
                    break;
                }
            }
        }
        return lIsValid;
    }

    if (!isNullOrUndefined(aIsBreaking)) {
        lIsBreaking = aIsBreaking;
    }
    lIsValid = isValid(aPageClass, aTabValue);

    if (!lIsValid) {

        lIsSubValid = false;
        for (lKey in aPageClass) {
            if (aPageClass.hasOwnProperty(lKey)) {
                lItem = aPageClass[lKey];
                if (!lIsSubValid) {
                    lIsSubValid = isValid(aPageClass, lItem.Name);
                    if (lIsSubValid) {
                        lHash = lItem.Hash;
                        break;
                    }
                }
            }
        }
    }

    //if ((!lIsValid || !lIsSubValid) && !lIsBreaking) {
    //    window.location.hash = lHash;
    //}
    if (!lIsValid && (lIsBreaking || (lIsSubValid && lHash !== 'Error'))) {
        window.location.hash = lHash;
    }


    //    if (lIndex < (lCount - 1)) {
    //        lItem = aPageClass[lIndex + 1];
    //        lHash = lItem.Hash;
    //    } else if (lCount === 1) {
    //        lHash = '';
    //    } else {
    //        lItem = aPageClass[0];
    //        lHash = lItem.Hash;
    //    }
    //    window.location.hash = lHash;
    //}

    return lIsValid;
}




function getEventMasterTamperCanCloseEvent_OnSuccess(aParams, aData) {
    "use strict";
    var lElement = $('#' + aParams),
        lItem,
        lKey,
        lCanShow = false;

    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            lItem = aData[lKey];

            if (!isNullOrUndefined(lItem) && lItem.IsClosable) {
                lCanShow = true;
            }
        }
    }

    if (lCanShow) {
        lElement.show();
    }
}

function getEventMasterTamperCanCloseStatus(aEventIds, aElement) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lTypeName = "Veritracks.Core.MasterTamperEventCanClose, Veritracks.Core",
        lCount = 0,
        lIsBadData = false,
            lKey,
            lItem;
    if (!isNullOrUndefined(aEventIds)) {
        lCount = count(aEventIds);
        if (lCount > 0) {
            for (lKey in aEventIds) {
                if (aEventIds.hasOwnProperty(lKey)) {
                    lItem = aEventIds[lKey];
                    if (!isNullOrUndefined(lItem)) {
                        lBuilder.AddNewExpressionConditional('EventId', lItem, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.Or());
                    } else {
                        lIsBadData = true;
                    }
                }
            }
            if (!lIsBadData) {
                ReadMultiple(lTypeName, lBuilder.RootExpression, 0, getEventMasterTamperCanCloseEvent_OnSuccess, Sad, aElement, null, 0, false);
            }
        }
    }
}

function toggleNotesDropdown(aPrefix) {
    if ($('.NotesDefaultArrow').is(':visible')) {
        $('#u' + aPrefix + 'NotesDefaultArrow').removeClass('NotesDefaultArrow').addClass('NotesExpandedArrow');
    } else {
        $('#u' + aPrefix + 'NotesDefaultArrow').addClass('NotesDefaultArrow').removeClass('NotesExpandedArrow');
    }
}

veritracks.system.applyFilterState = function (aFilterPrefix, aIsEmptyList) {
    "use strict";
    if (aIsEmptyList) {
        $('.' + aFilterPrefix + 'EmptyListAvailable').show();
        $('.' + aFilterPrefix + 'EmptyListUnavailable').hide();
    } else {
        $('.' + aFilterPrefix + 'EmptyListAvailable').hide();
        $('.' + aFilterPrefix + 'EmptyListUnavailable').show();
    }
};

veritracks.system.applyControlState = function (aFilterPrefix, aControl) {
    "use strict";
    var lDataSource,
        lIsEmpty = true;

    if (!isNullOrUndefined(aControl)) {
        lDataSource = aControl.getDataSource();
        if (!isNullOrUndefined(lDataSource)) {
            lIsEmpty = (lDataSource.length === 0);
        }
    }
    veritracks.system.applyFilterState(aFilterPrefix, lIsEmpty);
};

//changes applied to debug mode
veritracks.system.screenResolution = function () {
    "use strict";
    var lWidth = $(window).width(),
        lHeight = $(window).height(),
        lIsValid = true,
        lHtml = [];

    lIsValid = (lHeight >= 630 && lWidth >= 1280);

    lHtml.push('<div>width: ');
    lHtml.push(lWidth);
    if (lWidth <= 1024) {
        lHtml.push('</div>');
        lHtml.push('<div style="color: pink;"> Ipad Mode');
    }
    lHtml.push('</div>');
    lHtml.push('<div>height: ');
    lHtml.push(lHeight);
    if (lHeight < 630) {
        lHtml.push('</div>');
        lHtml.push('<div style="color: pink;">minimum height: 630');
    }
    lHtml.push('</div>');
    lHtml.push('<div>is valid: ');
    lHtml.push(lIsValid.toString());
    lHtml.push('</div>');
    alert(lHtml.join(''));
    // 630, 1280
};

function noteManager_OnChange() {
    var lValue = $('#uAddNoteTextArea').val();
    lValue = $.trim(lValue);
    if (lValue.length > 0 && lValue.length <= 3000) {
        //$('#uAddNoteTextArea').addClass('ValidateNoteManagerError').removeClass('ValidateNoteManagerSuccess');
        $('#uAddNoteTextArea').addClass('ValidateSuccess').removeClass('ValidateError');
    } else {
        //$('#uAddNoteTextArea').removeClass('ValidateNoteManagerError').addClass('ValidateNoteManagerSuccess');
        $('#uAddNoteTextArea').removeClass('ValidateSuccess').addClass('ValidateError');

    }
}
/**
 * 
 * Show loading bar
 * @param {string} elementNameId A element id that loading bar will be 
 * by default #{elementNameId}
 */
function showLoadingBar(elementNameId) {
    // 
    $('#' + elementNameId).prepend('<div id="uLoadingBar' + elementNameId + '"" style="position: absolute; width: 100%; height: 100%;background: white; z-index: 1000;"><img id="uLoadingBar' + elementNameId + 'Img" style="display: inline-block;position:absolute;left:50%;top:50%;margin-left: -80px;margin-top: -80px;" src="Images/CircleLoader.gif" alt="Loading..."></div>')
}
/**
 * Hide loading bar from showLoadingBar(...)
 * @param {string} elementNameId A element id that loading bar that will be removed
 * by default #uLoadingBar{elementNameId}
 */
function hideLoadingBar(elementNameId) {
    $('#uLoadingBar' + elementNameId).remove();
}


function setLoadingBarStatus(aLoadingHolderId, aContentHolderId, aIsIndeterminate, aCallback) {
    if (aIsIndeterminate) {
        $('#' + aContentHolderId).hide('fast', function () {
            $('#' + aLoadingHolderId).show('fast', function () {
                if (!isNullOrUndefined(aCallback)) {
                    aCallback();
                }
            });
        });
    } else {
        //$('#' + aLoadingHolderId).hide('fast', function () {
        //    $('#' + aContentHolderId).show();
        //});
        $('#' + aLoadingHolderId).hide('fast', function () {
            $('#' + aContentHolderId).show('fast', function () {
                if (!isNullOrUndefined(aCallback)) {
                    aCallback();
                }
            });
        });
    }
}

function uListViewSort(aColumn) {
    alert('hello');
}
//function setLoadingBarStatus(aLoadingHolderId, aContentHolderId, aIsActive) {
//    if (aIsActive) {
//        $('#' + aContentHolderId).hide();
//        $('#' + aLoadingHolderId).show();
//    } else {
//        $('#' + aLoadingHolderId).hide();
//        $('#' + aContentHolderId).show();
//    }
//}












function uChangeOrganizationsContinueButton_OnClick() {
    "use strict";
    var isRegional = false;
    function onSuccess() {
        gChangeOrganizationsListView.dispose();
        gChangeOrganizationsListView = null;
        window.location.reload(false);
    }

    function onFailure() {
        gChangeOrganizationsListView.dispose();
        gChangeOrganizationsListView = null;
        ClosePopup();
    }

    var lToken = veritracks.security.controller.tryGetSecurityToken(),
        lSelected = gChangeOrganizationsListView.selectedDataItem(),
        lIds = [],
        lItem,
        lKey;
    for (lKey in lSelected) {
        if (lSelected.hasOwnProperty(lKey)) {
            lItem = lSelected[lKey];
            if (!isNullOrUndefined(lItem)) {
                if (lItem.TreeLevel <= mRegionalCutOff) {
                    isRegional = true;
                }
                lIds.push(lItem.Id);
            }
        }
    }
    // supporting new schema change feature
    if (!$('#uChangeOrganizationsListViewHolder').is(':hidden')) {
        if (lIds.length > 0) {
            callAjax('SetUserOrganizations', { 'aSecurityToken': lToken, 'aOrganizationIds': lIds, 'aRegionalOri': isRegional }, onSuccess, onFailure, null);
        } else {
            onFailure();
        }
    }
    //else {
    //    uChangeSchema_OnSave();
    //}
}

function uChangeSchema_OnSave() {
    "use strict";
    var lSchemaName = $('#uChangeSchema').val(),
        lToken = veritracks.security.controller.tryGetSecurityToken();
    // if ($.inArray(lSchemaName, sessionStorage.secondarySchemas.split(",")) === -1) {
    //    gServiceIndex = 0;
    // }
    // else {
    //    gServiceIndex = 1;
    // }
    //  sessionStorage.serviceUrlIdx = gServiceIndex;
    // var tokenList = sessionStorage.tokens.split(",");
    veritracks.security.controller.clearCookie('VeritracksAuthenticationToken');
    veritracks.security.controller.setCookie('VeritracksAuthenticationToken', lToken);
    //if (lToken !== tokenList[gServiceIndex] && tokenList.length > 1) {
    //    lToken = tokenList[gServiceIndex];
    //}

    function uChangeSchema_OnComplete(aParams, aData) {
        var lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('Id', 58, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.ClientSetting.AssemblyQualifiedName, lBuilder.RootExpression, 0, uSchemaClientSettingRead_Success, null, {}, null, 0, false);
        ReadMultiple(gObjectList.OriParent.AssemblyQualifiedName, null, 0, uSchemaParentOri_Success, null, {}, null, 0, false);
        //window.location.reload(false);
    }

    function uSchemaParentOri_Success(aParams, aData) {
        mParentOri = aData;
    }

    function uSchemaClientSettingRead_Success(aParams, aData) {
        "use strict";
        var lData = aData[0];
        if (!isNullOrUndefined(lData)) {
            mEnabledSuperOri = parseInt(lData.Value);
            mCurrentSuperOri = null;
        }
        callAjax('GetUserDetails', { 'aSecurityToken': lToken }, uAuthorizationTokenSchema_OnComplete, uChangeSchema_OnFailure, null);
    }

    function uAuthorizationTokenSchema_OnComplete(aParams, aData) {
        gUserDetails.CurrentSchema = aData.CurrentSchema;
        ReadMultiple(gObjectList.Organization.AssemblyQualifiedName, null, 0, onSuccess, null, aData.AvailableOrganizationIds, null, 0, false);
    }

    function onSuccess(aParams, aData) {
        var lBuilder = new SumoPredicateBuilder(),
            lSort = new SortExpression();

        lSort.addAscendingColumn('OriPath');
        gAvailableOrganizationIds = aParams;
        lBuilder.AddNewExpressionConditional('Id', gAvailableOrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        mOrganizations = query(aData, lBuilder.RootExpression);
        mOrganizations = lSort.sort(mOrganizations);
        //gChangeOrganizationsListView.setDataSource(mOrganizations);
        buildOriTree(null, mOrganizations);
        selectCurrentOrisTree(false);
    }

    function uChangeSchema_OnFailure() {
        gChangeOrganizationsListView.dispose();
        gChangeOrganizationsListView = null;
        ClosePopup();
    }
    callAjax('SetUserClientSchema', { 'aSecurityToken': lToken, 'aSchemaName': lSchemaName }, uChangeSchema_OnComplete, uChangeSchema_OnFailure, null);

}

function uChangeSchema_OnClick() {
    var lSchemaName = $('#uChangeSchema').val();

    if (!$('#uChangeSchemaButton').hasClass('SelectedButton')) {
        if (lSchemaName != gUserDetails.CurrentSchema.SchemaName) {
            //  $('#uChangeSchemaButton').hide();
            $('.PopupWindow .closeButton').hide();
        }
        else {
            $('.PopupWindow .closeButton').hide();
        }
        $('#uChangeSchemaButton').addClass('SelectedButton');
        uChangeSchema_OnSave();
    }
}
// NEW SUPER USER FEATURES
function setParentOri(aOrganizationList) {
    "use strict";
    var parentOri,
        lKey,
        previousOri,
        currentOri,
        lBuilder = new SumoPredicateBuilder();

    lBuilder.AddNewExpressionConditional('Id', aOrganizationList, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    if (isNullOrUndefined(mOrganizations)) {
        mOrganizations = getDataItems('Organizations');
    }
    if (ObjectLength(mOrganizations) > 0) {
        aOrganizationList = query(mOrganizations, lBuilder.RootExpression);
        // get first parent ori
        for (lKey in aOrganizationList) {
            if (aOrganizationList.hasOwnProperty(lKey)) {
                if (aOrganizationList[lKey].ParentOriFlag == 1) {
                    previousOri = aOrganizationList[lKey].Id;
                    break;
                }
            }
        }

        for (lKey in aOrganizationList) {
            if (aOrganizationList.hasOwnProperty(lKey)) {
                currentOri = aOrganizationList[lKey];
                if (currentOri.ParentOriFlag == 1) {
                    if (currentOri.Id < previousOri) {
                        previousOri = currentOri.Id;
                    }
                }
            }
        }

        lBuilder.AddNewExpressionConditional('Id', gUserDetails.AvailableOrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        var lData = query(mParentOri, lBuilder.RootExpression);
        lBuilder.Clear();

        lBuilder.AddNewExpressionConditional('Id', previousOri, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('ChildId', gUserDetails.AvailableOrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        var OriLength = query(lData, lBuilder.RootExpression);
        mChildCount = OriLength.length - 1;
        if (!isNullOrUndefined(previousOri)) {
            mCurrentSuperOri = previousOri;
        }
    }
}

function checkParentOriFlag(aValue) {
    "use strict";
    var lKey,
        lOrganization,
        lParentFlag;
    //lValue = aValue.value;

    for (lKey in mOrganizations) {
        if (mOrganizations.hasOwnProperty(lKey)) {
            lOrganization = mOrganizations[lKey];
            if (lOrganization.Id == aValue) {
                lParentFlag = lOrganization.ParentOriFlag;
            }
        }
    }
    return lParentFlag;
}

function ParentOriSelectedTree(aParentOri) {
    "use strict";
    var lParentOriId = aParentOri.value,
        lParentOriChecked = aParentOri.checked,
        lKey,
        lParent,
        lCheck,
        lCount = 0;

    if (!isNullOrUndefined(mParentOri)) {
        for (lKey in mParentOri) {
            if (mParentOri.hasOwnProperty(lKey)) {
                lParent = mParentOri[lKey];
                if (lParent.Id == lParentOriId) {
                    lCheck = '#uOrganizationSelect' + lParent.ChildId.toString();
                    $(lCheck).attr('checked', lParentOriChecked);
                    $(lCheck).attr('disabled', 'disabled');
                    lCount++;
                }
            }
        }
    }
    if ($('#uOrganizationSelect' + lParentOriId.toString()).prop('checked') == true) {
        mChildCount = $('.SuperUserOrganization:checked').filter(':disabled').length - 1;
    }
    else {
        mChildCount = 0;
    }
    disableCheckboxTree(lParentOriId, lParentOriChecked);

}

function disableCheckboxTree(lParentOriId, lParentOriChecked) {
    var lSelected = $('.SuperUserOrganization:checked'),
        lKey,
        lOrganization,
        lCheck;

    if (lParentOriChecked) {
        //   $('.SuperUserOrganization:checked').attr('disabled', 'disabled');
        for (lKey in mOrganizations) {
            if (mOrganizations.hasOwnProperty(lKey)) {
                lOrganization = mOrganizations[lKey];
                if (lOrganization.ParentOriFlag == 1) {
                    lCheck = '#uOrganizationSelect' + lOrganization.Id.toString();
                    $(lCheck).attr('disabled', 'disabled');
                }
            }
        }
        lCheck = '#uOrganizationSelect' + lParentOriId.toString();
        $(lCheck).removeAttr("disabled");
    }
    else {
        for (lKey in mOrganizations) {
            if (mOrganizations.hasOwnProperty(lKey)) {
                lOrganization = mOrganizations[lKey];
                lCheck = '#uOrganizationSelect' + lOrganization.Id.toString();
                $(lCheck).removeAttr('disabled');
            }
        }
    }
}
//to be removed?
function ParentOriSelected(aParentOri, isSelected) {
    "use strict";
    if (!isNullOrUndefined(aParentOri)) {
        var lBuilder = new SumoPredicateBuilder(),
            lKey,
            lParent,
            lDataSource,
            lNewDataSource,
            lData = [],
            lKey2,
            lCheck = [];

        lBuilder.AddNewExpressionConditional('Id', aParentOri, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lParent = query(mParentOri, lBuilder.RootExpression);
        for (lKey in lParent) {
            if (lParent.hasOwnProperty(lKey)) {
                lCheck.push(lParent[lKey].ChildId);
            }
        }
        if (isNullOrUndefined(lCheck.indexOf(aParentOri))) {
            lCheck.push(aParentOri);
        }

        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('Id', gAvailableOrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lDataSource = query(mOrganizations, lBuilder.RootExpression);
        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('Id', lCheck, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lNewDataSource = query(lDataSource, lBuilder.RootExpression);

        for (lKey in lNewDataSource) {
            if (lNewDataSource.hasOwnProperty(lKey)) {
                lData.push(lNewDataSource[lKey].Id);
            }
        }
        if (isSelected) {
            gChangeOrganizationsListView.selectChosen(lData);
            disableParentOri(aParentOri, lData);
            mChildCount = lData.length - 1;
        }
        else {
            // this is a hard coded thing since stopllc ori does not have a child ori with childid = 11
            if (aParentOri == 11) {
                lData.push(11);
            }
            if (isNullOrUndefined(mCurrentSuperOri)) {
                if (!isNullOrUndefined(gChangeOrganizationsListView.getDataSource())) {
                    gChangeOrganizationsListView.unSelect(lData);
                    gChangeOrganizationsListView.removeDisabled(null);
                }
                mChildCount = 0;
            }
        }
    }
}
//to be removed?
function disableParentOri(aParentOri, lCheck) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lNotSelectedParentOri = [],
        lKey,
        lTemp = [],
        lTemp2 = [],
        lTemp3 = [];

    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('Id', aParentOri, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('Id', lCheck, false, mRelationalOperatorEnum.NotIn(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('ChildId', lCheck, false, mRelationalOperatorEnum.NotIn(), mLogicalOperatorEnum.And());
    lTemp = query(mParentOri, lBuilder.RootExpression);

    for (lKey in lTemp) {
        if (lTemp.hasOwnProperty(lKey)) {
            lTemp2.push(lTemp[lKey].Id);
        }
    }
    lBuilder.Clear();

    lBuilder.AddNewExpressionConditional('Id', lTemp2, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('ParentOriFlag', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lTemp3 = query(mOrganizations, lBuilder.RootExpression);

    for (lKey in lTemp3) {
        if (lTemp3.hasOwnProperty(lKey)) {
            lNotSelectedParentOri.push(lTemp3[lKey].Id);
        }
    }
    gChangeOrganizationsListView.disable(lNotSelectedParentOri);
}

function ParentOriUnSelect(aParentOri) {
    var list = [];
    list.push(aParentOri);
    gChangeOrganizationsListView.unSelect(list);
    return true;
}
function checkChildOri(aChildOri) {
    var lBuilder = new SumoPredicateBuilder(),
        lOri,
        lCheck = [],
        lKey;

    lBuilder.AddNewExpressionConditional('ChildId', aChildOri, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('Id', mCurrentSuperOri, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lOri = query(mParentOri, lBuilder.RootExpression);
    if (!isNullOrUndefined(lOri)) {
        for (lKey in lOri) {
            if (lOri.hasOwnProperty(lKey)) {
                lCheck.push(lOri[lKey].ChildId);
            }
        }
        gChangeOrganizationsListView.selectChosen(lCheck);
    }

}

// END
//to be removed?
function uChangeOrganizationsListView_OnChange(aSender, aSelected, aParams) {
    "use strict";
    var lSelected = aSelected,
        lParentFlag,
        singleSelect,
        lSize = lSelected.length - 1,
        isSelected = false,
        isFalse = false,
        lunselectList = [];

    singleSelect = gChangeOrganizationsListView.getDeSelectedKey();
    if (isNullOrUndefined(singleSelect)) {
        isSelected = true;
        singleSelect = gChangeOrganizationsListView.getSelectedKey();
    }
    // need check here to see if different parent ori being selected
    //if ($('#uChangeSchema').val() == gUserDetails.CurrentSchema.Description) {
    if (mEnabledSuperOri) {
        lParentFlag = checkParentOriFlag(singleSelect);
        if (!isNullOrUndefined(mCurrentSuperOri)) {
            // if (isSelected) {
            if (lParentFlag && mCurrentSuperOri != singleSelect) {
                isFalse = ParentOriUnSelect(singleSelect);
            }
            //   }
            // else {
            // need check to see if deselecting child of mCurrentSuperOri (its not allowed)
            checkChildOri(singleSelect);
            //  }
        }
    }
    //  }

    if (!isFalse) {
        if (!isNullOrUndefined(lSelected) && lSelected.length - mChildCount > 5) {
            lSelected.splice(lSelected.indexOf(singleSelect), 1);
            gChangeOrganizationsListView.selected(lSelected);
        }
        else {
            if (mEnabledSuperOri) {
                if (lParentFlag) {
                    if (isSelected) {
                        mCurrentSuperOri = singleSelect;
                    }
                    else {
                        mCurrentSuperOri = null;
                    }
                    ParentOriSelected(singleSelect, isSelected);
                }
            }
        }
    }
}

function uChangeSchemaData() {
    "use strict";
    var lHtml = [],
        lSchemas = gUserDetails.AvailableSchemas,
        lCurrentSchema = gUserDetails.CurrentSchema,
        lKey;

    if (lSchemas.length > 1) {
        lHtml.push('<div style="display:block"id="uChangeSchemaHolder">');
        lHtml.push('<span>' + localizeWrapper('cAgentChangeSchema') + '</span>');
        lHtml.push('<select id="uChangeSchema" onchange="uChangeSchemaData_OnChange()">');
        for (lKey in lSchemas) {
            if (lSchemas.hasOwnProperty(lKey)) {
                if (lSchemas[lKey].Name == lCurrentSchema.SchemaName) {
                    lHtml.push('<option value="' + lSchemas[lKey].Name + '" selected="selected">' + lSchemas[lKey].Description + '</option>');
                }
                else {
                    lHtml.push('<option value="' + lSchemas[lKey].Name + '">' + lSchemas[lKey].Description + '</option>');
                }
            }
        }
        lHtml.push('</select>');
        lHtml.push('<div id="uChangeSchemaButton" style="float:right; margin-right:50px; display:inline;" class="Button Clickable SelectedButton" onclick="uChangeSchema_OnClick();">' + localizeWrapper('cAgentChange') + '</div>');
        lHtml.push('</div>');
    }
    return lHtml.join('');
}
function uChangeSchemaData_OnChange() {
    "use strict";
    var lSelectedSchema = $('#uChangeSchema').val();

    if (lSelectedSchema !== gUserDetails.CurrentSchema.SchemaName) {
        $('#uChangeSchemaButton').removeClass('SelectedButton');
    }
    else {
        $('#uChangeSchemaButton').addClass('SelectedButton');
    }
}

function uChangeOrganizations_OnClick() {
    "use strict";
    function onSuccess(aParams, aData) {
        mOrganizations = aData;
        gAvailableOrganizationIds = gUserDetails.AvailableOrganizationIds;
        setParentOri(gUserDetails.OrganizationIds);
        //gChangeOrganizationsListView.setDataSource(aData);
        //gChangeOrganizationsListView.selected(gUserDetails.OrganizationIds);
        if (mEnabledSuperOri && !isNullOrUndefined(mCurrentSuperOri)) {
            //disableParentOri(mCurrentSuperOri, gUserDetails.OrganizationIds);
        }
        else {
            mChildCount = 0;
        }

        buildOriTree(aParams, aData);
        selectCurrentOrisTree(true);
        $("#uChangeOrganizationPanelLoadingBar").remove();
        //  buildSearchBox();
    }

    var lButtonBar = GenerateButtonCommandBar(),
        lBuilder = new SumoPredicateBuilder(),
        lSort = new SortExpression(),
        lHtml = [],
        lSchemas = gUserDetails.AvailableSchemas;

    lSort.addAscendingColumn('OriPath');
    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeChange'), 'Continue', setChangeOrganizations));
    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeClose'), 'close', ClosePopup));
    lHtml.push('<div>');
    lHtml.push(uChangeSchemaData());
    lHtml.push(buildSearchBox());
    lHtml.push('<div id="uChangeOrganizationPanelLoadingBar" class="loadingGif" style="max-width:275px;"></div>');
    lHtml.push('<div id="uChangeOrganizationsListViewHolder" style="height: 250px;overflow: scroll; width:100%"></div></div>');
    DisplayPopup(localizeWrapper('cAgentChangeLogonDetails'), lHtml.join(''), lButtonBar, false);
    //if (!isNullOrUndefined(gChangeOrganizationsListView)) {
    //   gChangeOrganizationsListView.dispose();
    // }
    gChangeOrganizationsListView = new sumo.controls.ListView('uOrganizationHolder', 'uChangeOrganizationsListViewHolder', { 'keyField': 'Id', 'selectMethod': 'auto', 'cssClass': 'VeritracksSelectListView', 'canUnselect': true, 'showHeader': true }, [
        { 'id': 'Selection', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'formatMethod': selectionColumnFormatter },
            { 'id': 'Name', 'title': localizeWrapper('cEnrolleeName'), 'dataField': 'Name', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'formatMethod': null }
    ]);
    //gChangeOrganizationsListView.bind('selectedchanged', uChangeOrganizationsListView_OnChange);

    lBuilder.AddNewExpressionConditional('Id', gUserDetails.AvailableOrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.Organization.AssemblyQualifiedName, lBuilder.RootExpression, 0, onSuccess, null, {}, lSort, 0, false);
}

function showHideOriChildren(parent) {
    "use strict";

    var $children = $("#" + parent).children("ul");

    if ($("#link" + parent).hasClass("plusSignImage")) {
        $("#link" + parent).removeClass("plusSignImage");
        $("#link" + parent).addClass("subtractSignImage");
    } else if ($("#link" + parent).hasClass("subtractSignImage")) {
        $("#link" + parent).removeClass("subtractSignImage");
        $("#link" + parent).addClass("plusSignImage");
    } else {
        //this link is not a parent
    }

    $children.each(function (index) {
        if ($(this).hasClass("OriUlCommon")) {
            $(this).removeClass("OriUlCommon");
            $(this).addClass("OriUlCommonHide");
        } else {
            $(this).removeClass("OriUlCommonHide");
            $(this).addClass("OriUlCommon");
        }
    });


}

function buildOriTree(aParams, aData) {
    "use strict";
    var oriKeyList = [],
        loginOriList = [],
        lItem,
        lKey;

    gTreeControl = new VeritracksTreeDisplayController('uOrganizationHolder', { 'Overflow': true });

    mOrganizations = aData;
    gTreeControl.setDataSource(mOrganizations);
    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            lItem = aData[lKey];
            loginOriList.push(lItem);
            oriKeyList.push(lItem.Id);

        }
    }//end of for

    if (mEnabledSuperOri == 0) {
        gTreeControl.buildFlatTree(aData);
        return;
    }
    else {
        gTreeControl.buildGraphTree(loginOriList, oriKeyList);
    }


    $('.SuperUserOrganization').change(organization_OnChangeTree).change();
}

function selectCurrentOrisTree(aCurrent) {
    "use strict";
    var currentParent = [];
    for (var oriIndex in mParentOri) {
        if (!isNullOrUndefined(mParentOri[oriIndex].Id)) {
            if (gUserDetails.OrganizationIds.indexOf(mParentOri[oriIndex].ChildId) != -1 && currentParent.indexOf(mParentOri[oriIndex].Id) == -1) {
                currentParent.push(mParentOri[oriIndex].Id);
            }
        }
    }//end of for

    $("a[class~= 'openOriParent']").each(function (index) {
        this.onclick();
        var id = this.getAttribute("id").replace('link', '');
        id = +id;
        if (gUserDetails.OrganizationIds.indexOf(id) != -1 && aCurrent) {
            if (!$("#uOrganizationSelect" + id).prop('checked')) {
                $("#uOrganizationSelect" + id).click();
            }
        }
    });

}

function buildSearchBox() {
    var searchBoxHtml = '<div id="uOrganizationSearchHolder" class="loginSearchBoxWindow">' +
                        '<div class="Clickable FloatRight cancelChangeSearchButton" id="uOriClearButton" onclick="uClearOrganizations(true);"></div>' +
                        '<input type="text" class="searchBoxInit" id="uOrganizationsText" onkeyup="uSearchOrganizations();" onclick="uClickSearchBoxInit();" onfocus="uFocusSearchBoxInit();" value="' + localizeText('cInventoryFindOrganization') + '"/>' +
                    '</div>';

    return searchBoxHtml;
}



function uSearchOrganizations() {
    "use strict";
    var search = $("#uOrganizationsText").val();

    if (search == '') {
        uClearOrganizations(true);
        return;
    }

    //search global,ignore case
    var valueRegX = new RegExp(search, "gi");
    var foundCount = 0;
    var browser = window.navigator.userAgent;
    var matchedIndex = 0;
    //remove any previous searches
    uClearOrganizations(false);

    $("li[class|= 'OriLiCommon']").each(function (index) {
        var matchIndex;
        var labelText = $("label[for|='uOrganizationSelect" + this.getAttribute("id") + "']").text();

        matchIndex = labelText.search(valueRegX);
        //replace text with '<span class="Q">'
        if (matchIndex != -1) {
            var labelTextMatches = labelText.match(valueRegX);
            var newLabelText = "";
            var j = 0;
            while (j < labelText.length) {
                var matchedText = "";
                for (var i = 0; i < labelTextMatches.length; i++) {
                    if (labelText.substr(j, labelTextMatches[i].length) == labelTextMatches[i]) {
                        matchedText = '<span class="Q">' + labelTextMatches[i] + '</span>';
                        j = j + labelTextMatches[i].length;
                        break;
                    }
                }

                if (matchedText != "") {
                    newLabelText = newLabelText + matchedText;
                } else {
                    newLabelText = newLabelText + labelText[j];
                    j++;
                }

                matchedText = "";
            }
            matchedIndex = index;
            $("label[for|='uOrganizationSelect" + this.getAttribute("id") + "']").html(newLabelText);
            foundCount++;
            if ($("#link" + this.getAttribute("id")).hasClass("plusSignImage")) {
                $("#link" + this.getAttribute("id")).click();
            }
        } else {
            if ($("#link" + this.getAttribute("id")).hasClass("plusSignImage")) {
                $("#link" + this.getAttribute("id")).click();
            }
        }//end of if

    });

    if (foundCount > 0) {
        var matchId = $("li[class|= 'OriLiCommon']:eq(" + matchedIndex + ")")[0].id;
        $("#uOrganizationSelect" + matchId).focus();
    }
    $("#uOrganizationsText").focus();

}

function loadThread(title, graphId) {
    var lUrl = gServerList.threads + 'Threads/';
    var iFrameUrl = "<iframe src=" + lUrl + graphId + "/?userToken=";
    iFrameUrl += veritracks.security.controller.tryGetSecurityToken() + "\"></iframe>";

    DisplayPopup(title, iFrameUrl, null, false, true);
}

function uClearOrganizations(clearFlag) {
    "use strict";
    if (clearFlag) {
        $("#uOrganizationsText").val('');
    }
    var browser = window.navigator.userAgent;
    //remove any previous searches
    $("span[class|= 'Q']").each(function (index) {
        var currentSpanHtml = this.innerHTML;
        if (typeof this.parentNode != 'undefined' && this.parentNode != null) {

            if (browser.indexOf('MSIE') != -1) {
                $(this.parentElement).html(this.parentNode.innerText);
            } else {
                $(this.parentElement).html(this.parentNode.textContent);
            }

        }

    });


}

function uClickSearchBoxInit() {
    $("#uOrganizationsText").val('');
}

function uFocusSearchBoxInit() {
    if ($("#uOrganizationsText").val() == localizeText('cInventoryFindOrganization')) {
        $("#uOrganizationsText").val('');
    }
}

function uFocusOutInit() {
    if ($("#uOrganizationsText").val() == '') {
        $("#uOrganizationsText").val(localizeText('cInventoryFindOrganization'));
    }
}

function organization_OnChangeTree(aEvent) {
    "use strict";
    var lSelected = $('.SuperUserOrganization:checked'),
        lValue = { 'value': aEvent.target.defaultValue, 'checked': aEvent.target.checked },
        lItem,
        lKey,
        lParentFlag;

    lParentFlag = checkParentOriFlag(lValue.value);
    if (lSelected.length - mChildCount > 5) {
        var lItem = '#uOrganizationSelect' + aEvent.target.defaultValue.toString();
        $(lItem).attr('checked', false);
    }
    else {
        if (mEnabledSuperOri) {
            if (lParentFlag) {
                if (lValue.checked) {
                    mCurrentSuperOri = lValue.value;
                }
                else {
                    mCurrentSuperOri = null;
                }
                ParentOriSelectedTree(lValue);
            }
        }
    }

}

function setChangeOrganizations() {
    "use strict";
    var lSelected = $('.SuperUserOrganization:checked');

    if (lSelected.length > 0) {
        setChangeOrganizationFinal();
    }
}
function setChangeOrganizationFinal() {
    "use strict";

    var isRegional = false;

    function onSuccess() {
        gChangeOrganizationsListView.dispose();
        gChangeOrganizationsListView = null;
        window.location.reload(false);
    }

    function onFailure() {
        gChangeOrganizationsListView.dispose();
        gChangeOrganizationsListView = null;
        ClosePopup();
    }
    var lSelected = $('.SuperUserOrganization:checked'),
        lToken = veritracks.security.controller.tryGetSecurityToken(),
        lIds = [],
        lItem,
        lKey;
    if (gUserDetails.Role !== 2) {
        for (lKey = 0; lKey < lSelected.length; ++lKey) {
            lItem = lSelected[lKey];
            lIds.push($(lItem).val());
        }
    }
    else {
        if (gUserDetails.ExtendedOrganizationIds.length > 0) {
            lIds = gUserDetails.ExtendedOrganizationIds;
        }
    }

    //try to get cut off point
    if (mRegionalCutOff == 0) {
        mRegionalCutOff = veritracks.system.clientSetting('RegionalOriLimit');
    }

    for (lKey in mOrganizations) {
        lItem = mOrganizations[lKey];
        if (mOrganizations.hasOwnProperty(lKey)) {
            if (lIds.indexOf(lItem.Id.toString()) != -1 && lItem.TreeLevel <= mRegionalCutOff) {
                isRegional = true;
                break;
            }
        }
    }
    callAjax('SetUserOrganizations', { 'aSecurityToken': lToken, 'aOrganizationIds': lIds, 'aRegionalOri': isRegional }, onSuccess, onFailure, null);
}

function enhancedCrimeAnalystSupport() {
    "use strict";

    if (gUserDetails.Role == 2) {
        $('#uDashboardTab').hide();
        $('#uEventsTab').hide();
        $('#uZonesTab').hide();
        $('#uReportsTab').hide();
        $('#uInventoryTab').hide();
        $('#uAgentsTab').hide();
    }
}

function IsOriLimited() {
    "use strict";
    var lResult = false,
        lOrganizationLimit = veritracks.system.clientSetting('OrganizationDashboardLimit'),
        mRegionalCutOff = veritracks.system.clientSetting('RegionalOriLimit');

    //if (gUserDetails.CurrentSchema.SchemaName == 'CA1' && mEnabledSuperOri) {
    //    if (gUserDetails.OrganizationIds.indexOf(101) !== -1) {
    //        lResult = true;
    //    }
    //}
    //count(gUserDetails.OrganizationIds) >= lOrganizationLimit ||
    if (gUserDetails.RegionalOri) {
        lResult = true;
    }
    return lResult;
}
function TopLevelCDCRSupport() {
    "use strict";

    if (IsOriLimited()) {
        $('#uDashboardTab').hide();
        $('#uEventTab').addClass('regionalOri');
        $('#uZoneTab').addClass('regionalOri');
    }
}

function RedirectToEnrollees() {
    window.location.href = '#Enrollees.Offenders.Profile.Events';
}

function RedirecToSSOPath() {
    var queryString = window.location.search;   
    var urlParams = new URLSearchParams(queryString);
    var returnUrl = urlParams.get('uReturnPath');   

    if (!isNullOrUndefined(returnUrl) && returnUrl != '') {             
        window.location.href = '#' +  returnUrl;
    }
}

function isPasswordValid(password) {
    var isValid = false;
    var regex = '/^(?=(?:.*[a-z]){1})(?=(?:.*[A-Z]){1})(?=(?:.*\d){1})(?=(?:.*[!@#$%^&*-]){1}).{8,}$/';
    isValid = regex.exec(password);
    if (isValid) {
        return true;
    }
    else {
        return false;
    }
}

function convertStandardToMetric(distance, unit) {
    var conversionRate = 0,
        result = 0,
        measurement = new Unit();
    switch (unit) {
        case Unit.MEASURE.KILOMETER: {
            conversionRate = 0.62137;
            break;
        }
        case Unit.MEASURE.METER: {
            conversionRate = 3.2808
            break;
        }
    }

    if (isNaN(distance)) {
        return result;
    }
    else {
        return result = (distance / conversionRate);
    }
}



function convertLBSToKilograms(aWeight) {
    var conversionRate = 2.24046,
        result;
    if (isNaN(aWeight)) {
        result = aWeight;
    }
    else {
        result = Math.round(aWeight / conversionRate);
    }
    return result;
}

function convertKilogramsToLBS(aWeight) {
    var conversionRate = 2.24046,
        result;

    if (isNaN(aWeight)) {
        result = aWeight;
    }
    else {
        result = aWeight * conversionRate;
    }

    return result;
}

function displayMetricWeigthData(aWeigtht) {
    var lDoMetric =  parseInt(getUserPreferenceValue(13,'ShowMetric')),
        lResult;

    if (lDoMetric) {
        lResult = convertLBSToKilograms(aWeigtht);
    } else {
        lResult = aWeigtht;
    }

    return lResult;
}

function convertMilesToKilometers(aDistance) {
    var conversionRate = 0.62137,
        result;
    if (isNaN(aDistance)) {
        result = aDistance;
    }
    else {
        result = Math.round(aDistance / conversionRate);
    }
    return result;
}

function convertKilometersToMeters(aDistance) {
    return aDistance * 1000;
}

function convertMetersToFeet(aDistance) {
    var lDistance = aDistance * 3.2808;

    return Math.round(lDistance);
}

function convertFeetToMeters(aDistance) {
    var lDistance = aDistance / 3.2808;

    return Math.round(lDistance);
}

function getInformaticsEnabled(aEnrolleeOriId) {
    var lFeaturePreview = gUserPermissions[61];
    
    if (gUserDetails.OrganizationIds.indexOf(aEnrolleeOriId) == -1) {
        return false;
    }
    if (isNullOrUndefined(lFeaturePreview) && !isNullOrUndefined(aEnrolleeOriId)) {
        return checkOrganizationProperty(aEnrolleeOriId, "enable_informatics_icons") == 'Y';
    } 

    if (!isNullOrUndefined(aEnrolleeOriId)) {
        return ((lFeaturePreview.Value == 1 || lFeaturePreview.Value == 2) || checkOrganizationProperty(aEnrolleeOriId, "enable_informatics_icons") == 'Y');
    } else if (!isNullOrUndefined(lFeaturePreview)) {
        return lFeaturePreview.Value == 1 || lFeaturePreview.Value == 2;
    } else {
        return false;
    }
    
}


veritracks.system.data = {
    'clientSettings': {}
};

veritracks.system.encodeHtml = function (aHtml) {
    return $('<div/>').text(aHtml).html();
};

veritracks.system.decodeHtml = function (aHtml) {
    var txt = document.createElement("textarea");
    txt.innerHTML = aHtml;
    return txt.value;
};

//veritracks.system.logo_OnClick = function () {
//    function onComplete() {
//        veritracks.system.logout();
//    }
//    function onFailure() {
//        var l = '';
//    }
//    if (gSystemSettings.IsDebug) {
//        //$('#uVeritracksLogo').unbind();
//        alert('Refreshing the cache.');
//        gSystemSettings.IsDebug = false;
//        callAjax('RefreshTheCache', null, onComplete, onFailure, null, false);
//    }
//};

veritracks.system.clientSetting = function (aName) {
    var lResult = null,
        lSetting = veritracks.system.data.clientSettings[aName.toLowerCase()];

    if (!isNullOrUndefined(lSetting)) {
        lResult = lSetting.Value;
    }

    return lResult;
};

veritracks.system.help_OnClick = function () {
    "use strict";

};

veritracks.system.training_OnClick = function () {
    "use strict";
    window.open('https://secure.wistia.com/login');
};

veritracks.system.ContactUs_OnClick = function () {
    "use strict";
    var lButtonBar = GenerateButtonCommandBar(),
        lHtml = [];

    lHtml.push('<div id="uContactUs">');
    lHtml.push(localizeText('cAgentContactSolutionsCenter'))
    lHtml.push('</div>');
    DisplayPopup(localizeWrapper('cAgentContactUs'), lHtml.join(''), lButtonBar, false);
}
veritracks.system.formatData = function (aDataItem, aDataField, aDataTypeField) {
    var lValue = aDataItem[aDataField],
        lType = aDataItem[aDataTypeField];

    var dateFormats = [
         moment.ISO_8601,
         "MM/DD/YYYY",
         "MM-DD-YYYY HH:mm:ss",
         "MM/DD/YYYY HH:mm:ss",
         "DD-MMM-YYYY HH:mm:ss"
    ]
    if (!isNullOrUndefined(lValue)) {
        if (['true', 't', 'yes', 'y'].indexOf(lValue.toLowerCase()) !== -1) {
            lValue = true;
        } else if (['true', 't', 'yes', 'y'].indexOf(lValue.toLowerCase()) !== -1) {
            lValue = false;
        } else if (moment(lValue, dateFormats, true).isValid()) {
            lValue = moment(lValue)._d;
        } else if (lValue.indexOf(",") !== -1) {
            lValue = lValue;
        }
        else if (!isNaN(parseInt(lValue)) && parseInt(lValue) >= 0) {
            lValue = parseInt(lValue);
        }
    }

    aDataItem[aDataField] = lValue;
};

function get_browser() {
    var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE';
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR\/(\d+)/)
        if (tem != null) { return 'Opera ' + tem[1]; }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) { M.splice(1, 1, tem[1]); }
    return M[0];
}

function get_browser_version() {
    var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return tem[1] || '';
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR\/(\d+)/)
        if (tem != null) { return 'Opera ' + tem[1]; }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) { M.splice(1, 1, tem[1]); }
    return M[1];
}

function getPermutations(aLength, aGroup) {
    var numbers = factorial(aLength);
    var divisor = factorial(aLength - aGroup);

    return (numbers / divisor);
}

function factorial(num) {
    // If the number is less than 0, reject it.
    if (num < 0) {
        return -1;
    }
        // If the number is 0, its factorial is 1.
    else if (num == 0) {
        return 1;
    }
    var tmp = num;
    while (num-- > 2) {
        tmp *= num;
    }
    return tmp;
}

function isRetinaDisplay() {
    if (window.matchMedia) {
        var mq = window.matchMedia("only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)");
        return (mq && mq.matches || (window.devicePixelRatio > 1));
    }
}

function timezoneFormatter(aId) {
    "use strict";
    return dataItemFormatter('TimeZone', 'Name', 'EASTERN', aId);
}

function getUserRoleTypes(aUserId) {
    "use strict";
    var lUserRoles = getDataItems('UserRoles'),
        lBuilder = new SumoPredicateBuilder(),
        llUserRolesHash = 1,
        lItem,
        lKey;

    lBuilder.AddNewExpressionConditional('UserId', aUserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lUserRoles = query(lUserRoles, lBuilder.RootExpression);

    for (lKey in lUserRoles) {
        if (lUserRoles.hasOwnProperty(lKey)) {
            lItem = lUserRoles[lKey];
            llUserRolesHash = lItem.UserRoleValueTypeId;
        }
    }
    return llUserRolesHash;
}
function displayWeight(aWeight) {
    "use strict";
    var lWeight,
        lDoMetric =  parseInt(getUserPreferenceValue(13,'ShowMetric'));
    if (aWeight === 0) {
        lWeight = '';
    } else {
        if (lDoMetric) {
            lWeight = convertLBSToKilograms(parseInt(aWeight)) + ' ' + localizeText('cKilograms');
        } else {
            lWeight = aWeight + ' ' + localizeText('cPounds');
        }
    }
    return lWeight;
}
function displayHeight(aInches) {
    "use strict";
    var lInches = 0,
        lFeet = 0,
        lDoMetric =  parseInt(getUserPreferenceValue(13,'ShowMetric'));
    if (lDoMetric) {
        return convertInchesToCentimeters(aInches) + 'cm';
    }
    else {
        lFeet = Math.floor(aInches / 12);
        lInches = aInches - (lFeet * 12);
        return lFeet + "' " + lInches + '"';
    }
}
function findIncompleteItems() {
    "use strict";
    var i,
        hasCompleted = false;
    gItemsNotComplete = [];
    for (i = 0; i < gItemsInited.length; i++) {
        hasCompleted = (gItemsComplete.indexOf(gItemsInited[i]) !== -1) || (gItemsComplete.indexOf(gItemsInited[i] + "s") !== -1) || (gItemsComplete.indexOf(gItemsInited[i] + "es") !== -1);
        if (hasCompleted === false) {
            gItemsNotComplete.push(gItemsInited[i]);
        }
    }
    var l = '';
}

if (typeof String.prototype.trim !== 'function') { String.prototype.trim = function () { return this.replace(/^\s+|\s+$/g, ''); } }



// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function (predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return kValue.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue;
                }
                // e. Increase k by 1.
                k++;
            }

            // 7. Return undefined.
            return undefined;
        }
    });
}


if (!Array.prototype.filter) {
    Array.prototype.filter = function (fun/*, thisArg*/) {
        'use strict';

        if (this === void 0 || this === null) {
            throw new TypeError();
        }

        var t = Object(this);
        var len = t.length >>> 0;
        if (typeof fun !== 'function') {
            throw new TypeError();
        }

        var res = [];
        var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
        for (var i = 0; i < len; i++) {
            if (i in t) {
                var val = t[i];

                // NOTE: Technically this should Object.defineProperty at
                //       the next index, as push can be affected by
                //       properties on Object.prototype and Array.prototype.
                //       But that method's new, and collisions should be
                //       rare, so use the more-compatible alternative.
                if (fun.call(thisArg, val, i, t)) {
                    res.push(val);
                }
            }
        }

        return res;
    };
}

if (!Array.isArray) {
    Array.isArray = function (arg) {
        return Object.prototype.toString.call(arg) === '[object Array]';
    };
}

if (typeof Object.assign != 'function') {
    Object.assign = function (target, varArgs) { // .length of function is 2
        'use strict';
        if (target == null) { // TypeError if undefined or null
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
            var nextSource = arguments[index];

            if (nextSource != null) { // Skip over if undefined or null
                for (var nextKey in nextSource) {
                    // Avoid bugs when hasOwnProperty is shadowed
                    if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                        to[nextKey] = nextSource[nextKey];
                    }
                }
            }
        }
        return to;
    };
}

//if (typeof Object.values != 'function') {
Object.values = function (target) { // .length of function is 2
    'use strict';
    return Object.keys(target).map(function (key) {
        return target[key]
    });

};
//}

if (!String.prototype.includes) {
    String.prototype.includes = function (search, start) {
        'use strict';
        if (typeof start !== 'number') {
            start = 0;
        }

        if (start + search.length > this.length) {
            return false;
        } else {
            return this.indexOf(search, start) !== -1;
        }
    };
}

// https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
if (!Array.prototype.findIndex) {
    Object.defineProperty(Array.prototype, 'findIndex', {
        value: function (predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return k.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return k;
                }
                // e. Increase k by 1.
                k++;
            }

            // 7. Return -1.
            return -1;
        },
        configurable: true,
        writable: true
    });
}
function polyfill() {
    var ElementPrototype = window.Element.prototype;

    if (typeof ElementPrototype.matches !== 'function') {
        ElementPrototype.matches = ElementPrototype.msMatchesSelector || ElementPrototype.mozMatchesSelector || ElementPrototype.webkitMatchesSelector || function matches(selector) {
            var element = this;
            var elements = (element.document || element.ownerDocument).querySelectorAll(selector);
            var index = 0;

            while (elements[index] && elements[index] !== element) {
                ++index;
            }

            return Boolean(elements[index]);
        };
    }

    if (typeof ElementPrototype.closest !== 'function') {
        ElementPrototype.closest = function closest(selector) {
            var element = this;

            while (element && element.nodeType === 1) {
                if (element.matches(selector)) {
                    return element;
                }

                element = element.parentNode;
            }

            return null;
        };
    }
}


polyfill();// Extend IE Functionality
if (typeof URLSearchParams == 'undefined'){
    (function (w) {
        w.URLSearchParams = w.URLSearchParams || function (searchString) {
            var self = this;
            self.searchString = searchString;
            self.get = function (name) {
                var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(self.searchString);
                if (results == null) {
                    return null;
                }
                else {
                    return decodeURI(results[1]) || 0;
                }
            };
        }
    })(window);
}
veritracks.terminateLogging = function () {
    VeritracksTerminateEnrolleeLogging();
}


function getScheduleColor(aSchedule) {
    "use strict";
    var lType = '#d3d3d3',
        lReocurring = aSchedule.IsReocurring || aSchedule.IsRecurring,
        lZone;

    var displayOldUI = displayOldScheduleUILoggedInOri(aSchedule.EnrolleeId || mEnrolleesData.OffenderCurrentId)

    switch (aSchedule.TargetTypeId) {
        case 8:
            lType = lReocurring?'#FFFFFF' : 'gray';
            break;
        case 1:
            lZone = getDataItem(aSchedule.EntityId, 'Zones');
            if (!isNullOrUndefined(lZone)) {
                if (lZone.Type == 2) {
                    lType = (lReocurring ? '#d40000' : '#a10000');
                }
                else if (lZone.Type == 1) {
                    lType = (lReocurring ? '#55d400' : '#41a100');
                }
            } else {
                if (aSchedule.ZoneScheduleType == 2) {
                    lType = (lReocurring ? '#d40000' : '#a10000');
                }
                else if (aSchedule.ZoneScheduleType == 1) {
                    lType = (lReocurring ? '#55d400' : '#41a100');
                }
            }
            break;
        case 10:
            lType = lReocurring ? '#FFFFFF' : 'gray';
            break;
        case 2:
            lType = (lReocurring ? '#d97fd9' : '#6c3f6c');
            break;
        case 7:
            if (displayOldUI)
                lType = (lReocurring ? '#a19e99' : '#616161');
            else
                lType = lReocurring ? '#FFFFFF' : 'gray';
            break;
        case 3:
            lType = (lReocurring ? '#0094ff' : '#0068b3');
            break;
        case 9:
            lType = lReocurring ? '#FFFFFF' : 'gray';
            break;
        case 6:
            lType = (lReocurring ? '#6493f9' : '#3371f7');
            break;
    }

    if (aSchedule.TravelFlag) {
        lType = (lReocurring ? '#FFA500' : '#b27300');
    }

    return lType;
}

function getScheduleType(aScheduleType){
  var lCarveOutPreference = getCarveOutPreference();

  if(lCarveOutPreference){
    switch (aScheduleType){
      case 1:
        return 8;
    case 2:
        return 10;
      case 3:
        return 7;
    }
  }

  return aScheduleType;
}

function getTimeInScheduleType(aScheduleType) {
    switch (aScheduleType){
      case 8:
        return 1;
      case 10:
        return 2;
      case 7:
        return 3;
    }

    return aScheduleType;
}

function getTimeOutScheduleType(aScheduleType) {
    switch (aScheduleType) {
        case 1:
            return 8;
        case 2:
            return 10;
        case 3:
            return 7;
    }

    return aScheduleType;
}
function DayOfWeekIntEnum(aDayString) {
    var daysEnum = { SUNDAY: 7, MONDAY: 1, TUESDAY: 2, WEDNESDAY: 3, THURSDAY: 4, FRIDAY: 5, SATURDAY: 6 };
    if (aDayString) {
        for (var key in daysEnum) {
            if (key == aDayString) {
                return daysEnum[key];
            }
        }
    } 
    return daysEnum;
}
//This Function compare values from two objects
//e.g. IsObjectEqual(mEnrollees.EnrolleeAlternateContact,new EnrolleeAlternateContact)
function IsObjectEqual(aObject,bObject){
    for (lFieldKey in aObject) {
        if (aObject.hasOwnProperty(lFieldKey)) {
            if(bObject[lFieldKey] !== aObject[lFieldKey]){
                return false;
            }
        }
    }
    return true;
}
var EMAScheduleType={
    1:"Change",
    3:"Timeout",
    4:"Appointment",
};


/**
 * Function to download KML file
 * @param {*} lHtml Takes the HTML content to be converted as KML
 */
function downloadKMLFile(lHtml) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(lHtml));
    element.setAttribute('download', Date().toString()+"-map-export.kml");
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}

function disableDeviceAction(){
    $('.pInventoryDeviceAction').addClass("DisableButton")
    $('.pInventoryDeviceAction').click(function(e) {
        if ($(this).hasClass('DisableButton')) {
            e.preventDefault(); // Prevent default click action
            return false; // Stop event propagation
        } else {
            // Your onclick functionality here
            console.log('Div clicked and not disabled');
        }
    });
}

function enableDeviceAction(){
    $('.pInventoryDeviceAction').removeClass("DisableButton");
}


function getProductIdFromEnrolleeId(aEnrolleeId){
    var lDeviceAssignment = gCurrentDeviceAssignment[aEnrolleeId],lDevice=null;
    // return undefined;
    if(!isNullOrUndefined(lDeviceAssignment)){
        for (var lKey in lDeviceAssignment) {
            if (lDeviceAssignment.hasOwnProperty(lKey)) {
                lDevice = lDeviceAssignment[lKey];
            }
        }
        return lDevice.ProductId;
    }
}


/**
 * Updates the measurement unit displayed in the specified element. 
 * Based on Client Property 'ShowMetric'
 * @param {string} selector - Query selector for the elements to update metric.
 */
function updateMeasurementUnit(selector) {
    const unit =  parseInt(getUserPreferenceValue(13,'ShowMetric'))?' m.':' ft.';// imperial or Metric
    document.querySelectorAll(selector).forEach(element => {
        element.innerHTML = unit;
    });
}